// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../img/colors/transparent.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.8 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
    monospace;
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --breakpoint-sm: 40rem;
    --breakpoint-md: 48rem;
    --breakpoint-lg: 64rem;
    --breakpoint-xl: 80rem;
    --breakpoint-2xl: 96rem;
    --container-2xl: 42rem;
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-normal: 400;
    --font-weight-semibold: 600;
    --font-weight-bold: var(--weight-bold);
    --leading-tight: 1.25;
    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --font-size-heading-1: var(--text-heading-1);
    --font-size-body: var(--text-body);
    --font-weight-regular: var(--weight-regular);
    --color-background-brand-accent-fill-1: var(--color-background-brand-accent-fill-1);
    --color-background-brand-accent-fill-2: var(--color-background-brand-accent-fill-2);
    --color-background-brand-accent-fill-3: var(--color-background-brand-accent-fill-3);
    --color-background-brand-primary: var(--color-background-brand-primary);
    --color-background-brand-primary-hover: var(--color-background-brand-primary-hover);
    --color-background-brand-primary-focus: var(--color-background-brand-primary-focus);
    --color-background-brand-primary-pressed: var(--color-background-brand-primary-pressed);
    --color-background-brand-secondary: var(--color-background-brand-secondary);
    --color-background-brand-secondary-hover: var(--color-background-brand-secondary-hover);
    --color-background-brand-secondary-focus: var(--color-background-brand-secondary-focus);
    --color-background-brand-secondary-pressed: var(--color-background-brand-secondary-pressed);
    --color-background-canvas-canvas-primary: var(--color-background-canvas-canvas-primary);
    --color-background-canvas-canvas-secondary: var(--color-background-canvas-canvas-secondary);
    --color-background-feedback-danger-1: var(--color-background-feedback-danger-1);
    --color-background-feedback-danger-2: var(--color-background-feedback-danger-2);
    --color-background-feedback-info-1: var(--color-background-feedback-info-1);
    --color-background-feedback-info-2: var(--color-background-feedback-info-2);
    --color-background-feedback-promotion-1: var(--color-background-feedback-promotion-1);
    --color-background-feedback-promotion-2: var(--color-background-feedback-promotion-2);
    --color-background-feedback-success-1: var(--color-background-feedback-success-1);
    --color-background-feedback-success-2: var(--color-background-feedback-success-2);
    --color-background-feedback-warning-1: var(--color-background-feedback-warning-1);
    --color-background-feedback-warning-2: var(--color-background-feedback-warning-2);
    --color-background-surface-disabled: var(--color-background-surface-disabled);
    --color-background-surface-fill-1: var(--color-background-surface-fill-1);
    --color-background-surface-fill-2: var(--color-background-surface-fill-2);
    --color-background-surface-fill-3: var(--color-background-surface-fill-3);
    --color-background-surface-fill-4: var(--color-background-surface-fill-4);
    --color-background-surface-fill-5: var(--color-background-surface-fill-5);
    --color-background-surface-overlay: var(--color-background-surface-overlay);
    --color-border-brand-primary: var(--color-border-brand-primary);
    --color-border-brand-primary-hover: var(--color-border-brand-primary-hover);
    --color-border-brand-primary-focus: var(--color-border-brand-primary-focus);
    --color-border-brand-primary-pressed: var(--color-border-brand-primary-pressed);
    --color-border-neutral-border-1: var(--color-border-neutral-border-1);
    --color-border-neutral-border-2: var(--color-border-neutral-border-2);
    --color-border-neutral-border-3: var(--color-border-neutral-border-3);
    --color-border-neutral-border-4: var(--color-border-neutral-border-4);
    --color-border-neutral-border-5: var(--color-border-neutral-border-5);
    --color-border-neutral-disabled: var(--color-border-neutral-disabled);
    --color-border-utility-alignment-guide: var(--color-border-utility-alignment-guide);
    --color-icon-brand-primary: var(--color-icon-brand-primary);
    --color-icon-brand-primary-hover: var(--color-icon-brand-primary-hover);
    --color-icon-brand-primary-focus: var(--color-icon-brand-primary-focus);
    --color-icon-brand-primary-pressed: var(--color-icon-brand-primary-pressed);
    --color-icon-brand-secondary: var(--color-icon-brand-secondary);
    --color-icon-default-disabled: var(--color-icon-default-disabled);
    --color-icon-default-primary: var(--color-icon-default-primary);
    --color-icon-default-secondary: var(--color-icon-default-secondary);
    --color-icon-default-tertiary: var(--color-icon-default-tertiary);
    --color-icon-feedback-danger: var(--color-icon-feedback-danger);
    --color-icon-feedback-info: var(--color-icon-feedback-info);
    --color-icon-feedback-success: var(--color-icon-feedback-success);
    --color-icon-feedback-warning: var(--color-icon-feedback-warning);
    --color-text-brand-primary: var(--color-text-brand-primary);
    --color-text-brand-primary-hover: var(--color-text-brand-primary-hover);
    --color-text-brand-primary-focus: var(--color-text-brand-primary-focus);
    --color-text-brand-primary-pressed: var(--color-text-brand-primary-pressed);
    --color-text-brand-secondary: var(--color-text-brand-secondary);
    --color-text-default-disabled: var(--color-text-default-disabled);
    --color-text-default-primary: var(--color-text-default-primary);
    --color-text-default-secondary: var(--color-text-default-secondary);
    --color-text-default-tertiary: var(--color-text-default-tertiary);
    --color-text-feedback-danger: var(--color-text-feedback-danger);
    --color-text-feedback-info: var(--color-text-feedback-info);
    --color-text-feedback-success: var(--color-text-feedback-success);
    --color-text-feedback-warning: var(--color-text-feedback-warning);
    --color-utilities-elevation-drop-shadow-lg: var(--color-utilities-elevation-drop-shadow-lg);
    --color-utilities-elevation-drop-shadow-md: var(--color-utilities-elevation-drop-shadow-md);
    --color-utilities-elevation-drop-shadow-sm: var(--color-utilities-elevation-drop-shadow-sm);
    --color-utilities-elevation-drop-shadow-xs: var(--color-utilities-elevation-drop-shadow-xs);
    --color-utilities-elevation-inner-shadow: var(--color-utilities-elevation-inner-shadow);
    --color-utilities-material-fills-overlay: var(--color-utilities-material-fills-overlay);
    --radius-control: var(--radius-control);
    --radius-surface: var(--radius-surface);
    --radius-overlay: var(--radius-overlay);
    --shadow-raised: var(--shadow-raised);
    --shadow-floating: var(--shadow-floating);
    --shadow-overlay: var(--shadow-overlay);
    --shadow-inverse: var(--shadow-inverse);
    --ease-standard: var(--ease-standard);
    --ease-emphasized: var(--ease-emphasized);
    --ease-decelerate: var(--ease-decelerate);
    --ease-accelerate: var(--ease-accelerate);
    --ease-linear: var(--ease-linear);
  }
}
@layer utilities {
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .inset-x-0 {
    inset-inline: calc(var(--spacing) * 0);
  }
  .inset-x-12 {
    inset-inline: calc(var(--spacing) * 12);
  }
  .inset-y-space-2xs {
    inset-block: var(--space-2xs);
  }
  .-top-2 {
    top: calc(var(--spacing) * -2);
  }
  .top-\\(--editor-interactive-view-snap-position\\) {
    top: var(--editor-interactive-view-snap-position);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1 {
    top: calc(var(--spacing) * 1);
  }
  .top-1\\/2 {
    top: calc(1/2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .top-8 {
    top: calc(var(--spacing) * 8);
  }
  .top-56 {
    top: calc(var(--spacing) * 56);
  }
  .top-\\[-9999px\\] {
    top: -9999px;
  }
  .top-\\[549px\\] {
    top: 549px;
  }
  .-right-3 {
    right: calc(var(--spacing) * -3);
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-1 {
    right: calc(var(--spacing) * 1);
  }
  .right-1\\/2 {
    right: calc(1/2 * 100%);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .right-8 {
    right: calc(var(--spacing) * 8);
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-1 {
    bottom: calc(var(--spacing) * 1);
  }
  .bottom-4 {
    bottom: calc(var(--spacing) * 4);
  }
  .bottom-7\\.5 {
    bottom: calc(var(--spacing) * 7.5);
  }
  .bottom-8 {
    bottom: calc(var(--spacing) * 8);
  }
  .bottom-12 {
    bottom: calc(var(--spacing) * 12);
  }
  .bottom-15 {
    bottom: calc(var(--spacing) * 15);
  }
  .left-\\(--editor-interactive-view-snap-position\\) {
    left: var(--editor-interactive-view-snap-position);
  }
  .left-\\(--slider-position\\) {
    left: var(--slider-position);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-1 {
    left: calc(var(--spacing) * 1);
  }
  .left-1\\/2 {
    left: calc(1/2 * 100%);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .left-3 {
    left: calc(var(--spacing) * 3);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .left-space-2xs {
    left: var(--space-2xs);
  }
  .isolate {
    isolation: isolate;
  }
  .z-\\(--dialog-z-index\\) {
    z-index: var(--dialog-z-index);
  }
  .z-0 {
    z-index: 0;
  }
  .z-1 {
    z-index: 1;
  }
  .z-2 {
    z-index: 2;
  }
  .z-3 {
    z-index: 3;
  }
  .z-4 {
    z-index: 4;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-40 {
    z-index: 40;
  }
  .z-\\[2\\] {
    z-index: 2;
  }
  .z-base {
    z-index: var(--z-base);
  }
  .z-dropdown {
    z-index: var(--z-dropdown);
  }
  .z-modal {
    z-index: var(--z-modal);
  }
  .z-modal-backdrop {
    z-index: var(--z-modal-backdrop);
  }
  .z-overlay {
    z-index: var(--z-overlay);
  }
  .z-popover {
    z-index: var(--z-popover);
  }
  .z-raised {
    z-index: var(--z-raised);
  }
  .z-sticky {
    z-index: var(--z-sticky);
  }
  .z-toast {
    z-index: var(--z-toast);
  }
  .z-tooltip {
    z-index: var(--z-tooltip);
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-5 {
    grid-column: span 5 / span 5;
  }
  .col-span-full {
    grid-column: 1 / -1;
  }
  .col-start-1 {
    grid-column-start: 1;
  }
  .col-start-3 {
    grid-column-start: 3;
  }
  .row-start-1 {
    grid-row-start: 1;
  }
  .row-start-2 {
    grid-row-start: 2;
  }
  .container {
    width: 100%;
  }
  @media (width >= 40rem) {
    .container {
      max-width: 40rem;
    }
  }
  @media (width >= 48rem) {
    .container {
      max-width: 48rem;
    }
  }
  @media (width >= 64rem) {
    .container {
      max-width: 64rem;
    }
  }
  @media (width >= 80rem) {
    .container {
      max-width: 80rem;
    }
  }
  @media (width >= 96rem) {
    .container {
      max-width: 96rem;
    }
  }
  .divider-horizontal {
    border-color: var(--divider-color, var(--neutral2-separator-and-divider));
    border-style: solid;
    border-width: 0;
    border-top-width: var(--divider-width, 1px);
    height: 0;
    margin: var(--divider-gap, calc(var(--spacing) * 2)) 0;
    width: var(--divider-size, calc(var(--spacing) * 5));
  }
  .divider-vertical {
    border-color: var(--divider-color, var(--neutral2-separator-and-divider));
    border-style: solid;
    border-width: 0;
    border-left-width: var(--divider-width, 1px);
    height: var(--divider-size, calc(var(--spacing) * 5));
    margin: 0 var(--divider-gap, calc(var(--spacing) * 2));
    width: 0;
  }
  .\\!m-0 {
    margin: calc(var(--spacing) * 0) !important;
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .m-2\\.5 {
    margin: calc(var(--spacing) * 2.5);
  }
  .m-\\[16px\\] {
    margin: 16px;
  }
  .m-auto {
    margin: auto;
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-16 {
    margin-inline: calc(var(--spacing) * 16);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .mx-space-lg {
    margin-inline: var(--space-lg);
  }
  .my-0 {
    margin-block: calc(var(--spacing) * 0);
  }
  .my-6 {
    margin-block: calc(var(--spacing) * 6);
  }
  .my-8 {
    margin-block: calc(var(--spacing) * 8);
  }
  .my-11 {
    margin-block: calc(var(--spacing) * 11);
  }
  .my-13 {
    margin-block: calc(var(--spacing) * 13);
  }
  .my-space-md {
    margin-block: var(--space-md);
  }
  .-mt-\\[102px\\] {
    margin-top: calc(102px * -1);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-3\\.5 {
    margin-top: calc(var(--spacing) * 3.5);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-7 {
    margin-top: calc(var(--spacing) * 7);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-14 {
    margin-top: calc(var(--spacing) * 14);
  }
  .mt-16 {
    margin-top: calc(var(--spacing) * 16);
  }
  .mt-18 {
    margin-top: calc(var(--spacing) * 18);
  }
  .mt-50\\.5 {
    margin-top: calc(var(--spacing) * 50.5);
  }
  .mt-59\\.5 {
    margin-top: calc(var(--spacing) * 59.5);
  }
  .mt-64 {
    margin-top: calc(var(--spacing) * 64);
  }
  .mt-82\\.5 {
    margin-top: calc(var(--spacing) * 82.5);
  }
  .mt-\\[8px\\] {
    margin-top: 8px;
  }
  .mt-\\[12px\\] {
    margin-top: 12px;
  }
  .mt-\\[238px\\] {
    margin-top: 238px;
  }
  .mt-auto {
    margin-top: auto;
  }
  .mt-space-2md {
    margin-top: var(--space-2md);
  }
  .mt-space-2xl {
    margin-top: var(--space-2xl);
  }
  .mt-space-lg {
    margin-top: var(--space-lg);
  }
  .mt-space-md {
    margin-top: var(--space-md);
  }
  .mr-24 {
    margin-right: calc(var(--spacing) * 24);
  }
  .mr-auto {
    margin-right: auto;
  }
  .mr-space-md {
    margin-right: var(--space-md);
  }
  .-mb-px {
    margin-bottom: -1px;
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-9 {
    margin-bottom: calc(var(--spacing) * 9);
  }
  .mb-14 {
    margin-bottom: calc(var(--spacing) * 14);
  }
  .mb-14\\.5 {
    margin-bottom: calc(var(--spacing) * 14.5);
  }
  .mb-\\[30px\\] {
    margin-bottom: 30px;
  }
  .mb-auto {
    margin-bottom: auto;
  }
  .mb-space-md {
    margin-bottom: var(--space-md);
  }
  .ml-0 {
    margin-left: calc(var(--spacing) * 0);
  }
  .ml-5\\.5 {
    margin-left: calc(var(--spacing) * 5.5);
  }
  .ml-6 {
    margin-left: calc(var(--spacing) * 6);
  }
  .ml-30\\.5 {
    margin-left: calc(var(--spacing) * 30.5);
  }
  .ml-auto {
    margin-left: auto;
  }
  .box-border {
    box-sizing: border-box;
  }
  .\\!flex {
    display: flex !important;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .flow-root {
    display: flow-root;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .inline-grid {
    display: inline-grid;
  }
  .table {
    display: table;
  }
  .aspect-\\[2\\/2\\.25\\] {
    aspect-ratio: 2/2.25;
  }
  .aspect-\\[5\\/4\\] {
    aspect-ratio: 5/4;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .size-\\(--spinner-size\\) {
    width: var(--spinner-size);
    height: var(--spinner-size);
  }
  .size-\\(--vector-color-size\\) {
    width: var(--vector-color-size);
    height: var(--vector-color-size);
  }
  .size-0 {
    width: calc(var(--spacing) * 0);
    height: calc(var(--spacing) * 0);
  }
  .size-4 {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .size-4\\.5 {
    width: calc(var(--spacing) * 4.5);
    height: calc(var(--spacing) * 4.5);
  }
  .size-5 {
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
  }
  .size-5\\.5 {
    width: calc(var(--spacing) * 5.5);
    height: calc(var(--spacing) * 5.5);
  }
  .size-6 {
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
  }
  .size-7 {
    width: calc(var(--spacing) * 7);
    height: calc(var(--spacing) * 7);
  }
  .size-8 {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .size-9 {
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
  }
  .size-10 {
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
  }
  .size-14 {
    width: calc(var(--spacing) * 14);
    height: calc(var(--spacing) * 14);
  }
  .size-16 {
    width: calc(var(--spacing) * 16);
    height: calc(var(--spacing) * 16);
  }
  .size-18 {
    width: calc(var(--spacing) * 18);
    height: calc(var(--spacing) * 18);
  }
  .size-22\\.5 {
    width: calc(var(--spacing) * 22.5);
    height: calc(var(--spacing) * 22.5);
  }
  .size-24 {
    width: calc(var(--spacing) * 24);
    height: calc(var(--spacing) * 24);
  }
  .size-25 {
    width: calc(var(--spacing) * 25);
    height: calc(var(--spacing) * 25);
  }
  .size-30 {
    width: calc(var(--spacing) * 30);
    height: calc(var(--spacing) * 30);
  }
  .size-31 {
    width: calc(var(--spacing) * 31);
    height: calc(var(--spacing) * 31);
  }
  .size-32 {
    width: calc(var(--spacing) * 32);
    height: calc(var(--spacing) * 32);
  }
  .size-55 {
    width: calc(var(--spacing) * 55);
    height: calc(var(--spacing) * 55);
  }
  .size-56 {
    width: calc(var(--spacing) * 56);
    height: calc(var(--spacing) * 56);
  }
  .size-121\\.5 {
    width: calc(var(--spacing) * 121.5);
    height: calc(var(--spacing) * 121.5);
  }
  .size-141\\.5 {
    width: calc(var(--spacing) * 141.5);
    height: calc(var(--spacing) * 141.5);
  }
  .size-196\\.75 {
    width: calc(var(--spacing) * 196.75);
    height: calc(var(--spacing) * 196.75);
  }
  .size-\\[20px\\] {
    width: 20px;
    height: 20px;
  }
  .size-\\[50px\\] {
    width: 50px;
    height: 50px;
  }
  .size-\\[861px\\] {
    width: 861px;
    height: 861px;
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .size-px {
    width: 1px;
    height: 1px;
  }
  .size-space-lg {
    width: var(--space-lg);
    height: var(--space-lg);
  }
  .\\!h-full {
    height: 100% !important;
  }
  .h-\\(--border-height\\) {
    height: var(--border-height);
  }
  .h-\\(--canvas-height\\) {
    height: var(--canvas-height);
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\/2 {
    height: calc(1/2 * 100%);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-5\\.5 {
    height: calc(var(--spacing) * 5.5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7\\.75 {
    height: calc(var(--spacing) * 7.75);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-9\\.5 {
    height: calc(var(--spacing) * 9.5);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-15 {
    height: calc(var(--spacing) * 15);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-17\\.5 {
    height: calc(var(--spacing) * 17.5);
  }
  .h-18 {
    height: calc(var(--spacing) * 18);
  }
  .h-18\\.5\\! {
    height: calc(var(--spacing) * 18.5) !important;
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-25 {
    height: calc(var(--spacing) * 25);
  }
  .h-31\\.25 {
    height: calc(var(--spacing) * 31.25);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-33 {
    height: calc(var(--spacing) * 33);
  }
  .h-37\\.5 {
    height: calc(var(--spacing) * 37.5);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-48 {
    height: calc(var(--spacing) * 48);
  }
  .h-48\\.75 {
    height: calc(var(--spacing) * 48.75);
  }
  .h-60 {
    height: calc(var(--spacing) * 60);
  }
  .h-100 {
    height: calc(var(--spacing) * 100);
  }
  .h-109 {
    height: calc(var(--spacing) * 109);
  }
  .h-130 {
    height: calc(var(--spacing) * 130);
  }
  .h-139 {
    height: calc(var(--spacing) * 139);
  }
  .h-189\\.5 {
    height: calc(var(--spacing) * 189.5);
  }
  .h-201 {
    height: calc(var(--spacing) * 201);
  }
  .h-213\\.5 {
    height: calc(var(--spacing) * 213.5);
  }
  .h-243\\.5 {
    height: calc(var(--spacing) * 243.5);
  }
  .h-280 {
    height: calc(var(--spacing) * 280);
  }
  .h-\\[1px\\] {
    height: 1px;
  }
  .h-\\[14px\\] {
    height: 14px;
  }
  .h-\\[18px\\] {
    height: 18px;
  }
  .h-\\[22px\\] {
    height: 22px;
  }
  .h-\\[70vh\\] {
    height: 70vh;
  }
  .h-\\[72px\\] {
    height: 72px;
  }
  .h-\\[88px\\] {
    height: 88px;
  }
  .h-\\[100dvh\\] {
    height: 100dvh;
  }
  .h-\\[124px\\] {
    height: 124px;
  }
  .h-\\[160px\\] {
    height: 160px;
  }
  .h-\\[420px\\] {
    height: 420px;
  }
  .h-\\[624px\\] {
    height: 624px;
  }
  .h-\\[calc\\(\\.\\.\\.\\)\\] {
    height: calc(...);
  }
  .h-\\[var\\(--switch-box-handle-size\\)\\] {
    height: var(--switch-box-handle-size);
  }
  .h-\\[var\\(--switch-box-height\\)\\] {
    height: var(--switch-box-height);
  }
  .h-auto {
    height: auto;
  }
  .h-auto\\! {
    height: auto !important;
  }
  .h-control-lg {
    height: var(--size-control-lg);
  }
  .h-control-md {
    height: var(--size-control-md);
  }
  .h-control-sm {
    height: var(--size-control-sm);
  }
  .h-dvh {
    height: 100dvh;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .h-screen {
    height: 100vh;
  }
  .h-svh {
    height: 100svh;
  }
  .\\!max-h-full {
    max-height: 100% !important;
  }
  .max-h-\\(--page-pair-max-height\\) {
    max-height: var(--page-pair-max-height);
  }
  .max-h-9 {
    max-height: calc(var(--spacing) * 9);
  }
  .max-h-25 {
    max-height: calc(var(--spacing) * 25);
  }
  .max-h-40 {
    max-height: calc(var(--spacing) * 40);
  }
  .max-h-55 {
    max-height: calc(var(--spacing) * 55);
  }
  .max-h-62\\.5 {
    max-height: calc(var(--spacing) * 62.5);
  }
  .max-h-\\[70vh\\] {
    max-height: 70vh;
  }
  .max-h-\\[80\\%\\] {
    max-height: 80%;
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh;
  }
  .max-h-\\[100dvh\\] {
    max-height: 100dvh;
  }
  .max-h-\\[220px\\] {
    max-height: 220px;
  }
  .max-h-\\[250px\\] {
    max-height: 250px;
  }
  .max-h-\\[inherit\\] {
    max-height: inherit;
  }
  .max-h-\\[min\\(62dvh\\,455px\\)\\] {
    max-height: min(62dvh, 455px);
  }
  .max-h-full {
    max-height: 100%;
  }
  .max-h-none\\! {
    max-height: none !important;
  }
  .max-h-screen {
    max-height: 100vh;
  }
  .icon-hit-area-min {
    min-width: var(--icon-hit-area-min);
    min-height: var(--icon-hit-area-min);
  }
  .icon-hit-area-recommended {
    min-width: var(--icon-hit-area-recommended);
    min-height: var(--icon-hit-area-recommended);
  }
  .\\!min-h-0 {
    min-height: calc(var(--spacing) * 0) !important;
  }
  .\\!min-h-\\[94px\\] {
    min-height: 94px !important;
  }
  .min-h-\\(--app-height\\) {
    min-height: var(--app-height);
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0);
  }
  .min-h-10 {
    min-height: calc(var(--spacing) * 10);
  }
  .min-h-12 {
    min-height: calc(var(--spacing) * 12);
  }
  .min-h-16 {
    min-height: calc(var(--spacing) * 16);
  }
  .min-h-\\[20px\\] {
    min-height: 20px;
  }
  .min-h-\\[70vh\\] {
    min-height: 70vh;
  }
  .min-h-\\[250px\\] {
    min-height: 250px;
  }
  .min-h-\\[400px\\] {
    min-height: 400px;
  }
  .min-h-control-lg {
    min-height: var(--size-control-lg);
  }
  .min-h-control-md {
    min-height: var(--size-control-md);
  }
  .min-h-control-sm {
    min-height: var(--size-control-sm);
  }
  .min-h-dvh {
    min-height: 100dvh;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-\\(--canvas-width\\) {
    width: var(--canvas-width);
  }
  .w-\\(--size-control-lg\\) {
    width: var(--size-control-lg);
  }
  .w-\\(--size-control-md\\) {
    width: var(--size-control-md);
  }
  .w-\\(--size-control-sm\\) {
    width: var(--size-control-sm);
  }
  .w-1\\/2 {
    width: calc(1/2 * 100%);
  }
  .w-2\\/3 {
    width: calc(2/3 * 100%);
  }
  .w-2\\/5 {
    width: calc(2/5 * 100%);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11\\/12 {
    width: calc(11/12 * 100%);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-16\\.5 {
    width: calc(var(--spacing) * 16.5);
  }
  .w-17\\.5 {
    width: calc(var(--spacing) * 17.5);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-28 {
    width: calc(var(--spacing) * 28);
  }
  .w-28\\.75 {
    width: calc(var(--spacing) * 28.75);
  }
  .w-33\\.25 {
    width: calc(var(--spacing) * 33.25);
  }
  .w-34\\.75 {
    width: calc(var(--spacing) * 34.75);
  }
  .w-35 {
    width: calc(var(--spacing) * 35);
  }
  .w-37 {
    width: calc(var(--spacing) * 37);
  }
  .w-38 {
    width: calc(var(--spacing) * 38);
  }
  .w-47\\.5 {
    width: calc(var(--spacing) * 47.5);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-57 {
    width: calc(var(--spacing) * 57);
  }
  .w-57\\.5 {
    width: calc(var(--spacing) * 57.5);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-75\\.25 {
    width: calc(var(--spacing) * 75.25);
  }
  .w-80 {
    width: calc(var(--spacing) * 80);
  }
  .w-84 {
    width: calc(var(--spacing) * 84);
  }
  .w-87\\.5 {
    width: calc(var(--spacing) * 87.5);
  }
  .w-89\\.5 {
    width: calc(var(--spacing) * 89.5);
  }
  .w-90 {
    width: calc(var(--spacing) * 90);
  }
  .w-112 {
    width: calc(var(--spacing) * 112);
  }
  .w-117\\.25 {
    width: calc(var(--spacing) * 117.25);
  }
  .w-135 {
    width: calc(var(--spacing) * 135);
  }
  .w-144 {
    width: calc(var(--spacing) * 144);
  }
  .w-146 {
    width: calc(var(--spacing) * 146);
  }
  .w-146\\.5 {
    width: calc(var(--spacing) * 146.5);
  }
  .w-157 {
    width: calc(var(--spacing) * 157);
  }
  .w-185 {
    width: calc(var(--spacing) * 185);
  }
  .w-222 {
    width: calc(var(--spacing) * 222);
  }
  .w-246 {
    width: calc(var(--spacing) * 246);
  }
  .w-247\\.5 {
    width: calc(var(--spacing) * 247.5);
  }
  .w-275 {
    width: calc(var(--spacing) * 275);
  }
  .w-\\[1px\\] {
    width: 1px;
  }
  .w-\\[14px\\] {
    width: 14px;
  }
  .w-\\[22px\\] {
    width: 22px;
  }
  .w-\\[32px\\] {
    width: 32px;
  }
  .w-\\[90\\%\\] {
    width: 90%;
  }
  .w-\\[100dvw\\] {
    width: 100dvw;
  }
  .w-\\[124px\\] {
    width: 124px;
  }
  .w-\\[140\\%\\] {
    width: 140%;
  }
  .w-\\[220px\\] {
    width: 220px;
  }
  .w-\\[231px\\] {
    width: 231px;
  }
  .w-\\[275px\\] {
    width: 275px;
  }
  .w-\\[350px\\] {
    width: 350px;
  }
  .w-\\[370px\\] {
    width: 370px;
  }
  .w-\\[392px\\] {
    width: 392px;
  }
  .w-\\[448px\\] {
    width: 448px;
  }
  .w-\\[889px\\] {
    width: 889px;
  }
  .w-\\[calc\\(100\\%-2rem\\)\\] {
    width: calc(100% - 2rem);
  }
  .w-\\[calc\\(100\\%_-_40px\\)\\] {
    width: calc(100% - 40px);
  }
  .w-\\[calc\\(100dvw-\\(var\\(--spacing\\)\\*10\\)\\)\\] {
    width: calc(100dvw - (var(--spacing) * 10));
  }
  .w-\\[calc\\(100vw-\\(var\\(--spacing\\)\\*4\\*2\\)\\)\\] {
    width: calc(100vw - (var(--spacing) * 4 * 2));
  }
  .w-\\[calc\\(100vw-2rem\\)\\] {
    width: calc(100vw - 2rem);
  }
  .w-\\[calc\\(100vw-32px\\)\\] {
    width: calc(100vw - 32px);
  }
  .w-\\[calc\\(100vw-var\\(--space-2xl\\)\\)\\]\\! {
    width: calc(100vw - var(--space-2xl)) !important;
  }
  .w-\\[calc\\(var\\(--space-xl\\)\\*8\\)\\] {
    width: calc(var(--space-xl) * 8);
  }
  .w-\\[min\\(100\\%\\,720px\\)\\] {
    width: min(100%, 720px);
  }
  .w-\\[min\\(996px\\,calc\\(100vw-2rem\\)\\)\\] {
    width: min(996px, calc(100vw - 2rem));
  }
  .w-\\[var\\(--switch-box-handle-size\\)\\] {
    width: var(--switch-box-handle-size);
  }
  .w-\\[var\\(--switch-box-width\\)\\] {
    width: var(--switch-box-width);
  }
  .w-auto {
    width: auto;
  }
  .w-dvw {
    width: 100dvw;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-lvw {
    width: 100lvw;
  }
  .w-max {
    width: max-content;
  }
  .w-screen {
    width: 100vw;
  }
  .max-w-\\(--overview-book-top-toolbar-max-width\\) {
    max-width: var(--overview-book-top-toolbar-max-width);
  }
  .max-w-\\(--page-pair-max-width\\) {
    max-width: var(--page-pair-max-width);
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-13\\.5 {
    max-width: calc(var(--spacing) * 13.5);
  }
  .max-w-25 {
    max-width: calc(var(--spacing) * 25);
  }
  .max-w-64 {
    max-width: calc(var(--spacing) * 64);
  }
  .max-w-81\\.5 {
    max-width: calc(var(--spacing) * 81.5);
  }
  .max-w-83\\.75 {
    max-width: calc(var(--spacing) * 83.75);
  }
  .max-w-107\\.5 {
    max-width: calc(var(--spacing) * 107.5);
  }
  .max-w-125 {
    max-width: calc(var(--spacing) * 125);
  }
  .max-w-172 {
    max-width: calc(var(--spacing) * 172);
  }
  .max-w-270 {
    max-width: calc(var(--spacing) * 270);
  }
  .max-w-\\[80\\%\\] {
    max-width: 80%;
  }
  .max-w-\\[100dvw\\] {
    max-width: 100dvw;
  }
  .max-w-\\[234px\\] {
    max-width: 234px;
  }
  .max-w-\\[250px\\] {
    max-width: 250px;
  }
  .max-w-\\[300px\\] {
    max-width: 300px;
  }
  .max-w-\\[360px\\] {
    max-width: 360px;
  }
  .max-w-\\[400px\\] {
    max-width: 400px;
  }
  .max-w-\\[420px\\] {
    max-width: 420px;
  }
  .max-w-\\[425px\\] {
    max-width: 425px;
  }
  .max-w-\\[492px\\] {
    max-width: 492px;
  }
  .max-w-\\[628px\\] {
    max-width: 628px;
  }
  .max-w-\\[760px\\] {
    max-width: 760px;
  }
  .max-w-\\[980px\\] {
    max-width: 980px;
  }
  .max-w-\\[1120px\\] {
    max-width: 1120px;
  }
  .max-w-\\[1220px\\] {
    max-width: 1220px;
  }
  .max-w-\\[1400px\\] {
    max-width: 1400px;
  }
  .max-w-\\[1520px\\] {
    max-width: 1520px;
  }
  .max-w-\\[calc\\(100\\%-2rem\\)\\] {
    max-width: calc(100% - 2rem);
  }
  .max-w-\\[calc\\(100dvw-\\(var\\(--spacing\\)\\*8\\)\\)\\] {
    max-width: calc(100dvw - (var(--spacing) * 8));
  }
  .max-w-\\[calc\\(100vw-2rem\\)\\] {
    max-width: calc(100vw - 2rem);
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-max {
    max-width: max-content;
  }
  .max-w-none {
    max-width: none;
  }
  .max-w-none\\! {
    max-width: none !important;
  }
  .max-w-screen {
    max-width: 100vw;
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-12 {
    min-width: calc(var(--spacing) * 12);
  }
  .min-w-22 {
    min-width: calc(var(--spacing) * 22);
  }
  .min-w-55 {
    min-width: calc(var(--spacing) * 55);
  }
  .min-w-\\[20px\\] {
    min-width: 20px;
  }
  .min-w-\\[200px\\] {
    min-width: 200px;
  }
  .min-w-\\[1036px\\] {
    min-width: 1036px;
  }
  .min-w-\\[1160px\\] {
    min-width: 1160px;
  }
  .min-w-\\[calc\\(var\\(--space-xl\\)\\*8\\)\\] {
    min-width: calc(var(--space-xl) * 8);
  }
  .min-w-full {
    min-width: 100%;
  }
  .min-w-max {
    min-width: max-content;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-shrink {
    flex-shrink: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .grow {
    flex-grow: 1;
  }
  .basis-0 {
    flex-basis: calc(var(--spacing) * 0);
  }
  .basis-1\\/2 {
    flex-basis: calc(1/2 * 100%);
  }
  .basis-14 {
    flex-basis: calc(var(--spacing) * 14);
  }
  .\\!origin-center {
    transform-origin: center !important;
  }
  .origin-left {
    transform-origin: left;
  }
  .origin-top-left {
    transform-origin: top left;
  }
  .-translate-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-1\\/2 {
    --tw-translate-x: calc(1/2 * 100%);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-\\[var\\(--switch-box-handle-transform\\)\\] {
    --tw-translate-x: var(--switch-box-handle-transform);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-full {
    --tw-translate-x: 100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-0\\.5 {
    --tw-translate-y: calc(var(--spacing) * -0.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-25 {
    --tw-translate-y: calc(var(--spacing) * -25);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-\\[22px\\] {
    --tw-translate-y: calc(22px * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-0 {
    --tw-translate-y: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-110 {
    --tw-scale-x: 110%;
    --tw-scale-y: 110%;
    --tw-scale-z: 110%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-scale-x-100 {
    --tw-scale-x: calc(100% * -1);
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-rotate-45 {
    rotate: calc(45deg * -1);
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .\\[transform\\:scaleX\\(0\\)\\] {
    transform: scaleX(0);
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .transform-gpu {
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-wiggle {
    --tw-animation-delay: 0s;
    animation: 0.3s ease-in-out var(--tw-animation-delay) wiggle infinite;
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .\\!cursor-grab {
    cursor: grab !important;
  }
  .cursor-crosshair {
    cursor: crosshair;
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-ew-resize {
    cursor: ew-resize;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-none {
    cursor: none;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .touch-pan-x {
    --tw-pan-x: pan-x;
    touch-action: var(--tw-pan-x,) var(--tw-pan-y,) var(--tw-pinch-zoom,);
  }
  .touch-none {
    touch-action: none;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .appearance-none {
    appearance: none;
  }
  .auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }
  .grid-flow-col {
    grid-auto-flow: column;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .grid-cols-\\[5\\.5rem_minmax\\(0\\,1fr\\)\\] {
    grid-template-columns: 5.5rem minmax(0,1fr);
  }
  .grid-cols-\\[7rem_1fr\\] {
    grid-template-columns: 7rem 1fr;
  }
  .grid-cols-\\[160px_repeat\\(5\\,1fr\\)\\] {
    grid-template-columns: 160px repeat(5,1fr);
  }
  .grid-cols-\\[210px_392px_370px\\] {
    grid-template-columns: 210px 392px 370px;
  }
  .grid-cols-\\[210px_minmax\\(0\\,1fr\\)_370px\\] {
    grid-template-columns: 210px minmax(0,1fr) 370px;
  }
  .grid-cols-\\[230px_minmax\\(0\\,1fr\\)_231px\\] {
    grid-template-columns: 230px minmax(0,1fr) 231px;
  }
  .grid-cols-\\[max-content_max-content\\] {
    grid-template-columns: max-content max-content;
  }
  .grid-cols-\\[max-content_max-content_minmax\\(0\\,1fr\\)\\] {
    grid-template-columns: max-content max-content minmax(0,1fr);
  }
  .grid-cols-\\[max-content_minmax\\(0\\,1fr\\)\\] {
    grid-template-columns: max-content minmax(0,1fr);
  }
  .grid-cols-\\[max-content_minmax\\(0\\,1fr\\)_max-content\\] {
    grid-template-columns: max-content minmax(0,1fr) max-content;
  }
  .grid-cols-\\[minmax\\(0\\,1\\.2fr\\)_180px_180px_180px\\] {
    grid-template-columns: minmax(0,1.2fr) 180px 180px 180px;
  }
  .grid-cols-\\[minmax\\(0\\,1fr\\)_auto\\] {
    grid-template-columns: minmax(0,1fr) auto;
  }
  .grid-cols-\\[minmax\\(0\\,1fr\\)_auto_minmax\\(0\\,1fr\\)\\] {
    grid-template-columns: minmax(0,1fr) auto minmax(0,1fr);
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(180px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(180px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(220px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(220px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(240px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(260px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(260px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(280px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(280px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fit\\,var\\(--page-pair-max-width\\)\\)\\] {
    grid-template-columns: repeat(auto-fit,var(--page-pair-max-width));
  }
  .grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  .grid-rows-\\[280px_1fr\\] {
    grid-template-rows: 280px 1fr;
  }
  .grid-rows-\\[minmax\\(0\\,1fr\\)_auto_minmax\\(0\\,1fr\\)\\] {
    grid-template-rows: minmax(0,1fr) auto minmax(0,1fr);
  }
  .grid-rows-\\[repeat\\(4\\,100px\\)\\] {
    grid-template-rows: repeat(4,100px);
  }
  .\\!flex-col {
    flex-direction: column !important;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .place-content-center {
    place-content: center;
  }
  .place-items-center {
    place-items: center;
  }
  .content-center {
    align-content: center;
  }
  .content-start {
    align-content: flex-start;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .\\!justify-start {
    justify-content: flex-start !important;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-center-safe {
    justify-content: safe center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-items-center {
    justify-items: center;
  }
  .justify-items-start {
    justify-items: start;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0);
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-5\\.5 {
    gap: calc(var(--spacing) * 5.5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-7\\.5 {
    gap: calc(var(--spacing) * 7.5);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-9 {
    gap: calc(var(--spacing) * 9);
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10);
  }
  .gap-12 {
    gap: calc(var(--spacing) * 12);
  }
  .gap-13 {
    gap: calc(var(--spacing) * 13);
  }
  .gap-32\\.5 {
    gap: calc(var(--spacing) * 32.5);
  }
  .gap-\\[8px\\] {
    gap: 8px;
  }
  .gap-\\[32px\\] {
    gap: 32px;
  }
  .gap-\\[36px\\] {
    gap: 36px;
  }
  .gap-\\[var\\(--space-lg\\)\\] {
    gap: var(--space-lg);
  }
  .gap-\\[var\\(--space-xl\\)\\] {
    gap: var(--space-xl);
  }
  .gap-control {
    gap: var(--space-control-gap);
  }
  .gap-space-2md {
    gap: var(--space-2md);
  }
  .gap-space-2xl {
    gap: var(--space-2xl);
  }
  .gap-space-2xs {
    gap: var(--space-2xs);
  }
  .gap-space-lg {
    gap: var(--space-lg);
  }
  .gap-space-md {
    gap: var(--space-md);
  }
  .gap-space-sm {
    gap: var(--space-sm);
  }
  .gap-space-xl {
    gap: var(--space-xl);
  }
  .gap-space-xs {
    gap: var(--space-xs);
  }
  .icon-text-gap {
    gap: var(--icon-text-gap);
  }
  .icon-text-gap-lg {
    gap: var(--icon-text-gap-lg);
  }
  .gap-x-1 {
    column-gap: calc(var(--spacing) * 1);
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-x-4 {
    column-gap: calc(var(--spacing) * 4);
  }
  .gap-x-6 {
    column-gap: calc(var(--spacing) * 6);
  }
  .gap-x-7\\.5 {
    column-gap: calc(var(--spacing) * 7.5);
  }
  .gap-x-10 {
    column-gap: calc(var(--spacing) * 10);
  }
  .gap-x-\\[1px\\] {
    column-gap: 1px;
  }
  .gap-x-\\[4px\\] {
    column-gap: 4px;
  }
  .gap-x-\\[8px\\] {
    column-gap: 8px;
  }
  .gap-x-\\[10px\\] {
    column-gap: 10px;
  }
  .gap-x-\\[12px\\] {
    column-gap: 12px;
  }
  .gap-x-\\[16px\\] {
    column-gap: 16px;
  }
  .gap-x-\\[24px\\] {
    column-gap: 24px;
  }
  .gap-x-space-2xl {
    column-gap: var(--space-2xl);
  }
  .gap-x-space-lg {
    column-gap: var(--space-lg);
  }
  .gap-x-space-sm {
    column-gap: var(--space-sm);
  }
  .\\!gap-y-\\[14px\\] {
    row-gap: 14px !important;
  }
  .gap-y-0\\.5 {
    row-gap: calc(var(--spacing) * 0.5);
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .gap-y-3 {
    row-gap: calc(var(--spacing) * 3);
  }
  .gap-y-4 {
    row-gap: calc(var(--spacing) * 4);
  }
  .gap-y-5 {
    row-gap: calc(var(--spacing) * 5);
  }
  .gap-y-6 {
    row-gap: calc(var(--spacing) * 6);
  }
  .gap-y-8 {
    row-gap: calc(var(--spacing) * 8);
  }
  .gap-y-14 {
    row-gap: calc(var(--spacing) * 14);
  }
  .gap-y-\\[4px\\] {
    row-gap: 4px;
  }
  .gap-y-\\[8px\\] {
    row-gap: 8px;
  }
  .gap-y-\\[12px\\] {
    row-gap: 12px;
  }
  .gap-y-\\[16px\\] {
    row-gap: 16px;
  }
  .gap-y-\\[24px\\] {
    row-gap: 24px;
  }
  .gap-y-\\[28px\\] {
    row-gap: 28px;
  }
  .gap-y-\\[32px\\] {
    row-gap: 32px;
  }
  .gap-y-\\[40px\\] {
    row-gap: 40px;
  }
  .gap-y-space-lg {
    row-gap: var(--space-lg);
  }
  .self-center {
    align-self: center;
  }
  .self-end {
    align-self: flex-end;
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .justify-self-center {
    justify-self: center;
  }
  .justify-self-end {
    justify-self: flex-end;
  }
  .justify-self-start {
    justify-self: flex-start;
  }
  .justify-self-stretch {
    justify-self: stretch;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-visible\\! {
    overflow: visible !important;
  }
  .\\!overflow-x-hidden {
    overflow-x: hidden !important;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-x-hidden\\! {
    overflow-x: hidden !important;
  }
  .overflow-x-visible {
    overflow-x: visible;
  }
  .\\!overflow-y-auto {
    overflow-y: auto !important;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overscroll-x-contain {
    overscroll-behavior-x: contain;
  }
  .rounded-\\(--radius-surface\\) {
    border-radius: var(--radius-surface);
  }
  .rounded-1\\! {
    border-radius: calc(var(--spacing) * 1) !important;
  }
  .rounded-2 {
    border-radius: calc(var(--spacing) * 2);
  }
  .rounded-3 {
    border-radius: calc(var(--spacing) * 3);
  }
  .rounded-4 {
    border-radius: calc(var(--spacing) * 4);
  }
  .rounded-6 {
    border-radius: calc(var(--spacing) * 6);
  }
  .rounded-\\[18px\\] {
    border-radius: 18px;
  }
  .rounded-\\[20px\\] {
    border-radius: 20px;
  }
  .rounded-\\[32px\\] {
    border-radius: 32px;
  }
  .rounded-\\[100\\%\\] {
    border-radius: 100%;
  }
  .rounded-\\[calc\\(var\\(--switch-box-height\\)\\*2\\)\\] {
    border-radius: calc(var(--switch-box-height) * 2);
  }
  .rounded-\\[calc\\(var\\(--switch-box-height\\)\\/2\\)\\] {
    border-radius: calc(var(--switch-box-height) / 2);
  }
  .rounded-control {
    border-radius: var(--radius-control);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-overlay {
    border-radius: var(--radius-overlay);
  }
  .rounded-surface {
    border-radius: var(--radius-surface);
  }
  .rounded-s-overlay {
    border-start-start-radius: var(--radius-overlay);
    border-end-start-radius: var(--radius-overlay);
  }
  .rounded-s-overlay {
    border-start-start-radius: var(--radius-overlay);
    border-end-start-radius: var(--radius-overlay);
  }
  .rounded-e-6 {
    border-start-end-radius: calc(var(--spacing) * 6);
    border-end-end-radius: calc(var(--spacing) * 6);
  }
  .rounded-e-overlay {
    border-start-end-radius: var(--radius-overlay);
    border-end-end-radius: var(--radius-overlay);
  }
  .rounded-e-overlay {
    border-start-end-radius: var(--radius-overlay);
    border-end-end-radius: var(--radius-overlay);
  }
  .rounded-t-\\(--kiosk-panel-radius\\) {
    border-top-left-radius: var(--kiosk-panel-radius);
    border-top-right-radius: var(--kiosk-panel-radius);
  }
  .rounded-t-6 {
    border-top-left-radius: calc(var(--spacing) * 6);
    border-top-right-radius: calc(var(--spacing) * 6);
  }
  .rounded-t-overlay {
    border-top-left-radius: var(--radius-overlay);
    border-top-right-radius: var(--radius-overlay);
  }
  .rounded-t-overlay {
    border-top-left-radius: var(--radius-overlay);
    border-top-right-radius: var(--radius-overlay);
  }
  .rounded-tr-surface {
    border-top-right-radius: var(--radius-surface);
  }
  .rounded-b-overlay {
    border-bottom-right-radius: var(--radius-overlay);
    border-bottom-left-radius: var(--radius-overlay);
  }
  .rounded-b-overlay {
    border-bottom-right-radius: var(--radius-overlay);
    border-bottom-left-radius: var(--radius-overlay);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-0\\! {
    border-style: var(--tw-border-style) !important;
    border-width: 0px !important;
  }
  .border-1 {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-4 {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .border-20 {
    border-style: var(--tw-border-style);
    border-width: 20px;
  }
  .border-\\[5px\\] {
    border-style: var(--tw-border-style);
    border-width: 5px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .\\!border-\\(--primary1\\) {
    border-color: var(--primary1) !important;
  }
  .border-\\(--background-primary\\) {
    border-color: var(--background-primary);
  }
  .border-\\(--background-primary-translucent\\) {
    border-color: var(--background-primary-translucent);
  }
  .border-\\(--black1\\) {
    border-color: var(--black1);
  }
  .border-\\(--kiosk-black\\) {
    border-color: var(--kiosk-black);
  }
  .border-\\(--kiosk-border\\) {
    border-color: var(--kiosk-border);
  }
  .border-\\(--kiosk-border-inverse\\) {
    border-color: var(--kiosk-border-inverse);
  }
  .border-\\(--kiosk-border-muted\\) {
    border-color: var(--kiosk-border-muted);
  }
  .border-\\(--kiosk-border-secondary\\) {
    border-color: var(--kiosk-border-secondary);
  }
  .border-\\(--kiosk-border-subtle\\) {
    border-color: var(--kiosk-border-subtle);
  }
  .border-\\(--kiosk-feedback-success\\) {
    border-color: var(--kiosk-feedback-success);
  }
  .border-\\(--kiosk-feedback-success-muted\\) {
    border-color: var(--kiosk-feedback-success-muted);
  }
  .border-\\(--kiosk-selector-default-border\\) {
    border-color: var(--kiosk-selector-default-border);
  }
  .border-\\(--kiosk-selector-selected\\) {
    border-color: var(--kiosk-selector-selected);
  }
  .border-\\(--neutral1-borders-and-stroke\\) {
    border-color: var(--neutral1-borders-and-stroke);
  }
  .border-\\(--neutral2-borders-and-stroke\\) {
    border-color: var(--neutral2-borders-and-stroke);
  }
  .border-\\(--neutral3-background-fill\\) {
    border-color: var(--neutral3-background-fill);
  }
  .border-\\(--palette-removed\\) {
    border-color: var(--palette-removed);
  }
  .border-\\(--primary1\\) {
    border-color: var(--primary1);
  }
  .border-\\[var\\(--color-border-brand-primary\\)\\] {
    border-color: var(--color-border-brand-primary);
  }
  .border-\\[var\\(--color-border-neutral-border-2\\)\\] {
    border-color: var(--color-border-neutral-border-2);
  }
  .border-\\[var\\(--color-border-neutral-border-3\\)\\] {
    border-color: var(--color-border-neutral-border-3);
  }
  .border-\\[var\\(--white1\\)\\] {
    border-color: var(--white1);
  }
  .border-background-feedback-danger-1 {
    border-color: var(--color-background-feedback-danger-1);
  }
  .border-background-surface-disabled {
    border-color: var(--color-background-surface-disabled);
  }
  .border-border-brand-primary {
    border-color: var(--color-border-brand-primary);
  }
  .border-border-brand-primary-focus {
    border-color: var(--color-border-brand-primary-focus);
  }
  .border-border-brand-primary-hover {
    border-color: var(--color-border-brand-primary-hover);
  }
  .border-border-brand-primary-pressed {
    border-color: var(--color-border-brand-primary-pressed);
  }
  .border-border-neutral-border-1 {
    border-color: var(--color-border-neutral-border-1);
  }
  .border-border-neutral-border-2 {
    border-color: var(--color-border-neutral-border-2);
  }
  .border-border-neutral-border-3 {
    border-color: var(--color-border-neutral-border-3);
  }
  .border-border-neutral-border-4 {
    border-color: var(--color-border-neutral-border-4);
  }
  .border-border-neutral-border-5 {
    border-color: var(--color-border-neutral-border-5);
  }
  .border-border-neutral-disabled {
    border-color: var(--color-border-neutral-disabled);
  }
  .border-transparent {
    border-color: transparent;
  }
  .\\!bg-\\[initial\\] {
    background-color: initial !important;
  }
  .\\[background-color\\:var\\(--editor-toolbar-background-color\\,var\\(--color-background-surface-fill-2\\)\\)\\] {
    background-color: var(--editor-toolbar-background-color,var(--color-background-surface-fill-2));
  }
  .bg-\\(--background-primary\\) {
    background-color: var(--background-primary);
  }
  .bg-\\(--background-primary\\)\\! {
    background-color: var(--background-primary) !important;
  }
  .bg-\\(--background-primary-inverse\\) {
    background-color: var(--background-primary-inverse);
  }
  .bg-\\(--background-secondary\\) {
    background-color: var(--background-secondary);
  }
  .bg-\\(--bg-color\\) {
    background-color: var(--bg-color);
  }
  .bg-\\(--color-kept\\) {
    background-color: var(--color-kept);
  }
  .bg-\\(--gridlines\\) {
    background-color: var(--gridlines);
  }
  .bg-\\(--kiosk-background\\) {
    background-color: var(--kiosk-background);
  }
  .bg-\\(--kiosk-border-primary\\) {
    background-color: var(--kiosk-border-primary);
  }
  .bg-\\(--kiosk-border-secondary\\) {
    background-color: var(--kiosk-border-secondary);
  }
  .bg-\\(--kiosk-key-floater-background\\) {
    background-color: var(--kiosk-key-floater-background);
  }
  .bg-\\(--kiosk-selector-selected\\) {
    background-color: var(--kiosk-selector-selected);
  }
  .bg-\\(--kiosk-surface-idle-overlay\\)\\/50 {
    background-color: var(--kiosk-surface-idle-overlay);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .bg-\\(--kiosk-surface-idle-overlay\\)\\/50 {
      background-color: color-mix(in oklab, var(--kiosk-surface-idle-overlay) 50%, transparent);
    }
  }
  .bg-\\(--kiosk-surface-muted\\) {
    background-color: var(--kiosk-surface-muted);
  }
  .bg-\\(--kiosk-surface-overlay\\)\\/50 {
    background-color: var(--kiosk-surface-overlay);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .bg-\\(--kiosk-surface-overlay\\)\\/50 {
      background-color: color-mix(in oklab, var(--kiosk-surface-overlay) 50%, transparent);
    }
  }
  .bg-\\(--kiosk-surface-primary\\) {
    background-color: var(--kiosk-surface-primary);
  }
  .bg-\\(--kiosk-surface-selected\\) {
    background-color: var(--kiosk-surface-selected);
  }
  .bg-\\(--kiosk-surface-selected-pressed\\) {
    background-color: var(--kiosk-surface-selected-pressed);
  }
  .bg-\\(--kiosk-upsell-background\\) {
    background-color: var(--kiosk-upsell-background);
  }
  .bg-\\(--neutral1-borders-and-stroke\\) {
    background-color: var(--neutral1-borders-and-stroke);
  }
  .bg-\\(--neutral3-background-fill\\) {
    background-color: var(--neutral3-background-fill);
  }
  .bg-\\(--neutral3-background-fills\\) {
    background-color: var(--neutral3-background-fills);
  }
  .bg-\\(--neutral5-grey-fill\\) {
    background-color: var(--neutral5-grey-fill);
  }
  .bg-\\(--primary1\\) {
    background-color: var(--primary1);
  }
  .bg-\\(--sub-nav-bar-background\\) {
    background-color: var(--sub-nav-bar-background);
  }
  .bg-\\(--swatch-color\\) {
    background-color: var(--swatch-color);
  }
  .bg-\\(--vector-color\\,unset\\) {
    background-color: var(--vector-color,unset);
  }
  .bg-\\(--white1\\) {
    background-color: var(--white1);
  }
  .bg-\\[color-mix\\(in_srgb\\,var\\(--primary1\\)_30\\%\\,var\\(--white1\\)\\)\\] {
    background-color: var(--primary1);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .bg-\\[color-mix\\(in_srgb\\,var\\(--primary1\\)_30\\%\\,var\\(--white1\\)\\)\\] {
      background-color: color-mix(in srgb,var(--primary1) 30%,var(--white1));
    }
  }
  .bg-\\[var\\(--color-background-brand-accent-fill-1\\)\\] {
    background-color: var(--color-background-brand-accent-fill-1);
  }
  .bg-\\[var\\(--color-background-brand-primary\\)\\] {
    background-color: var(--color-background-brand-primary);
  }
  .bg-\\[var\\(--color-background-feedback-warning-2\\)\\] {
    background-color: var(--color-background-feedback-warning-2);
  }
  .bg-\\[var\\(--color-background-surface-fill-1\\)\\] {
    background-color: var(--color-background-surface-fill-1);
  }
  .bg-\\[var\\(--color-background-surface-fill-2\\)\\] {
    background-color: var(--color-background-surface-fill-2);
  }
  .bg-\\[var\\(--primary1\\)\\] {
    background-color: var(--primary1);
  }
  .bg-\\[var\\(--workspace-toolbar-background-color\\,var\\(--color-background-surface-fill-1\\)\\)\\] {
    background-color: var(--workspace-toolbar-background-color,var(--color-background-surface-fill-1));
  }
  .bg-background-brand-accent-fill-1 {
    background-color: var(--color-background-brand-accent-fill-1);
  }
  .bg-background-brand-accent-fill-2 {
    background-color: var(--color-background-brand-accent-fill-2);
  }
  .bg-background-brand-primary {
    background-color: var(--color-background-brand-primary);
  }
  .bg-background-brand-primary-focus {
    background-color: var(--color-background-brand-primary-focus);
  }
  .bg-background-brand-primary-hover {
    background-color: var(--color-background-brand-primary-hover);
  }
  .bg-background-brand-primary-pressed {
    background-color: var(--color-background-brand-primary-pressed);
  }
  .bg-background-canvas-canvas-secondary {
    background-color: var(--color-background-canvas-canvas-secondary);
  }
  .bg-background-feedback-danger-1 {
    background-color: var(--color-background-feedback-danger-1);
  }
  .bg-background-feedback-success-1 {
    background-color: var(--color-background-feedback-success-1);
  }
  .bg-background-feedback-warning-1 {
    background-color: var(--color-background-feedback-warning-1);
  }
  .bg-background-surface-disabled {
    background-color: var(--color-background-surface-disabled);
  }
  .bg-background-surface-fill-1 {
    background-color: var(--color-background-surface-fill-1);
  }
  .bg-background-surface-fill-2 {
    background-color: var(--color-background-surface-fill-2);
  }
  .bg-background-surface-fill-3 {
    background-color: var(--color-background-surface-fill-3);
  }
  .bg-background-surface-fill-4 {
    background-color: var(--color-background-surface-fill-4);
  }
  .bg-background-surface-fill-5 {
    background-color: var(--color-background-surface-fill-5);
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .bg-black\\/50 {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-black\\/80 {
    background-color: color-mix(in srgb, #000 80%, transparent);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .bg-black\\/80 {
      background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
  }
  .bg-border-neutral-border-2 {
    background-color: var(--color-border-neutral-border-2);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-\\(image\\:--bg-image\\) {
    background-image: var(--bg-image);
  }
  .bg-\\(image\\:--vector-color-image\\,unset\\) {
    background-image: var(--vector-color-image,unset);
  }
  .bg-\\[url\\(\\~root\\/img\\/colors\\/transparent\\.svg\\)\\] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .bg-contain {
    background-size: contain;
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-size-\\(--bg-size\\) {
    background-size: var(--bg-size);
  }
  .bg-size-\\[10\\%\\] {
    background-size: 10%;
  }
  .bg-center {
    background-position: center;
  }
  .bg-no-repeat {
    background-repeat: no-repeat;
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .\\!p-0 {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-10 {
    padding: calc(var(--spacing) * 10);
  }
  .p-12 {
    padding: calc(var(--spacing) * 12);
  }
  .p-\\[calc\\(\\.\\.\\.\\)\\] {
    padding: calc(...);
  }
  .p-\\[var\\(--space-2xs\\)\\] {
    padding: var(--space-2xs);
  }
  .p-\\[var\\(--space-xl\\)\\] {
    padding: var(--space-xl);
  }
  .p-\\[var\\(--switch-box-padding\\)\\] {
    padding: var(--switch-box-padding);
  }
  .p-space-2md {
    padding: var(--space-2md);
  }
  .p-space-2sm {
    padding: var(--space-2sm);
  }
  .p-space-2xl {
    padding: var(--space-2xl);
  }
  .p-space-2xs {
    padding: var(--space-2xs);
  }
  .p-space-3xs {
    padding: var(--space-3xs);
  }
  .p-space-lg {
    padding: var(--space-lg);
  }
  .p-space-md {
    padding: var(--space-md);
  }
  .p-space-none {
    padding: var(--space-none);
  }
  .p-space-sm {
    padding: var(--space-sm);
  }
  .p-space-xl {
    padding: var(--space-xl);
  }
  .p-space-xs {
    padding: var(--space-xs);
  }
  .p-control-lg {
    padding-block: var(--space-control-y-lg);
    padding-inline: var(--space-control-x);
  }
  .p-control-md {
    padding-block: var(--space-control-y-md);
    padding-inline: var(--space-control-x);
  }
  .p-control-sm {
    padding-block: var(--space-control-y-sm);
    padding-inline: var(--space-control-x);
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-4\\! {
    padding-inline: calc(var(--spacing) * 4) !important;
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-12 {
    padding-inline: calc(var(--spacing) * 12);
  }
  .px-12\\.5 {
    padding-inline: calc(var(--spacing) * 12.5);
  }
  .px-14 {
    padding-inline: calc(var(--spacing) * 14);
  }
  .px-16 {
    padding-inline: calc(var(--spacing) * 16);
  }
  .px-24 {
    padding-inline: calc(var(--spacing) * 24);
  }
  .px-\\[24px\\] {
    padding-inline: 24px;
  }
  .px-\\[30px\\] {
    padding-inline: 30px;
  }
  .px-\\[94px\\] {
    padding-inline: 94px;
  }
  .px-control {
    padding-inline: var(--space-control-x);
  }
  .px-px {
    padding-inline: 1px;
  }
  .px-space-lg {
    padding-inline: var(--space-lg);
  }
  .px-space-md {
    padding-inline: var(--space-md);
  }
  .px-space-sm {
    padding-inline: var(--space-sm);
  }
  .px-space-xs {
    padding-inline: var(--space-xs);
  }
  .py-0 {
    padding-block: calc(var(--spacing) * 0);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\! {
    padding-block: calc(var(--spacing) * 1) !important;
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-\\[12px\\] {
    padding-block: 12px;
  }
  .py-\\[48px\\] {
    padding-block: 48px;
  }
  .py-control-lg {
    padding-block: var(--space-control-y-lg);
  }
  .py-control-md {
    padding-block: var(--space-control-y-md);
  }
  .py-control-sm {
    padding-block: var(--space-control-y-sm);
  }
  .py-space-2xs {
    padding-block: var(--space-2xs);
  }
  .py-space-sm {
    padding-block: var(--space-sm);
  }
  .py-space-xs {
    padding-block: var(--space-xs);
  }
  .\\!pt-\\[calc\\(var\\(--space-2xl\\)\\+var\\(--space-xl\\)\\)\\] {
    padding-top: calc(var(--space-2xl) + var(--space-xl)) !important;
  }
  .pt-0 {
    padding-top: calc(var(--spacing) * 0);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-5 {
    padding-top: calc(var(--spacing) * 5);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-12 {
    padding-top: calc(var(--spacing) * 12);
  }
  .pt-15 {
    padding-top: calc(var(--spacing) * 15);
  }
  .pt-32 {
    padding-top: calc(var(--spacing) * 32);
  }
  .pt-\\[48px\\] {
    padding-top: 48px;
  }
  .pt-\\[72px\\] {
    padding-top: 72px;
  }
  .pt-space-lg {
    padding-top: var(--space-lg);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-7\\.5 {
    padding-right: calc(var(--spacing) * 7.5);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pr-\\[8px\\] {
    padding-right: 8px;
  }
  .pb-\\(--overview-book-padding-bottom\\) {
    padding-bottom: var(--overview-book-padding-bottom);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-6 {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pb-12 {
    padding-bottom: calc(var(--spacing) * 12);
  }
  .pb-space-sm {
    padding-bottom: var(--space-sm);
  }
  .pb-space-xs {
    padding-bottom: var(--space-xs);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .pl-\\[12px\\] {
    padding-left: 12px;
  }
  .pl-space-sm {
    padding-left: var(--space-sm);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .align-middle {
    vertical-align: middle;
  }
  .type-body-2-emphasis {
    font-family: var(--type-body-2-emphasis-family);
    font-size: var(--type-body-2-emphasis-size);
    line-height: var(--type-body-2-emphasis-leading);
    font-weight: var(--type-body-2-emphasis-weight);
  }
  .font-\\(family-name\\:--font-family\\) {
    font-family: var(--font-family);
  }
  .font-\\(family-name\\:--font-family-bold\\) {
    font-family: var(--font-family-bold);
  }
  .font-\\(family-name\\:--font-family-demi-bold\\) {
    font-family: var(--font-family-demi-bold);
  }
  .font-\\(family-name\\:--font-family-regular\\) {
    font-family: var(--font-family-regular);
  }
  .font-\\[inherit\\] {
    font-family: inherit;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .type-link {
    font-size: var(--type-link-size);
    line-height: var(--type-link-leading);
    font-weight: var(--type-link-weight);
    text-decoration: underline;
  }
  .type-body-1 {
    font-size: var(--type-body-1-size);
    line-height: var(--type-body-1-leading);
    font-weight: var(--type-body-1-weight);
  }
  .type-body-1-strong {
    font-size: var(--type-body-1-strong-size);
    line-height: var(--type-body-1-strong-leading);
    font-weight: var(--type-body-1-strong-weight);
  }
  .type-body-2 {
    font-size: var(--type-body-2-size);
    line-height: var(--type-body-2-leading);
    font-weight: var(--type-body-2-weight);
  }
  .type-button {
    font-size: var(--type-button-label-size);
    line-height: var(--type-button-label-leading);
    font-weight: var(--type-button-label-weight);
  }
  .type-caption {
    font-size: var(--type-caption-size);
    line-height: var(--type-caption-leading);
    font-weight: var(--type-caption-weight);
  }
  .type-caption-2 {
    font-size: var(--type-caption-2-size);
    line-height: var(--type-caption-2-leading);
    font-weight: var(--type-caption-2-weight);
  }
  .type-h5 {
    font-size: var(--type-h5-size);
    line-height: var(--type-h5-leading);
    font-weight: var(--type-h5-weight);
  }
  .type-h6 {
    font-size: var(--type-h6-size);
    line-height: var(--type-h6-leading);
    font-weight: var(--type-h6-weight);
  }
  .type-heading {
    font-size: var(--type-heading-size);
    line-height: var(--type-heading-leading);
    font-weight: var(--type-heading-weight);
  }
  .type-subtitle {
    font-size: var(--type-subtitle-size);
    line-height: var(--type-subtitle-leading);
    font-weight: var(--type-subtitle-weight);
  }
  .type-subtitle-1 {
    font-size: var(--type-subtitle-1-size);
    line-height: var(--type-subtitle-1-leading);
    font-weight: var(--type-subtitle-1-weight);
  }
  .type-subtitle-strong {
    font-size: var(--type-subtitle-strong-size);
    line-height: var(--type-subtitle-strong-leading);
    font-weight: var(--type-subtitle-strong-weight);
  }
  .type-title-1 {
    font-size: var(--type-title-1-size);
    line-height: var(--type-title-1-leading);
    font-weight: var(--type-title-1-weight);
  }
  .type-title-2 {
    font-size: var(--type-title-2-size);
    line-height: var(--type-title-2-leading);
    font-weight: var(--type-title-2-weight);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .\\!text-\\(length\\:--type-subtitle-1-size\\) {
    font-size: var(--type-subtitle-1-size) !important;
  }
  .\\[font-size\\:18px\\] {
    font-size: 18px;
  }
  .text-\\(length\\:--font-size-l\\) {
    font-size: var(--font-size-l);
  }
  .text-\\(length\\:--font-size-l2\\) {
    font-size: var(--font-size-l2);
  }
  .text-\\(length\\:--font-size-m\\) {
    font-size: var(--font-size-m);
  }
  .text-\\(length\\:--font-size-m2\\) {
    font-size: var(--font-size-m2);
  }
  .text-\\(length\\:--font-size-s\\) {
    font-size: var(--font-size-s);
  }
  .text-\\(length\\:--font-size-xl\\) {
    font-size: var(--font-size-xl);
  }
  .text-\\(length\\:--font-size-xs\\) {
    font-size: var(--font-size-xs);
  }
  .text-\\(length\\:--font-size-xs2\\) {
    font-size: var(--font-size-xs2);
  }
  .text-\\(length\\:--font-size-xs3\\) {
    font-size: var(--font-size-xs3);
  }
  .text-\\(length\\:--font-size-xxl\\) {
    font-size: var(--font-size-xxl);
  }
  .text-\\(length\\:--font-size-xxs2\\) {
    font-size: var(--font-size-xxs2);
  }
  .text-\\(length\\:--font-size-xxxl\\) {
    font-size: var(--font-size-xxxl);
  }
  .text-\\(length\\:--type-button-link-large-size\\) {
    font-size: var(--type-button-link-large-size);
  }
  .text-\\(length\\:--type-button-link-medium-size\\) {
    font-size: var(--type-button-link-medium-size);
  }
  .text-\\(length\\:--type-button-link-small-size\\) {
    font-size: var(--type-button-link-small-size);
  }
  .text-\\(length\\:--type-subtitle-1-size\\) {
    font-size: var(--type-subtitle-1-size);
  }
  .text-\\(length\\:--type-subtitle-size\\) {
    font-size: var(--type-subtitle-size);
  }
  .text-\\[3\\.5rem\\] {
    font-size: 3.5rem;
  }
  .text-\\[4rem\\] {
    font-size: 4rem;
  }
  .text-\\[5rem\\] {
    font-size: 5rem;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[18px\\] {
    font-size: 18px;
  }
  .text-\\[40px\\] {
    font-size: 40px;
  }
  .text-\\[48px\\] {
    font-size: 48px;
  }
  .\\!leading-\\[1\\.2\\] {
    --tw-leading: 1.2 !important;
    line-height: 1.2 !important;
  }
  .leading-\\(--type-button-link-leading\\) {
    --tw-leading: var(--type-button-link-leading);
    line-height: var(--type-button-link-leading);
  }
  .leading-8 {
    --tw-leading: calc(var(--spacing) * 8);
    line-height: calc(var(--spacing) * 8);
  }
  .leading-\\[1\\.1\\] {
    --tw-leading: 1.1;
    line-height: 1.1;
  }
  .leading-\\[1\\.2\\] {
    --tw-leading: 1.2;
    line-height: 1.2;
  }
  .leading-\\[1\\.45\\] {
    --tw-leading: 1.45;
    line-height: 1.45;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-\\(--font-weight-bold\\) {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-\\(--font-weight-demi-bold\\) {
    --tw-font-weight: var(--font-weight-demi-bold);
    font-weight: var(--font-weight-demi-bold);
  }
  .font-\\(--font-weight-regular\\) {
    --tw-font-weight: var(--font-weight-regular);
    font-weight: var(--font-weight-regular);
  }
  .font-\\(--type-button-link-weight\\) {
    --tw-font-weight: var(--type-button-link-weight);
    font-weight: var(--type-button-link-weight);
  }
  .font-\\(--weight-bold\\) {
    --tw-font-weight: var(--weight-bold);
    font-weight: var(--weight-bold);
  }
  .font-\\(--weight-regular\\)\\! {
    --tw-font-weight: var(--weight-regular) !important;
    font-weight: var(--weight-regular) !important;
  }
  .font-bold {
    --tw-font-weight: var(--weight-bold);
    font-weight: var(--weight-bold);
  }
  .font-demi {
    --tw-font-weight: var(--weight-demi);
    font-weight: var(--weight-demi);
  }
  .font-medium {
    --tw-font-weight: var(--weight-medium);
    font-weight: var(--weight-medium);
  }
  .font-medium\\! {
    --tw-font-weight: var(--weight-medium) !important;
    font-weight: var(--weight-medium) !important;
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-regular {
    --tw-font-weight: var(--weight-regular);
    font-weight: var(--weight-regular);
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .text-\\(--accent1\\) {
    color: var(--accent1);
  }
  .text-\\(--color-other-brand\\) {
    color: var(--color-other-brand);
  }
  .text-\\(--font-neutral-black1\\) {
    color: var(--font-neutral-black1);
  }
  .text-\\(--font-neutral-grey1\\) {
    color: var(--font-neutral-grey1);
  }
  .text-\\(--font-neutral-white1\\) {
    color: var(--font-neutral-white1);
  }
  .text-\\(--font-primary\\) {
    color: var(--font-primary);
  }
  .text-\\(--font-secondary\\) {
    color: var(--font-secondary);
  }
  .text-\\(--font-size-xs\\) {
    color: var(--font-size-xs);
  }
  .text-\\(--icon-default\\) {
    color: var(--icon-default);
  }
  .text-\\(--kiosk-feedback-success\\) {
    color: var(--kiosk-feedback-success);
  }
  .text-\\(--kiosk-icon-inverse\\) {
    color: var(--kiosk-icon-inverse);
  }
  .text-\\(--kiosk-icon-loading\\) {
    color: var(--kiosk-icon-loading);
  }
  .text-\\(--kiosk-text-danger\\) {
    color: var(--kiosk-text-danger);
  }
  .text-\\(--kiosk-text-inverse\\) {
    color: var(--kiosk-text-inverse);
  }
  .text-\\(--kiosk-text-muted\\) {
    color: var(--kiosk-text-muted);
  }
  .text-\\(--kiosk-text-primary\\) {
    color: var(--kiosk-text-primary);
  }
  .text-\\(--kiosk-upsell-text\\) {
    color: var(--kiosk-upsell-text);
  }
  .text-\\(--neutral4-grey\\) {
    color: var(--neutral4-grey);
  }
  .text-\\(--primary1\\) {
    color: var(--primary1);
  }
  .text-\\(--success-color\\) {
    color: var(--success-color);
  }
  .text-\\(--white1\\) {
    color: var(--white1);
  }
  .text-\\[var\\(--color-background-feedback-warning-1\\)\\] {
    color: var(--color-background-feedback-warning-1);
  }
  .text-\\[var\\(--color-deleted\\)\\] {
    color: var(--color-deleted);
  }
  .text-\\[var\\(--color-icon-default-primary\\)\\] {
    color: var(--color-icon-default-primary);
  }
  .text-\\[var\\(--color-text-brand-primary\\)\\] {
    color: var(--color-text-brand-primary);
  }
  .text-\\[var\\(--color-text-default-primary\\)\\] {
    color: var(--color-text-default-primary);
  }
  .text-\\[var\\(--color-text-default-secondary\\)\\] {
    color: var(--color-text-default-secondary);
  }
  .text-\\[var\\(--color-text-default-tertiary\\)\\] {
    color: var(--color-text-default-tertiary);
  }
  .text-background-brand-accent-fill-1 {
    color: var(--color-background-brand-accent-fill-1);
  }
  .text-background-brand-accent-fill-3 {
    color: var(--color-background-brand-accent-fill-3);
  }
  .text-current {
    color: currentcolor;
  }
  .text-icon-brand-primary {
    color: var(--color-icon-brand-primary);
  }
  .text-icon-brand-primary-focus {
    color: var(--color-icon-brand-primary-focus);
  }
  .text-icon-brand-primary-hover {
    color: var(--color-icon-brand-primary-hover);
  }
  .text-icon-brand-primary-pressed {
    color: var(--color-icon-brand-primary-pressed);
  }
  .text-icon-default-disabled {
    color: var(--color-icon-default-disabled);
  }
  .text-icon-default-primary {
    color: var(--color-icon-default-primary);
  }
  .text-icon-default-secondary {
    color: var(--color-icon-default-secondary);
  }
  .text-icon-feedback-success {
    color: var(--color-icon-feedback-success);
  }
  .text-inherit {
    color: inherit;
  }
  .text-text-brand-primary {
    color: var(--color-text-brand-primary);
  }
  .text-text-brand-primary-focus {
    color: var(--color-text-brand-primary-focus);
  }
  .text-text-brand-primary-hover {
    color: var(--color-text-brand-primary-hover);
  }
  .text-text-brand-primary-pressed {
    color: var(--color-text-brand-primary-pressed);
  }
  .text-text-default-disabled {
    color: var(--color-text-default-disabled);
  }
  .text-text-default-primary {
    color: var(--color-text-default-primary);
  }
  .text-text-default-secondary {
    color: var(--color-text-default-secondary);
  }
  .text-text-default-tertiary {
    color: var(--color-text-default-tertiary);
  }
  .text-text-feedback-danger {
    color: var(--color-text-feedback-danger);
  }
  .text-white {
    color: var(--color-white);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .normal-case {
    text-transform: none;
  }
  .text-transform-brand {
    text-transform: var(--text-transform);
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .no-underline {
    text-decoration-line: none;
  }
  .underline {
    text-decoration-line: underline;
  }
  .decoration-\\[0\\.06em\\] {
    text-decoration-thickness: 0.06em;
  }
  .underline-offset-\\[0\\.18em\\] {
    text-underline-offset: 0.18em;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-10 {
    opacity: 10%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\(--kiosk-sheet-shadow\\) {
    --tw-shadow: var(--kiosk-sheet-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[10px_10px_20px_0_rgba\\(88\\,88\\,88\\,0\\.15\\)\\] {
    --tw-shadow: 10px 10px 20px 0 var(--tw-shadow-color, rgba(88,88,88,0.15));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[inset_0_0_0_1px_var\\(--color-border-brand-primary-focus\\)\\] {
    --tw-shadow: inset 0 0 0 1px var(--tw-shadow-color, var(--color-border-brand-primary-focus));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[inset_0_0_0_1px_var\\(--color-border-neutral-border-1\\)\\] {
    --tw-shadow: inset 0 0 0 1px var(--tw-shadow-color, var(--color-border-neutral-border-1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[inset_0_0_0_2px_var\\(--color-border-neutral-border-1\\)\\] {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-border-neutral-border-1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-floating {
    --tw-shadow: var(--shadow-floating);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-inverse {
    --tw-shadow: var(--shadow-inverse);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-overlay {
    --tw-shadow: var(--shadow-overlay);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-raised {
    --tw-shadow: var(--shadow-raised);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-4 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-\\[3px\\] {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\(color\\:--editor-vector-colors-view-color-box-shadow-color\\,transparent\\) {
    --tw-shadow-color: var(--editor-vector-colors-view-color-box-shadow-color,transparent);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .shadow-\\(color\\:--editor-vector-colors-view-color-box-shadow-color\\,transparent\\) {
      --tw-shadow-color: color-mix(in oklab, var(--editor-vector-colors-view-color-box-shadow-color,transparent) var(--tw-shadow-alpha), transparent);
    }
  }
  .ring-\\(--kiosk-border-primary\\) {
    --tw-ring-color: var(--kiosk-border-primary);
  }
  .ring-\\(--kiosk-focus-ring\\) {
    --tw-ring-color: var(--kiosk-focus-ring);
  }
  .ring-\\(--kiosk-selector-selected\\) {
    --tw-ring-color: var(--kiosk-selector-selected);
  }
  .ring-\\[2px_transparent\\] {
    --tw-ring-color: 2px transparent;
  }
  .ring-\\[2px_var\\(--swatch-color\\)\\] {
    --tw-ring-color: 2px var(--swatch-color);
  }
  .ring-border-neutral-border-1 {
    --tw-ring-color: var(--color-border-neutral-border-1);
  }
  .focus-ring {
    outline: var(--focus-ring-width) var(--focus-ring-style) var(--focus-ring-color);
    outline-offset: var(--focus-ring-offset);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-\\[10px_10px_20px_rgba\\(88\\,88\\,88\\,0\\.15\\)\\] {
    --tw-drop-shadow-size: drop-shadow(10px 10px 20px var(--tw-drop-shadow-color, rgba(88,88,88,0.15)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-sm {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.15)));
    --tw-drop-shadow: drop-shadow(var(--drop-shadow-sm));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-\\(color\\:--feedback-danger-muted\\) {
    --tw-drop-shadow-color: var(--feedback-danger-muted);
  }
  @supports (color: color-mix(in lab, red, red)) {
    .drop-shadow-\\(color\\:--feedback-danger-muted\\) {
      --tw-drop-shadow-color: color-mix(in oklab, var(--feedback-danger-muted) var(--tw-drop-shadow-alpha), transparent);
    }
  }
  .drop-shadow-\\(color\\:--feedback-danger-muted\\) {
    --tw-drop-shadow: var(--tw-drop-shadow-size);
  }
  .sepia {
    --tw-sepia: sepia(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-filter {
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, visibility, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[background-color\\,border-color\\,color\\,transform\\] {
    transition-property: background-color,border-color,color,transform;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[background-color\\,box-shadow\\,opacity\\,translate\\] {
    transition-property: background-color,box-shadow,opacity,translate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[border-width\\,transform\\] {
    transition-property: border-width,transform;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[box-shadow\\] {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .delay-500 {
    transition-delay: 500ms;
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-400 {
    --tw-duration: 400ms;
    transition-duration: 400ms;
  }
  .duration-1000 {
    --tw-duration: 1000ms;
    transition-duration: 1000ms;
  }
  .duration-base {
    transition-duration: var(--duration-base);
  }
  .duration-fast {
    transition-duration: var(--duration-fast);
  }
  .duration-instant {
    transition-duration: var(--duration-instant);
  }
  .duration-slow {
    transition-duration: var(--duration-slow);
  }
  .duration-slower {
    transition-duration: var(--duration-slower);
  }
  .ease-\\[ease\\] {
    --tw-ease: ease;
    transition-timing-function: ease;
  }
  .ease-accelerate {
    --tw-ease: var(--ease-accelerate);
    transition-timing-function: var(--ease-accelerate);
  }
  .ease-decelerate {
    --tw-ease: var(--ease-decelerate);
    transition-timing-function: var(--ease-decelerate);
  }
  .ease-emphasized {
    --tw-ease: var(--ease-emphasized);
    transition-timing-function: var(--ease-emphasized);
  }
  .ease-in {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-linear {
    --tw-ease: linear;
    transition-timing-function: linear;
  }
  .ease-linear {
    --tw-ease: var(--ease-linear);
    transition-timing-function: var(--ease-linear);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .ease-standard {
    --tw-ease: var(--ease-standard);
    transition-timing-function: var(--ease-standard);
  }
  .will-change-transform {
    will-change: transform;
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .\\[--checkbox-component-border-radius\\:4px\\] {
    --checkbox-component-border-radius: 4px;
  }
  .\\[--checkbox-component-border-width\\:1px\\] {
    --checkbox-component-border-width: 1px;
  }
  .\\[--checkbox-component-checked-background\\:var\\(--color-background-brand-primary\\)\\] {
    --checkbox-component-checked-background: var(--color-background-brand-primary);
  }
  .\\[--checkbox-component-checked-border\\:var\\(--color-border-brand-primary\\)\\] {
    --checkbox-component-checked-border: var(--color-border-brand-primary);
  }
  .\\[--checkbox-component-checked-icon-color\\:var\\(--color-icon-default-secondary\\)\\] {
    --checkbox-component-checked-icon-color: var(--color-icon-default-secondary);
  }
  .\\[--checkbox-component-icon-size\\:12px\\] {
    --checkbox-component-icon-size: 12px;
  }
  .\\[--editor-toolbar-background-color\\:var\\(--color-background-surface-fill-1\\)\\] {
    --editor-toolbar-background-color: var(--color-background-surface-fill-1);
  }
  .\\[-webkit-user-drag\\:none\\] {
    -webkit-user-drag: none;
  }
  .\\[animation-duration\\:1\\.1s\\] {
    animation-duration: 1.1s;
  }
  .\\[animation-fill-mode\\:forwards\\] {
    animation-fill-mode: forwards;
  }
  .\\[animation-name\\:kiosk-idle-warning-return-progress\\] {
    animation-name: kiosk-idle-warning-return-progress;
  }
  .\\[animation-timing-function\\:linear\\] {
    animation-timing-function: linear;
  }
  .\\[clip-path\\:inset\\(0_0_0_var\\(--slider-position\\)\\)\\] {
    clip-path: inset(0 0 0 var(--slider-position));
  }
  .\\[clip-path\\:inset\\(50\\%\\)\\] {
    clip-path: inset(50%);
  }
  .\\[clip\\:rect\\(0_0_0_0\\)\\] {
    clip: rect(0 0 0 0);
  }
  .\\[grid-area\\:element\\] {
    grid-area: element;
  }
  .\\[grid-area\\:thin-line-warning\\] {
    grid-area: thin-line-warning;
  }
  .\\[grid-template-areas\\:\\'element\\'\\] {
    grid-template-areas: 'element';
  }
  .\\[scrollbar-width\\:none\\] {
    scrollbar-width: none;
  }
  .divider-gap-0 {
    --divider-gap: calc(var(--spacing) * 0);
  }
  .divider-gap-1 {
    --divider-gap: calc(var(--spacing) * 1);
  }
  .divider-gap-4 {
    --divider-gap: calc(var(--spacing) * 4);
  }
  .divider-size-10 {
    --divider-size: calc(var(--spacing) * 10);
  }
  .divider-size-full {
    --divider-size: 100%;
  }
  .divider-width-2 {
    --divider-width: 2px;
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  :is(.\\*\\:origin-top-left > *) {
    transform-origin: top left;
  }
  :is(.\\*\\:scale-\\(--crop-photo-scale\\) > *) {
    scale: var(--crop-photo-scale);
  }
  :is(.\\*\\*\\:appearance-textfield *) {
    appearance: textfield;
  }
  :is(.\\*\\*\\:appearance-textfield *)::-webkit-inner-spin-button {
    appearance: none;
  }
  :is(.\\*\\*\\:appearance-textfield *)::-webkit-outer-spin-button {
    appearance: none;
  }
  :is(.\\*\\*\\:text-center *) {
    text-align: center;
  }
  :is(.\\*\\*\\:font-\\(family-name\\:--font-family-regular\\)\\! *) {
    font-family: var(--font-family-regular) !important;
  }
  :is(.\\*\\*\\:text-\\(length\\:--font-size-xs\\)\\! *) {
    font-size: var(--font-size-xs) !important;
  }
  :is(.\\*\\*\\:font-\\(--font-weight-regular\\)\\! *) {
    --tw-font-weight: var(--font-weight-regular) !important;
    font-weight: var(--font-weight-regular) !important;
  }
  :is(.\\*\\*\\:text-\\(--font-primary\\)\\! *) {
    color: var(--font-primary) !important;
  }
  .not-peer-\\[\\&\\.overview-book-low-resolution-alert\\]\\:pt-\\(--overview-book-padding\\):not(*:is(:where(.peer).overview-book-low-resolution-alert ~ *)) {
    padding-top: var(--overview-book-padding);
  }
  @media (hover: hover) {
    .group-hover\\/floating-action\\:bg-background-brand-accent-fill-1:is(:where(.group\\/floating-action):hover *) {
      background-color: var(--color-background-brand-accent-fill-1);
    }
  }
  @media (hover: hover) {
    .group-hover\\/floating-action\\:text-icon-brand-primary:is(:where(.group\\/floating-action):hover *) {
      color: var(--color-icon-brand-primary);
    }
  }
  @media (hover: hover) {
    .group-hover\\/floating-action\\:text-text-brand-primary:is(:where(.group\\/floating-action):hover *) {
      color: var(--color-text-brand-primary);
    }
  }
  @media (hover: hover) {
    .group-hover\\/page\\:flex:is(:where(.group\\/page):hover *) {
      display: flex;
    }
  }
  @media (hover: hover) {
    .group-hover\\/photo-menu-option\\:text-text-brand-primary:is(:where(.group\\/photo-menu-option):hover *) {
      color: var(--color-text-brand-primary);
    }
  }
  @media (hover: hover) {
    .group-hover\\/photo-tile\\:pointer-events-auto:is(:where(.group\\/photo-tile):hover *) {
      pointer-events: auto;
    }
  }
  @media (hover: hover) {
    .group-hover\\/photo-tile\\:opacity-20:is(:where(.group\\/photo-tile):hover *) {
      opacity: 20%;
    }
  }
  @media (hover: hover) {
    .group-hover\\/photo-tile\\:opacity-100:is(:where(.group\\/photo-tile):hover *) {
      opacity: 100%;
    }
  }
  @media (hover: hover) {
    .group-hover\\/spread\\:flex:is(:where(.group\\/spread):hover *) {
      display: flex;
    }
  }
  .placeholder\\:text-\\[1em\\]::placeholder {
    font-size: 1em;
  }
  .before\\:pointer-events-none::before {
    content: var(--tw-content);
    pointer-events: none;
  }
  .before\\:absolute::before {
    content: var(--tw-content);
    position: absolute;
  }
  .before\\:z-1::before {
    content: var(--tw-content);
    z-index: 1;
  }
  .before\\:h-full::before {
    content: var(--tw-content);
    height: 100%;
  }
  .before\\:w-full::before {
    content: var(--tw-content);
    width: 100%;
  }
  .before\\:rounded-\\(--page-pair-border-radius\\)::before {
    content: var(--tw-content);
    border-radius: var(--page-pair-border-radius);
  }
  .before\\:rounded-full::before {
    content: var(--tw-content);
    border-radius: calc(infinity * 1px);
  }
  .before\\:inset-shadow-raised::before {
    content: var(--tw-content);
    --tw-inset-shadow: inset var(--shadow-raised);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .before\\:inset-ring::before {
    content: var(--tw-content);
    --tw-inset-ring-shadow: inset 0 0 0 1px var(--tw-inset-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .before\\:\\[--tw-inset-ring-color\\:var\\(--neutral1-borders-and-stroke\\)\\]::before {
    content: var(--tw-content);
    --tw-inset-ring-color: var(--neutral1-borders-and-stroke);
  }
  .after\\:pointer-events-none::after {
    content: var(--tw-content);
    pointer-events: none;
  }
  .after\\:absolute::after {
    content: var(--tw-content);
    position: absolute;
  }
  .after\\:inset-0::after {
    content: var(--tw-content);
    inset: calc(var(--spacing) * 0);
  }
  .after\\:z-raised::after {
    content: var(--tw-content);
    z-index: var(--z-raised);
  }
  .after\\:box-border::after {
    content: var(--tw-content);
    box-sizing: border-box;
  }
  .after\\:rounded-surface::after {
    content: var(--tw-content);
    border-radius: var(--radius-surface);
  }
  .after\\:border::after {
    content: var(--tw-content);
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .after\\:border-dashed::after {
    content: var(--tw-content);
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .after\\:border-border-brand-primary::after {
    content: var(--tw-content);
    border-color: var(--color-border-brand-primary);
  }
  .after\\:bg-background-brand-accent-fill-1::after {
    content: var(--tw-content);
    background-color: var(--color-background-brand-accent-fill-1);
  }
  .after\\:bg-\\[linear-gradient\\(currentColor\\,currentColor\\)\\]::after {
    content: var(--tw-content);
    background-image: linear-gradient(currentColor,currentColor);
  }
  .after\\:bg-size-\\[100\\%_0\\.06em\\]::after {
    content: var(--tw-content);
    background-size: 100% 0.06em;
  }
  .after\\:bg-clip-padding::after {
    content: var(--tw-content);
    background-clip: padding-box;
  }
  .after\\:bg-position-\\[center_calc\\(50\\%\\+0\\.7em\\)\\]::after {
    content: var(--tw-content);
    background-position: center calc(50% + 0.7em);
  }
  .after\\:bg-no-repeat::after {
    content: var(--tw-content);
    background-repeat: no-repeat;
  }
  .after\\:bg-origin-content::after {
    content: var(--tw-content);
    background-origin: content-box;
  }
  .after\\:\\[padding\\:inherit\\]::after {
    content: var(--tw-content);
    padding: inherit;
  }
  .after\\:content-\\[\\'\\'\\]::after {
    content: var(--tw-content);
    --tw-content: '';
    content: var(--tw-content);
  }
  .after\\:content-\\[\\\\\\'\\\\\\'\\]::after {
    content: var(--tw-content);
    --tw-content: \\'\\';
    content: var(--tw-content);
  }
  .first\\:mt-4:first-child {
    margin-top: calc(var(--spacing) * 4);
  }
  .first\\:border-t-0:first-child {
    border-top-style: var(--tw-border-style);
    border-top-width: 0px;
  }
  :is(.\\*\\:first\\:font-\\(family-name\\:--font-family-demi-bold\\) > *):first-child {
    font-family: var(--font-family-demi-bold);
  }
  :is(.\\*\\:first\\:text-\\(length\\:--font-size-m\\) > *):first-child {
    font-size: var(--font-size-m);
  }
  :is(.\\*\\:first\\:font-\\(--font-weight-demi-bold\\) > *):first-child {
    --tw-font-weight: var(--font-weight-demi-bold);
    font-weight: var(--font-weight-demi-bold);
  }
  :is(.\\*\\:last\\:text-\\(length\\:--font-size-xs2\\) > *):last-child {
    font-size: var(--font-size-xs2);
  }
  .last-of-type\\:hidden:last-of-type {
    display: none;
  }
  @media (hover: hover) {
    .hover\\:border\\!:hover {
      border-style: var(--tw-border-style) !important;
      border-width: 1px !important;
    }
  }
  @media (hover: hover) {
    .hover\\:border-\\(--neutral2-borders-and-stroke\\):hover {
      border-color: var(--neutral2-borders-and-stroke);
    }
  }
  @media (hover: hover) {
    .hover\\:border-\\[var\\(--color-border-neutral-border-3\\)\\]:hover {
      border-color: var(--color-border-neutral-border-3);
    }
  }
  @media (hover: hover) {
    .hover\\:border-border-brand-primary-hover:hover {
      border-color: var(--color-border-brand-primary-hover);
    }
  }
  @media (hover: hover) {
    .hover\\:border-border-neutral-border-1:hover {
      border-color: var(--color-border-neutral-border-1);
    }
  }
  @media (hover: hover) {
    .hover\\:border-border-neutral-border-2:hover {
      border-color: var(--color-border-neutral-border-2);
    }
  }
  @media (hover: hover) {
    .hover\\:border-border-neutral-border-3:hover {
      border-color: var(--color-border-neutral-border-3);
    }
  }
  @media (hover: hover) {
    .hover\\:border-border-neutral-border-4:hover {
      border-color: var(--color-border-neutral-border-4);
    }
  }
  @media (hover: hover) {
    .hover\\:bg-background-brand-accent-fill-1:hover {
      background-color: var(--color-background-brand-accent-fill-1);
    }
  }
  @media (hover: hover) {
    .hover\\:bg-background-brand-primary-hover:hover {
      background-color: var(--color-background-brand-primary-hover);
    }
  }
  @media (hover: hover) {
    .hover\\:bg-background-surface-fill-2:hover {
      background-color: var(--color-background-surface-fill-2);
    }
  }
  @media (hover: hover) {
    .hover\\:text-icon-brand-primary:hover {
      color: var(--color-icon-brand-primary);
    }
  }
  @media (hover: hover) {
    .hover\\:text-icon-default-secondary:hover {
      color: var(--color-icon-default-secondary);
    }
  }
  @media (hover: hover) {
    .hover\\:text-text-brand-primary:hover {
      color: var(--color-text-brand-primary);
    }
  }
  @media (hover: hover) {
    .hover\\:opacity-30:hover {
      opacity: 30%;
    }
  }
  @media (hover: hover) {
    .hover\\:shadow-floating:hover {
      --tw-shadow: var(--shadow-floating);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  @media (hover: hover) {
    .hover\\:shadow-overlay:hover {
      --tw-shadow: var(--shadow-overlay);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:border-\\(--kiosk-black\\):focus {
    border-color: var(--kiosk-black);
  }
  .focus\\:outline-none:focus {
    --tw-outline-style: none;
    outline-style: none;
  }
  .focus-visible\\:focus-ring:focus-visible {
    outline: var(--focus-ring-width) var(--focus-ring-style) var(--focus-ring-color);
    outline-offset: var(--focus-ring-offset);
  }
  .focus-visible\\:outline-none:focus-visible {
    --tw-outline-style: none;
    outline-style: none;
  }
  .active\\:scale-100:active {
    --tw-scale-x: 100%;
    --tw-scale-y: 100%;
    --tw-scale-z: 100%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .active\\:scale-\\[\\.97\\]:active {
    scale: .97;
  }
  .active\\:scale-\\[0\\.98\\]:active {
    scale: 0.98;
  }
  .active\\:scale-\\[0\\.99\\]:active {
    scale: 0.99;
  }
  .active\\:\\!cursor-grabbing:active {
    cursor: grabbing !important;
  }
  .active\\:cursor-grabbing:active {
    cursor: grabbing;
  }
  .active\\:border-8:active {
    border-style: var(--tw-border-style);
    border-width: 8px;
  }
  .active\\:border-\\(--kiosk-border-hover\\):active {
    border-color: var(--kiosk-border-hover);
  }
  .active\\:border-border-neutral-border-1:active {
    border-color: var(--color-border-neutral-border-1);
  }
  .active\\:bg-\\(--kiosk-border-secondary\\):active {
    background-color: var(--kiosk-border-secondary);
  }
  .active\\:bg-\\(--kiosk-surface-primary-pressed\\):active {
    background-color: var(--kiosk-surface-primary-pressed);
  }
  .active\\:bg-\\(--kiosk-surface-selected-pressed\\):active {
    background-color: var(--kiosk-surface-selected-pressed);
  }
  .active\\:bg-\\(--kiosk-upsell-background-pressed\\):active {
    background-color: var(--kiosk-upsell-background-pressed);
  }
  .active\\:bg-background-brand-primary-pressed:active {
    background-color: var(--color-background-brand-primary-pressed);
  }
  .active\\:text-icon-default-secondary:active {
    color: var(--color-icon-default-secondary);
  }
  .active\\:ring-\\(--kiosk-selector-pressed-border\\):active {
    --tw-ring-color: var(--kiosk-selector-pressed-border);
  }
  .enabled\\:active\\:border:enabled:active {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .enabled\\:active\\:border-0:enabled:active {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .enabled\\:active\\:border-border-brand-primary-pressed:enabled:active {
    border-color: var(--color-border-brand-primary-pressed);
  }
  .enabled\\:active\\:bg-background-brand-accent-fill-1:enabled:active {
    background-color: var(--color-background-brand-accent-fill-1);
  }
  .enabled\\:active\\:bg-background-brand-primary-pressed:enabled:active {
    background-color: var(--color-background-brand-primary-pressed);
  }
  .enabled\\:active\\:text-icon-brand-primary-pressed:enabled:active {
    color: var(--color-icon-brand-primary-pressed);
  }
  .enabled\\:active\\:text-text-brand-primary-pressed:enabled:active {
    color: var(--color-text-brand-primary-pressed);
  }
  .enabled\\:active\\:shadow-none:enabled:active {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .disabled\\:cursor-default:disabled {
    cursor: default;
  }
  .disabled\\:border-\\(--kiosk-border-primary\\):disabled {
    border-color: var(--kiosk-border-primary);
  }
  .disabled\\:bg-\\(--kiosk-border-primary\\):disabled {
    background-color: var(--kiosk-border-primary);
  }
  .disabled\\:bg-\\(--kiosk-surface-primary\\):disabled {
    background-color: var(--kiosk-surface-primary);
  }
  .disabled\\:bg-transparent:disabled {
    background-color: transparent;
  }
  .disabled\\:text-\\(--kiosk-text-disabled\\):disabled {
    color: var(--kiosk-text-disabled);
  }
  .disabled\\:opacity-40:disabled {
    opacity: 40%;
  }
  .has-focus\\:border-border-brand-primary:has(*:focus) {
    border-color: var(--color-border-brand-primary);
  }
  .has-\\[\\.overview-book-view\\]\\:static\\!:has(*:is(.overview-book-view)) {
    position: static !important;
  }
  .has-\\[\\.overview-book-view\\]\\:float-none\\!:has(*:is(.overview-book-view)) {
    float: none !important;
  }
  .has-\\[\\.overview-book-view\\]\\:mt-\\[initial\\]\\!:has(*:is(.overview-book-view)) {
    margin-top: initial !important;
  }
  .has-\\[\\.overview-book-view\\]\\:h-\\[calc\\(var\\(--app-full-height\\)-var\\(--subnavigation-margin-top\\)\\)\\]:has(*:is(.overview-book-view)) {
    height: calc(var(--app-full-height) - var(--subnavigation-margin-top));
  }
  .has-\\[\\.overview-book-view\\]\\:translate-y-\\(--subnavigation-margin-top\\):has(*:is(.overview-book-view)) {
    --tw-translate-y: var(--subnavigation-margin-top);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  @media (prefers-reduced-motion: reduce) {
    .motion-reduce\\:\\[transform\\:scaleX\\(1\\)\\] {
      transform: scaleX(1);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .motion-reduce\\:\\[animation\\:none\\] {
      animation: none;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .motion-reduce\\:duration-0 {
      --tw-duration: 0ms;
      transition-duration: 0ms;
    }
  }
  @media (width < 48rem) {
    .max-md\\:relative {
      position: relative;
    }
  }
  @media (width < 48rem) {
    .max-md\\:flex {
      display: flex;
    }
  }
  @media (width < 48rem) {
    .max-md\\:min-h-19 {
      min-height: calc(var(--spacing) * 19);
    }
  }
  @media (width < 48rem) {
    .max-md\\:max-w-full {
      max-width: 100%;
    }
  }
  @media (width < 48rem) {
    .max-md\\:min-w-0 {
      min-width: calc(var(--spacing) * 0);
    }
  }
  @media (width < 48rem) {
    .max-md\\:shrink-0 {
      flex-shrink: 0;
    }
  }
  @media (width < 48rem) {
    .max-md\\:grow {
      flex-grow: 1;
    }
  }
  @media (width < 48rem) {
    .max-md\\:flex-col-reverse {
      flex-direction: column-reverse;
    }
  }
  @media (width < 48rem) {
    .max-md\\:justify-start {
      justify-content: flex-start;
    }
  }
  @media (width < 48rem) {
    .max-md\\:gap-space-xs {
      gap: var(--space-xs);
    }
  }
  @media (width < 48rem) {
    .max-md\\:gap-x-space-sm {
      column-gap: var(--space-sm);
    }
  }
  @media (width < 48rem) {
    .max-md\\:overflow-hidden {
      overflow: hidden;
    }
  }
  @media (width < 48rem) {
    .max-md\\:overflow-x-scroll {
      overflow-x: scroll;
    }
  }
  @media (width < 48rem) {
    .max-md\\:rounded-t-4 {
      border-top-left-radius: calc(var(--spacing) * 4);
      border-top-right-radius: calc(var(--spacing) * 4);
    }
  }
  @media (width < 48rem) {
    .max-md\\:bg-\\(--workspace-toolbar-background-color\\) {
      background-color: var(--workspace-toolbar-background-color);
    }
  }
  @media (width < 48rem) {
    .max-md\\:p-space-sm {
      padding: var(--space-sm);
    }
  }
  @media (width < 48rem) {
    .max-md\\:px-1\\.5 {
      padding-inline: calc(var(--spacing) * 1.5);
    }
  }
  @media (width < 48rem) {
    .max-md\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
  }
  @media (width < 48rem) {
    .max-md\\:px-space-xs {
      padding-inline: var(--space-xs);
    }
  }
  @media (width < 48rem) {
    .max-md\\:py-space-md {
      padding-block: var(--space-md);
    }
  }
  @media (width < 48rem) {
    .max-md\\:pt-space-sm {
      padding-top: var(--space-sm);
    }
  }
  @media (width < 48rem) {
    .max-md\\:pb-3 {
      padding-bottom: calc(var(--spacing) * 3);
    }
  }
  @media (width < 48rem) {
    .max-md\\:whitespace-nowrap {
      white-space: nowrap;
    }
  }
  @media (width < 48rem) {
    .max-md\\:\\[--workspace-toolbar-background-color\\:var\\(--background-quaternary\\)\\] {
      --workspace-toolbar-background-color: var(--background-quaternary);
    }
  }
  @media (width < 48rem) {
    .max-md\\:\\[--workspace-toolbar-background-color\\:var\\(--background-secondary\\)\\] {
      --workspace-toolbar-background-color: var(--background-secondary);
    }
  }
  @media (width < 48rem) {
    .max-md\\:\\[scrollbar-width\\:none\\] {
      scrollbar-width: none;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:inset-0 {
      inset: calc(var(--spacing) * 0);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:col-span-full {
      grid-column: 1 / -1;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:row-start-1 {
      grid-row-start: 1;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:row-start-2 {
      grid-row-start: 2;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:-mx-4 {
      margin-inline: calc(var(--spacing) * -4);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:mt-10 {
      margin-top: calc(var(--spacing) * 10);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:mb-8 {
      margin-bottom: calc(var(--spacing) * 8);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:box-border {
      box-sizing: border-box;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:flex {
      display: flex;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:grid {
      display: grid;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:hidden {
      display: none;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:h-dvh {
      height: 100dvh;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:h-full {
      height: 100%;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:max-h-32 {
      max-height: calc(var(--spacing) * 32);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:max-h-40 {
      max-height: calc(var(--spacing) * 40);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:max-h-full {
      max-height: 100%;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:max-h-none {
      max-height: none;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:w-16\\.5\\! {
      width: calc(var(--spacing) * 16.5) !important;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:w-dvw {
      width: 100dvw;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:w-full {
      width: 100%;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:max-w-full {
      max-width: 100%;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:min-w-0 {
      min-width: calc(var(--spacing) * 0);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:min-w-16\\.5\\! {
      min-width: calc(var(--spacing) * 16.5) !important;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:flex-1 {
      flex: 1;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:shrink-0 {
      flex-shrink: 0;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:grow {
      flex-grow: 1;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:-translate-y-2 {
      --tw-translate-y: calc(var(--spacing) * -2);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:translate-y-0 {
      --tw-translate-y: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  @media (width < 40rem) {
    .max-sm\\:flex-col {
      flex-direction: column;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:self-center {
      align-self: center;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:justify-self-end {
      justify-self: flex-end;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:justify-self-start {
      justify-self: flex-start;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:overflow-hidden {
      overflow: hidden;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:overflow-x-auto {
      overflow-x: auto;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:overflow-x-hidden {
      overflow-x: hidden;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:rounded-none {
      border-radius: 0;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:rounded-none {
      border-radius: 0;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:p-4 {
      padding: calc(var(--spacing) * 4);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:px-2 {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:py-1\\.5 {
      padding-block: calc(var(--spacing) * 1.5);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:py-3 {
      padding-block: calc(var(--spacing) * 3);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:py-4 {
      padding-block: calc(var(--spacing) * 4);
    }
  }
  @media (width < 40rem) {
    .max-sm\\:text-\\(length\\:--font-size-s2\\)\\! {
      font-size: var(--font-size-s2) !important;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:leading-\\[1\\.125\\] {
      --tw-leading: 1.125;
      line-height: 1.125;
    }
  }
  @media (width < 40rem) {
    .max-sm\\:shadow-none {
      --tw-shadow: 0 0 #0000;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  @media (width >= 40rem) {
    .sm\\:block {
      display: block;
    }
  }
  @media (width >= 40rem) {
    .sm\\:min-w-max {
      min-width: max-content;
    }
  }
  @media (width >= 40rem) {
    .sm\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  @media (width >= 40rem) {
    .sm\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
  }
  @media (width >= 40rem) {
    .sm\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
  }
  @media (width >= 48rem) {
    .md\\:top-3 {
      top: calc(var(--spacing) * 3);
    }
  }
  @media (width >= 48rem) {
    .md\\:right-3 {
      right: calc(var(--spacing) * 3);
    }
  }
  @media (width >= 48rem) {
    .md\\:left-3 {
      left: calc(var(--spacing) * 3);
    }
  }
  @media (width >= 48rem) {
    .md\\:col-span-3 {
      grid-column: span 3 / span 3;
    }
  }
  @media (width >= 48rem) {
    .md\\:-mx-6 {
      margin-inline: calc(var(--spacing) * -6);
    }
  }
  @media (width >= 48rem) {
    .md\\:mx-10 {
      margin-inline: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    .md\\:my-10 {
      margin-block: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    .md\\:mt-10 {
      margin-top: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    .md\\:mt-11\\.5 {
      margin-top: calc(var(--spacing) * 11.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:mt-space-xl {
      margin-top: var(--space-xl);
    }
  }
  @media (width >= 48rem) {
    .md\\:mr-10 {
      margin-right: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    .md\\:mr-space-lg {
      margin-right: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:mb-7 {
      margin-bottom: calc(var(--spacing) * 7);
    }
  }
  @media (width >= 48rem) {
    .md\\:mb-10 {
      margin-bottom: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    .md\\:mb-11 {
      margin-bottom: calc(var(--spacing) * 11);
    }
  }
  @media (width >= 48rem) {
    .md\\:mb-space-md {
      margin-bottom: var(--space-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:ml-auto {
      margin-left: auto;
    }
  }
  @media (width >= 48rem) {
    .md\\:block {
      display: block;
    }
  }
  @media (width >= 48rem) {
    .md\\:contents {
      display: contents;
    }
  }
  @media (width >= 48rem) {
    .md\\:flex {
      display: flex;
    }
  }
  @media (width >= 48rem) {
    .md\\:grid {
      display: grid;
    }
  }
  @media (width >= 48rem) {
    .md\\:grid\\! {
      display: grid !important;
    }
  }
  @media (width >= 48rem) {
    .md\\:hidden\\! {
      display: none !important;
    }
  }
  @media (width >= 48rem) {
    .md\\:size-6 {
      width: calc(var(--spacing) * 6);
      height: calc(var(--spacing) * 6);
    }
  }
  @media (width >= 48rem) {
    .md\\:size-8 {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
    }
  }
  @media (width >= 48rem) {
    .md\\:size-10 {
      width: calc(var(--spacing) * 10);
      height: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    .md\\:size-45 {
      width: calc(var(--spacing) * 45);
      height: calc(var(--spacing) * 45);
    }
  }
  @media (width >= 48rem) {
    .md\\:h-8 {
      height: calc(var(--spacing) * 8);
    }
  }
  @media (width >= 48rem) {
    .md\\:h-9\\! {
      height: calc(var(--spacing) * 9) !important;
    }
  }
  @media (width >= 48rem) {
    .md\\:h-20 {
      height: calc(var(--spacing) * 20);
    }
  }
  @media (width >= 48rem) {
    .md\\:h-91\\.25 {
      height: calc(var(--spacing) * 91.25);
    }
  }
  @media (width >= 48rem) {
    .md\\:h-control-md {
      height: var(--size-control-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:h-full {
      height: 100%;
    }
  }
  @media (width >= 48rem) {
    .md\\:max-h-40 {
      max-height: calc(var(--spacing) * 40);
    }
  }
  @media (width >= 48rem) {
    .md\\:max-h-64 {
      max-height: calc(var(--spacing) * 64);
    }
  }
  @media (width >= 48rem) {
    .md\\:max-h-full {
      max-height: 100%;
    }
  }
  @media (width >= 48rem) {
    .md\\:min-h-0 {
      min-height: calc(var(--spacing) * 0);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-24 {
      width: calc(var(--spacing) * 24);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-62 {
      width: calc(var(--spacing) * 62);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-62\\.5 {
      width: calc(var(--spacing) * 62.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-80 {
      width: calc(var(--spacing) * 80);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-96 {
      width: calc(var(--spacing) * 96);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-103\\.5 {
      width: calc(var(--spacing) * 103.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-105 {
      width: calc(var(--spacing) * 105);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-110\\.5 {
      width: calc(var(--spacing) * 110.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-115 {
      width: calc(var(--spacing) * 115);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-125 {
      width: calc(var(--spacing) * 125);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-128 {
      width: calc(var(--spacing) * 128);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-130 {
      width: calc(var(--spacing) * 130);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-152 {
      width: calc(var(--spacing) * 152);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-156 {
      width: calc(var(--spacing) * 156);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-175 {
      width: calc(var(--spacing) * 175);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-180 {
      width: calc(var(--spacing) * 180);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-193\\.25 {
      width: calc(var(--spacing) * 193.25);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-200 {
      width: calc(var(--spacing) * 200);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-222\\.5 {
      width: calc(var(--spacing) * 222.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-247\\.5 {
      width: calc(var(--spacing) * 247.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-249 {
      width: calc(var(--spacing) * 249);
    }
  }
  @media (width >= 48rem) {
    .md\\:w-\\[248px\\] {
      width: 248px;
    }
  }
  @media (width >= 48rem) {
    .md\\:w-\\[min\\(100dvw\\,calc\\(var\\(--spacing\\)\\*283\\.5\\)\\)\\] {
      width: min(100dvw, calc(var(--spacing) * 283.5));
    }
  }
  @media (width >= 48rem) {
    .md\\:w-auto {
      width: auto;
    }
  }
  @media (width >= 48rem) {
    .md\\:w-auto\\! {
      width: auto !important;
    }
  }
  @media (width >= 48rem) {
    .md\\:w-fit {
      width: fit-content;
    }
  }
  @media (width >= 48rem) {
    .md\\:w-full {
      width: 100%;
    }
  }
  @media (width >= 48rem) {
    .md\\:max-w-80 {
      max-width: calc(var(--spacing) * 80);
    }
  }
  @media (width >= 48rem) {
    .md\\:max-w-150 {
      max-width: calc(var(--spacing) * 150);
    }
  }
  @media (width >= 48rem) {
    .md\\:max-w-175 {
      max-width: calc(var(--spacing) * 175);
    }
  }
  @media (width >= 48rem) {
    .md\\:max-w-\\[calc\\(100\\%-5rem\\)\\] {
      max-width: calc(100% - 5rem);
    }
  }
  @media (width >= 48rem) {
    .md\\:max-w-none {
      max-width: none;
    }
  }
  @media (width >= 48rem) {
    .md\\:min-w-0 {
      min-width: calc(var(--spacing) * 0);
    }
  }
  @media (width >= 48rem) {
    .md\\:min-w-40 {
      min-width: calc(var(--spacing) * 40);
    }
  }
  @media (width >= 48rem) {
    .md\\:min-w-68\\.5 {
      min-width: calc(var(--spacing) * 68.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:min-w-70 {
      min-width: calc(var(--spacing) * 70);
    }
  }
  @media (width >= 48rem) {
    .md\\:min-w-80 {
      min-width: calc(var(--spacing) * 80);
    }
  }
  @media (width >= 48rem) {
    .md\\:flex-1 {
      flex: 1;
    }
  }
  @media (width >= 48rem) {
    .md\\:flex-auto {
      flex: auto;
    }
  }
  @media (width >= 48rem) {
    .md\\:shrink-0 {
      flex-shrink: 0;
    }
  }
  @media (width >= 48rem) {
    .md\\:translate-x-0 {
      --tw-translate-x: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  @media (width >= 48rem) {
    .md\\:translate-x-2 {
      --tw-translate-x: calc(var(--spacing) * 2);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  @media (width >= 48rem) {
    .md\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  @media (width >= 48rem) {
    .md\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  @media (width >= 48rem) {
    .md\\:flex-col {
      flex-direction: column;
    }
  }
  @media (width >= 48rem) {
    .md\\:flex-row {
      flex-direction: row;
    }
  }
  @media (width >= 48rem) {
    .md\\:items-center {
      align-items: center;
    }
  }
  @media (width >= 48rem) {
    .md\\:justify-between {
      justify-content: space-between;
    }
  }
  @media (width >= 48rem) {
    .md\\:justify-end {
      justify-content: flex-end;
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-5 {
      gap: calc(var(--spacing) * 5);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-space-lg {
      gap: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-space-md {
      gap: var(--space-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-space-sm {
      gap: var(--space-sm);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-space-xl {
      gap: var(--space-xl);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-x-3\\! {
      column-gap: calc(var(--spacing) * 3) !important;
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-y-4 {
      row-gap: calc(var(--spacing) * 4);
    }
  }
  @media (width >= 48rem) {
    .md\\:gap-y-space-lg {
      row-gap: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:overflow-hidden {
      overflow: hidden;
    }
  }
  @media (width >= 48rem) {
    .md\\:overflow-y-auto {
      overflow-y: auto;
    }
  }
  @media (width >= 48rem) {
    .md\\:rounded-6 {
      border-radius: calc(var(--spacing) * 6);
    }
  }
  @media (width >= 48rem) {
    .md\\:rounded-surface {
      border-radius: var(--radius-surface);
    }
  }
  @media (width >= 48rem) {
    .md\\:rounded-r-control {
      border-top-right-radius: var(--radius-control);
      border-bottom-right-radius: var(--radius-control);
    }
  }
  @media (width >= 48rem) {
    .md\\:border-6 {
      border-style: var(--tw-border-style);
      border-width: 6px;
    }
  }
  @media (width >= 48rem) {
    .md\\:border-r {
      border-right-style: var(--tw-border-style);
      border-right-width: 1px;
    }
  }
  @media (width >= 48rem) {
    .md\\:border-border-neutral-border-2 {
      border-color: var(--color-border-neutral-border-2);
    }
  }
  @media (width >= 48rem) {
    .md\\:bg-background-surface-fill-1 {
      background-color: var(--color-background-surface-fill-1);
    }
  }
  @media (width >= 48rem) {
    .md\\:p-2\\! {
      padding: calc(var(--spacing) * 2) !important;
    }
  }
  @media (width >= 48rem) {
    .md\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
  }
  @media (width >= 48rem) {
    .md\\:p-space-lg {
      padding: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:p-space-md {
      padding: var(--space-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:p-space-sm {
      padding: var(--space-sm);
    }
  }
  @media (width >= 48rem) {
    .md\\:p-space-xl {
      padding: var(--space-xl);
    }
  }
  @media (width >= 48rem) {
    .md\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  @media (width >= 48rem) {
    .md\\:px-21\\.5 {
      padding-inline: calc(var(--spacing) * 21.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:px-42\\.5 {
      padding-inline: calc(var(--spacing) * 42.5);
    }
  }
  @media (width >= 48rem) {
    .md\\:px-space-2xs {
      padding-inline: var(--space-2xs);
    }
  }
  @media (width >= 48rem) {
    .md\\:px-space-lg {
      padding-inline: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:px-space-sm {
      padding-inline: var(--space-sm);
    }
  }
  @media (width >= 48rem) {
    .md\\:py-8 {
      padding-block: calc(var(--spacing) * 8);
    }
  }
  @media (width >= 48rem) {
    .md\\:py-space-md {
      padding-block: var(--space-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:pt-0 {
      padding-top: calc(var(--spacing) * 0);
    }
  }
  @media (width >= 48rem) {
    .md\\:pt-4 {
      padding-top: calc(var(--spacing) * 4);
    }
  }
  @media (width >= 48rem) {
    .md\\:pt-space-lg {
      padding-top: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:pt-space-md {
      padding-top: var(--space-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:pt-space-sm {
      padding-top: var(--space-sm);
    }
  }
  @media (width >= 48rem) {
    .md\\:pb-space-lg {
      padding-bottom: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:pb-space-sm {
      padding-bottom: var(--space-sm);
    }
  }
  @media (width >= 48rem) {
    .md\\:text-\\(length\\:--font-size-m\\) {
      font-size: var(--font-size-m);
    }
  }
  @media (width >= 48rem) {
    .md\\:text-\\(length\\:--font-size-xl\\) {
      font-size: var(--font-size-xl);
    }
  }
  @media (width >= 48rem) {
    .md\\:text-\\(length\\:--font-size-xxl\\) {
      font-size: var(--font-size-xxl);
    }
  }
  @media (width >= 48rem) {
    .md\\:text-\\(--font-size-xs1\\) {
      color: var(--font-size-xs1);
    }
  }
  @media (width >= 48rem) {
    .md\\:shadow-floating {
      --tw-shadow: var(--shadow-floating);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[--workspace-toolbar-background-color\\:var\\(--color-background-surface-fill-1\\)\\] {
      --workspace-toolbar-background-color: var(--color-background-surface-fill-1);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[scrollbar-width\\:none\\] {
      scrollbar-width: none;
    }
  }
  @media (width >= 48rem) {
    :is(.md\\:\\*\\*\\:font-\\(family-name\\:--font-family-demi-bold\\)\\! *) {
      font-family: var(--font-family-demi-bold) !important;
    }
  }
  @media (width >= 48rem) {
    :is(.md\\:\\*\\*\\:font-\\(--font-weight-demi-bold\\)\\! *) {
      --tw-font-weight: var(--font-weight-demi-bold) !important;
      font-weight: var(--font-weight-demi-bold) !important;
    }
  }
  @media (width >= 48rem) {
    .first\\:md\\:mt-10:first-child {
      margin-top: calc(var(--spacing) * 10);
    }
  }
  @media (width >= 48rem) {
    @media (hover: hover) {
      .md\\:hover\\:font-bold:hover {
        --tw-font-weight: var(--weight-bold);
        font-weight: var(--weight-bold);
      }
    }
  }
  @media (width >= 64rem) {
    .lg\\:block {
      display: block;
    }
  }
  @media (width >= 64rem) {
    .lg\\:grid {
      display: grid;
    }
  }
  @media (width >= 64rem) {
    .lg\\:grid-cols-\\[10rem_minmax\\(0\\,1fr\\)_minmax\\(16rem\\,0\\.48fr\\)\\] {
      grid-template-columns: 10rem minmax(0,1fr) minmax(16rem,0.48fr);
    }
  }
  @media (width >= 64rem) {
    .lg\\:items-center {
      align-items: center;
    }
  }
  @media (width >= 64rem) {
    .lg\\:gap-5 {
      gap: calc(var(--spacing) * 5);
    }
  }
  @media (width >= 80rem) {
    .xl\\:hidden {
      display: none;
    }
  }
  @media (width >= 96rem) {
    .\\32 xl\\:block {
      display: block;
    }
  }
  .agfa\\:bg-background-brand-secondary-hover:where([data-label="agfa"] *) {
    background-color: var(--color-background-brand-secondary-hover);
  }
  .agfa\\:text-text-default-primary:where([data-label="agfa"] *) {
    color: var(--color-text-default-primary);
  }
  @media (hover: hover) {
    .agfa\\:group-hover\\/floating-action\\:bg-background-brand-secondary-hover:where([data-label="agfa"] *):is(:where(.group\\/floating-action):hover *) {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (hover: hover) {
    .agfa\\:group-hover\\/floating-action\\:text-icon-default-primary:where([data-label="agfa"] *):is(:where(.group\\/floating-action):hover *) {
      color: var(--color-icon-default-primary);
    }
  }
  @media (hover: hover) {
    .agfa\\:group-hover\\/floating-action\\:text-text-default-primary:where([data-label="agfa"] *):is(:where(.group\\/floating-action):hover *) {
      color: var(--color-text-default-primary);
    }
  }
  @media (hover: hover) {
    .agfa\\:hover\\:bg-background-brand-secondary-hover:where([data-label="agfa"] *):hover {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (hover: hover) {
    .agfa\\:hover\\:text-text-default-primary:where([data-label="agfa"] *):hover {
      color: var(--color-text-default-primary);
    }
  }
  .agfa\\:enabled\\:border-border-neutral-border-5:where([data-label="agfa"] *):enabled {
    border-color: var(--color-border-neutral-border-5);
  }
  .agfa\\:enabled\\:bg-background-brand-secondary:where([data-label="agfa"] *):enabled {
    background-color: var(--color-background-brand-secondary);
  }
  .agfa\\:enabled\\:bg-background-brand-secondary-focus:where([data-label="agfa"] *):enabled {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .agfa\\:enabled\\:bg-background-brand-secondary-hover:where([data-label="agfa"] *):enabled {
    background-color: var(--color-background-brand-secondary-hover);
  }
  .agfa\\:enabled\\:bg-background-brand-secondary-pressed:where([data-label="agfa"] *):enabled {
    background-color: var(--color-background-brand-secondary-pressed);
  }
  .agfa\\:enabled\\:text-icon-default-primary:where([data-label="agfa"] *):enabled {
    color: var(--color-icon-default-primary);
  }
  .agfa\\:enabled\\:text-text-default-primary:where([data-label="agfa"] *):enabled {
    color: var(--color-text-default-primary);
  }
  .agfa\\:enabled\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-3\\)\\]:where([data-label="agfa"] *):enabled {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .agfa\\:enabled\\:active\\:border-border-neutral-border-5:where([data-label="agfa"] *):enabled:active {
    border-color: var(--color-border-neutral-border-5);
  }
  .agfa\\:enabled\\:active\\:bg-background-brand-secondary-pressed:where([data-label="agfa"] *):enabled:active {
    background-color: var(--color-background-brand-secondary-pressed);
  }
  .agfa\\:enabled\\:active\\:text-icon-default-primary:where([data-label="agfa"] *):enabled:active {
    color: var(--color-icon-default-primary);
  }
  .agfa\\:enabled\\:active\\:text-text-default-primary:where([data-label="agfa"] *):enabled:active {
    color: var(--color-text-default-primary);
  }
  .brandon\\:bg-background-surface-fill-2:where([data-label="brandon"] *) {
    background-color: var(--color-background-surface-fill-2);
  }
  .brandon\\:text-text-brand-secondary:where([data-label="brandon"] *) {
    color: var(--color-text-brand-secondary);
  }
  @media (hover: hover) {
    .brandon\\:group-hover\\/floating-action\\:bg-background-surface-fill-2:where([data-label="brandon"] *):is(:where(.group\\/floating-action):hover *) {
      background-color: var(--color-background-surface-fill-2);
    }
  }
  @media (hover: hover) {
    .brandon\\:group-hover\\/floating-action\\:text-icon-brand-secondary:where([data-label="brandon"] *):is(:where(.group\\/floating-action):hover *) {
      color: var(--color-icon-brand-secondary);
    }
  }
  @media (hover: hover) {
    .brandon\\:group-hover\\/floating-action\\:text-text-brand-secondary:where([data-label="brandon"] *):is(:where(.group\\/floating-action):hover *) {
      color: var(--color-text-brand-secondary);
    }
  }
  @media (hover: hover) {
    .brandon\\:hover\\:bg-background-surface-fill-2:where([data-label="brandon"] *):hover {
      background-color: var(--color-background-surface-fill-2);
    }
  }
  @media (hover: hover) {
    .brandon\\:hover\\:text-text-brand-secondary:where([data-label="brandon"] *):hover {
      color: var(--color-text-brand-secondary);
    }
  }
  .brandon\\:enabled\\:border-background-brand-secondary:where([data-label="brandon"] *):enabled {
    border-color: var(--color-background-brand-secondary);
  }
  .brandon\\:enabled\\:border-background-brand-secondary-focus:where([data-label="brandon"] *):enabled {
    border-color: var(--color-background-brand-secondary-focus);
  }
  .brandon\\:enabled\\:border-background-brand-secondary-hover:where([data-label="brandon"] *):enabled {
    border-color: var(--color-background-brand-secondary-hover);
  }
  .brandon\\:enabled\\:border-background-brand-secondary-pressed:where([data-label="brandon"] *):enabled {
    border-color: var(--color-background-brand-secondary-pressed);
  }
  .brandon\\:enabled\\:bg-background-surface-fill-2:where([data-label="brandon"] *):enabled {
    background-color: var(--color-background-surface-fill-2);
  }
  .brandon\\:enabled\\:text-background-brand-secondary-focus:where([data-label="brandon"] *):enabled {
    color: var(--color-background-brand-secondary-focus);
  }
  .brandon\\:enabled\\:text-background-brand-secondary-hover:where([data-label="brandon"] *):enabled {
    color: var(--color-background-brand-secondary-hover);
  }
  .brandon\\:enabled\\:text-background-brand-secondary-pressed:where([data-label="brandon"] *):enabled {
    color: var(--color-background-brand-secondary-pressed);
  }
  .brandon\\:enabled\\:text-icon-brand-secondary:where([data-label="brandon"] *):enabled {
    color: var(--color-icon-brand-secondary);
  }
  .brandon\\:enabled\\:text-text-brand-secondary:where([data-label="brandon"] *):enabled {
    color: var(--color-text-brand-secondary);
  }
  .brandon\\:enabled\\:active\\:border-background-brand-secondary-pressed:where([data-label="brandon"] *):enabled:active {
    border-color: var(--color-background-brand-secondary-pressed);
  }
  .brandon\\:enabled\\:active\\:bg-background-surface-fill-2:where([data-label="brandon"] *):enabled:active {
    background-color: var(--color-background-surface-fill-2);
  }
  .brandon\\:enabled\\:active\\:text-background-brand-secondary-pressed:where([data-label="brandon"] *):enabled:active {
    color: var(--color-background-brand-secondary-pressed);
  }
  .helloprint\\:enabled\\:border-border-brand-primary:where([data-label="helloprint"] *):enabled {
    border-color: var(--color-border-brand-primary);
  }
  .helloprint\\:enabled\\:border-border-brand-primary-focus:where([data-label="helloprint"] *):enabled {
    border-color: var(--color-border-brand-primary-focus);
  }
  .helloprint\\:enabled\\:border-border-brand-primary-hover:where([data-label="helloprint"] *):enabled {
    border-color: var(--color-border-brand-primary-hover);
  }
  .helloprint\\:enabled\\:border-border-brand-primary-pressed:where([data-label="helloprint"] *):enabled {
    border-color: var(--color-border-brand-primary-pressed);
  }
  .helloprint\\:enabled\\:bg-background-brand-secondary:where([data-label="helloprint"] *):enabled {
    background-color: var(--color-background-brand-secondary);
  }
  .helloprint\\:enabled\\:bg-background-brand-secondary-focus:where([data-label="helloprint"] *):enabled {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .helloprint\\:enabled\\:bg-background-brand-secondary-hover:where([data-label="helloprint"] *):enabled {
    background-color: var(--color-background-brand-secondary-hover);
  }
  .helloprint\\:enabled\\:bg-background-brand-secondary-pressed:where([data-label="helloprint"] *):enabled {
    background-color: var(--color-background-brand-secondary-pressed);
  }
  .helloprint\\:enabled\\:text-icon-brand-primary:where([data-label="helloprint"] *):enabled {
    color: var(--color-icon-brand-primary);
  }
  .helloprint\\:enabled\\:text-icon-default-primary:where([data-label="helloprint"] *):enabled {
    color: var(--color-icon-default-primary);
  }
  .helloprint\\:enabled\\:text-text-brand-primary:where([data-label="helloprint"] *):enabled {
    color: var(--color-text-brand-primary);
  }
  .helloprint\\:enabled\\:text-text-default-primary:where([data-label="helloprint"] *):enabled {
    color: var(--color-text-default-primary);
  }
  .helloprint\\:enabled\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="helloprint"] *):enabled {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .helloprint\\:enabled\\:active\\:border-border-brand-primary-pressed:where([data-label="helloprint"] *):enabled:active {
    border-color: var(--color-border-brand-primary-pressed);
  }
  .helloprint\\:enabled\\:active\\:bg-background-brand-secondary-pressed:where([data-label="helloprint"] *):enabled:active {
    background-color: var(--color-background-brand-secondary-pressed);
  }
  .helloprint\\:enabled\\:active\\:text-icon-brand-primary:where([data-label="helloprint"] *):enabled:active {
    color: var(--color-icon-brand-primary);
  }
  .helloprint\\:enabled\\:active\\:text-text-brand-primary:where([data-label="helloprint"] *):enabled:active {
    color: var(--color-text-brand-primary);
  }
  .hema\\:border-\\(--primitive-color-accent-8a\\):where([data-label="hema"] *) {
    border-color: var(--primitive-color-accent-8a);
  }
  .hema\\:border-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *) {
    border-color: var(--primitive-color-accent-8b);
  }
  .hema\\:border-background-surface-disabled:where([data-label="hema"] *) {
    border-color: var(--color-background-surface-disabled);
  }
  .hema\\:bg-\\(--primitive-color-accent-8a\\):where([data-label="hema"] *) {
    background-color: var(--primitive-color-accent-8a);
  }
  .hema\\:bg-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *) {
    background-color: var(--primitive-color-accent-8b);
  }
  .hema\\:bg-background-surface-disabled:where([data-label="hema"] *) {
    background-color: var(--color-background-surface-disabled);
  }
  .hema\\:py-control-md:where([data-label="hema"] *) {
    padding-block: var(--space-control-y-md);
  }
  .hema\\:font-\\(family-name\\:--font-family-bold\\):where([data-label="hema"] *) {
    font-family: var(--font-family-bold);
  }
  .hema\\:font-\\(--font-weight-bold\\):where([data-label="hema"] *) {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .hema\\:text-text-default-disabled:where([data-label="hema"] *) {
    color: var(--color-text-default-disabled);
  }
  .hema\\:text-text-default-primary:where([data-label="hema"] *) {
    color: var(--color-text-default-primary);
  }
  .hema\\:lowercase:where([data-label="hema"] *) {
    text-transform: lowercase;
  }
  .hema\\:normal-case:where([data-label="hema"] *) {
    text-transform: none;
  }
  .hema\\:enabled\\:border-border-neutral-border-5:where([data-label="hema"] *):enabled {
    border-color: var(--color-border-neutral-border-5);
  }
  .hema\\:enabled\\:bg-background-surface-fill-2:where([data-label="hema"] *):enabled {
    background-color: var(--color-background-surface-fill-2);
  }
  .hema\\:enabled\\:text-icon-default-primary:where([data-label="hema"] *):enabled {
    color: var(--color-icon-default-primary);
  }
  .hema\\:enabled\\:text-text-default-primary:where([data-label="hema"] *):enabled {
    color: var(--color-text-default-primary);
  }
  .hema\\:enabled\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="hema"] *):enabled {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .hema\\:enabled\\:focus-visible\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="hema"] *):enabled:focus-visible {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .hema\\:enabled\\:active\\:border-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *):enabled:active {
    border-color: var(--primitive-color-accent-8b);
  }
  .hema\\:enabled\\:active\\:border-border-neutral-border-5:where([data-label="hema"] *):enabled:active {
    border-color: var(--color-border-neutral-border-5);
  }
  .hema\\:enabled\\:active\\:bg-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *):enabled:active {
    background-color: var(--primitive-color-accent-8b);
  }
  .hema\\:enabled\\:active\\:bg-background-surface-fill-2:where([data-label="hema"] *):enabled:active {
    background-color: var(--color-background-surface-fill-2);
  }
  .hema\\:enabled\\:active\\:text-icon-default-primary:where([data-label="hema"] *):enabled:active {
    color: var(--color-icon-default-primary);
  }
  .hema\\:enabled\\:active\\:text-text-default-primary:where([data-label="hema"] *):enabled:active {
    color: var(--color-text-default-primary);
  }
  .safsira\\:enabled\\:border-border-brand-primary:where([data-label="safsira"] *):enabled {
    border-color: var(--color-border-brand-primary);
  }
  .safsira\\:enabled\\:border-border-brand-primary-focus:where([data-label="safsira"] *):enabled {
    border-color: var(--color-border-brand-primary-focus);
  }
  .safsira\\:enabled\\:border-border-brand-primary-hover:where([data-label="safsira"] *):enabled {
    border-color: var(--color-border-brand-primary-hover);
  }
  .safsira\\:enabled\\:border-border-brand-primary-pressed:where([data-label="safsira"] *):enabled {
    border-color: var(--color-border-brand-primary-pressed);
  }
  .safsira\\:enabled\\:bg-background-brand-secondary:where([data-label="safsira"] *):enabled {
    background-color: var(--color-background-brand-secondary);
  }
  .safsira\\:enabled\\:bg-background-brand-secondary-focus:where([data-label="safsira"] *):enabled {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .safsira\\:enabled\\:bg-background-brand-secondary-hover:where([data-label="safsira"] *):enabled {
    background-color: var(--color-background-brand-secondary-hover);
  }
  .safsira\\:enabled\\:bg-background-brand-secondary-pressed:where([data-label="safsira"] *):enabled {
    background-color: var(--color-background-brand-secondary-pressed);
  }
  .safsira\\:enabled\\:text-icon-brand-primary:where([data-label="safsira"] *):enabled {
    color: var(--color-icon-brand-primary);
  }
  .safsira\\:enabled\\:text-text-brand-primary:where([data-label="safsira"] *):enabled {
    color: var(--color-text-brand-primary);
  }
  .safsira\\:enabled\\:text-text-brand-primary-focus:where([data-label="safsira"] *):enabled {
    color: var(--color-text-brand-primary-focus);
  }
  .safsira\\:enabled\\:text-text-brand-primary-hover:where([data-label="safsira"] *):enabled {
    color: var(--color-text-brand-primary-hover);
  }
  .safsira\\:enabled\\:text-text-brand-primary-pressed:where([data-label="safsira"] *):enabled {
    color: var(--color-text-brand-primary-pressed);
  }
  .safsira\\:enabled\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-3\\)\\]:where([data-label="safsira"] *):enabled {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .safsira\\:enabled\\:active\\:border-border-brand-primary-pressed:where([data-label="safsira"] *):enabled:active {
    border-color: var(--color-border-brand-primary-pressed);
  }
  .safsira\\:enabled\\:active\\:bg-background-brand-secondary-pressed:where([data-label="safsira"] *):enabled:active {
    background-color: var(--color-background-brand-secondary-pressed);
  }
  .safsira\\:enabled\\:active\\:text-text-brand-primary-pressed:where([data-label="safsira"] *):enabled:active {
    color: var(--color-text-brand-primary-pressed);
  }
  .yoursurprise\\:bg-background-brand-secondary-hover:where([data-label="yoursurprise"] *) {
    background-color: var(--color-background-brand-secondary-hover);
  }
  .yoursurprise\\:text-text-default-tertiary:where([data-label="yoursurprise"] *) {
    color: var(--color-text-default-tertiary);
  }
  @media (hover: hover) {
    .yoursurprise\\:group-hover\\/floating-action\\:bg-background-brand-secondary-hover:where([data-label="yoursurprise"] *):is(:where(.group\\/floating-action):hover *) {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (hover: hover) {
    .yoursurprise\\:group-hover\\/floating-action\\:text-icon-default-tertiary:where([data-label="yoursurprise"] *):is(:where(.group\\/floating-action):hover *) {
      color: var(--color-icon-default-tertiary);
    }
  }
  @media (hover: hover) {
    .yoursurprise\\:group-hover\\/floating-action\\:text-text-default-tertiary:where([data-label="yoursurprise"] *):is(:where(.group\\/floating-action):hover *) {
      color: var(--color-text-default-tertiary);
    }
  }
  @media (hover: hover) {
    .yoursurprise\\:hover\\:bg-background-brand-secondary-hover:where([data-label="yoursurprise"] *):hover {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (hover: hover) {
    .yoursurprise\\:hover\\:text-text-default-tertiary:where([data-label="yoursurprise"] *):hover {
      color: var(--color-text-default-tertiary);
    }
  }
  .yoursurprise\\:enabled\\:border-border-neutral-border-2:where([data-label="yoursurprise"] *):enabled {
    border-color: var(--color-border-neutral-border-2);
  }
  .yoursurprise\\:enabled\\:border-border-neutral-border-3:where([data-label="yoursurprise"] *):enabled {
    border-color: var(--color-border-neutral-border-3);
  }
  .yoursurprise\\:enabled\\:bg-background-brand-secondary:where([data-label="yoursurprise"] *):enabled {
    background-color: var(--color-background-brand-secondary);
  }
  .yoursurprise\\:enabled\\:bg-background-brand-secondary-focus:where([data-label="yoursurprise"] *):enabled {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .yoursurprise\\:enabled\\:bg-background-brand-secondary-hover:where([data-label="yoursurprise"] *):enabled {
    background-color: var(--color-background-brand-secondary-hover);
  }
  .yoursurprise\\:enabled\\:text-icon-default-tertiary:where([data-label="yoursurprise"] *):enabled {
    color: var(--color-icon-default-tertiary);
  }
  .yoursurprise\\:enabled\\:text-text-default-tertiary:where([data-label="yoursurprise"] *):enabled {
    color: var(--color-text-default-tertiary);
  }
  .yoursurprise\\:enabled\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="yoursurprise"] *):enabled {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .yoursurprise\\:enabled\\:active\\:border-border-neutral-border-3:where([data-label="yoursurprise"] *):enabled:active {
    border-color: var(--color-border-neutral-border-3);
  }
  .yoursurprise\\:enabled\\:active\\:bg-background-brand-secondary-focus:where([data-label="yoursurprise"] *):enabled:active {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .yoursurprise\\:enabled\\:active\\:text-icon-default-tertiary:where([data-label="yoursurprise"] *):enabled:active {
    color: var(--color-icon-default-tertiary);
  }
  .yoursurprise\\:enabled\\:active\\:text-text-default-tertiary:where([data-label="yoursurprise"] *):enabled:active {
    color: var(--color-text-default-tertiary);
  }
  @media (width <= 767px) and (min-height: 701px) {
    .max-sm-tall\\:grid {
      display: grid;
    }
  }
  @media (width <= 767px) and (max-height: 700px) {
    .max-sm-small\\:hidden {
      display: none;
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.button-toggle-component\\]\\:h-35 .button-toggle-component {
      height: calc(var(--spacing) * 35);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.button-toggle-component\\]\\:w-35 .button-toggle-component {
      width: calc(var(--spacing) * 35);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.editor-layer-list-view\\]\\:\\[--editor-layer-list-view-button-toggle-width\\:var\\(--sub-options-max-width\\)\\] .editor-layer-list-view {
      --editor-layer-list-view-button-toggle-width: var(--sub-options-max-width);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.editor-object-selector-view_\\.button-toggle-component\\]\\:h-auto .editor-object-selector-view .button-toggle-component {
      height: auto;
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.editor-object-selector-view_\\.button-toggle-component\\]\\:w-\\(--sub-options-max-width\\) .editor-object-selector-view .button-toggle-component {
      width: var(--sub-options-max-width);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.editor-object-selector-view_\\.button-toggle-component\\]\\:items-start .editor-object-selector-view .button-toggle-component {
      align-items: flex-start;
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.editor-object-selector-view_\\.button-toggle-component\\]\\:\\[--button-toggle-component-padding-y\\:var\\(--space-md\\)\\] .editor-object-selector-view .button-toggle-component {
      --button-toggle-component-padding-y: var(--space-md);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&_\\.editor-theme-selector-view\\]\\:max-h-full .editor-theme-selector-view {
      max-height: 100%;
    }
  }
  .\\[\\&_\\.project-top-toolbar-view-container\\]\\:max-w-\\(--overview-book-top-toolbar-max-width\\) .project-top-toolbar-view-container {
    max-width: var(--overview-book-top-toolbar-max-width);
  }
  .\\[\\&_\\.project-top-toolbar-view-container\\]\\:px-10 .project-top-toolbar-view-container {
    padding-inline: calc(var(--spacing) * 10);
  }
  .\\[\\&_\\.project-top-toolbar-view-container\\]\\:py-6 .project-top-toolbar-view-container {
    padding-block: calc(var(--spacing) * 6);
  }
  .\\[\\&_\\.project-top-toolbar-view-right-container_\\.divider\\.full\\]\\:mr-2 .project-top-toolbar-view-right-container .divider.full {
    margin-right: calc(var(--spacing) * 2);
  }
  .\\[\\&_\\[data-typography-variant\\=\\'body1\\'\\]\\]\\:mr-0 [data-typography-variant='body1'] {
    margin-right: calc(var(--spacing) * 0);
  }
  .\\[\\&\\.button-toggle-component-checked\\]\\:border-2\\!.button-toggle-component-checked {
    border-style: var(--tw-border-style) !important;
    border-width: 2px !important;
  }
  .\\[\\&\\.button-toggle-component-checked\\]\\:bg-transparent\\!.button-toggle-component-checked {
    background-color: transparent !important;
  }
  :is(.\\*\\*\\:\\[\\&\\.editor-canvas-view\\]\\:overflow-hidden\\! *).editor-canvas-view {
    overflow: hidden !important;
  }
  :is(.\\*\\*\\:\\[\\&\\.editor-canvas-view\\]\\:rounded-\\(--page-pair-border-radius\\) *).editor-canvas-view {
    border-radius: var(--page-pair-border-radius);
  }
  .\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
    display: none;
  }
  @media (width < 48rem) {
    .max-md\\:\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
      display: none;
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
      display: none;
    }
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:active\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="hema"] *):enabled:focus-visible:active {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border:enabled:focus-visible:not(:active) {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-0:enabled:focus-visible:not(:active) {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-2:enabled:focus-visible:not(:active) {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-border-brand-primary-focus:enabled:focus-visible:not(:active) {
    border-color: var(--color-border-brand-primary-focus);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-brand-accent-fill-1:enabled:focus-visible:not(:active) {
    background-color: var(--color-background-brand-accent-fill-1);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-brand-primary-focus:enabled:focus-visible:not(:active) {
    background-color: var(--color-background-brand-primary-focus);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-icon-brand-primary-focus:enabled:focus-visible:not(:active) {
    color: var(--color-icon-brand-primary-focus);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-text-brand-primary-focus:enabled:focus-visible:not(:active) {
    color: var(--color-text-brand-primary-focus);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_1px_var\\(--color-border-brand-primary-focus\\)\\]:enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 1px var(--tw-shadow-color, var(--color-border-brand-primary-focus));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_1px_var\\(--color-border-neutral-border-1\\)\\]:enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 1px var(--tw-shadow-color, var(--color-border-neutral-border-1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-border-neutral-border-1\\)\\]:enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-border-neutral-border-1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:outline-none:enabled:focus-visible:not(:active) {
    --tw-outline-style: none;
    outline-style: none;
  }
  .agfa\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-border-neutral-border-5:where([data-label="agfa"] *):enabled:focus-visible:not(:active) {
    border-color: var(--color-border-neutral-border-5);
  }
  .agfa\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-focus:where([data-label="agfa"] *):enabled:focus-visible:not(:active) {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .agfa\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-icon-default-primary:where([data-label="agfa"] *):enabled:focus-visible:not(:active) {
    color: var(--color-icon-default-primary);
  }
  .agfa\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-text-default-primary:where([data-label="agfa"] *):enabled:focus-visible:not(:active) {
    color: var(--color-text-default-primary);
  }
  .agfa\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-3\\)\\]:where([data-label="agfa"] *):enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .brandon\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-background-brand-secondary-focus:where([data-label="brandon"] *):enabled:focus-visible:not(:active) {
    border-color: var(--color-background-brand-secondary-focus);
  }
  .brandon\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-surface-fill-2:where([data-label="brandon"] *):enabled:focus-visible:not(:active) {
    background-color: var(--color-background-surface-fill-2);
  }
  .brandon\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-background-brand-secondary-focus:where([data-label="brandon"] *):enabled:focus-visible:not(:active) {
    color: var(--color-background-brand-secondary-focus);
  }
  .helloprint\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-border-brand-primary-focus:where([data-label="helloprint"] *):enabled:focus-visible:not(:active) {
    border-color: var(--color-border-brand-primary-focus);
  }
  .helloprint\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-focus:where([data-label="helloprint"] *):enabled:focus-visible:not(:active) {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .helloprint\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-icon-default-primary:where([data-label="helloprint"] *):enabled:focus-visible:not(:active) {
    color: var(--color-icon-default-primary);
  }
  .helloprint\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-text-default-primary:where([data-label="helloprint"] *):enabled:focus-visible:not(:active) {
    color: var(--color-text-default-primary);
  }
  .helloprint\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="helloprint"] *):enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    border-color: var(--primitive-color-accent-8b);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-border-neutral-border-5:where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    border-color: var(--color-border-neutral-border-5);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    background-color: var(--primitive-color-accent-8b);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-surface-fill-2:where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    background-color: var(--color-background-surface-fill-2);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-icon-default-primary:where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    color: var(--color-icon-default-primary);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-text-default-primary:where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    color: var(--color-text-default-primary);
  }
  .hema\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="hema"] *):enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .safsira\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-border-brand-primary-focus:where([data-label="safsira"] *):enabled:focus-visible:not(:active) {
    border-color: var(--color-border-brand-primary-focus);
  }
  .safsira\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-focus:where([data-label="safsira"] *):enabled:focus-visible:not(:active) {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .safsira\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-text-brand-primary-focus:where([data-label="safsira"] *):enabled:focus-visible:not(:active) {
    color: var(--color-text-brand-primary-focus);
  }
  .safsira\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-3\\)\\]:where([data-label="safsira"] *):enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .yoursurprise\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:border-border-neutral-border-3:where([data-label="yoursurprise"] *):enabled:focus-visible:not(:active) {
    border-color: var(--color-border-neutral-border-3);
  }
  .yoursurprise\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-focus:where([data-label="yoursurprise"] *):enabled:focus-visible:not(:active) {
    background-color: var(--color-background-brand-secondary-focus);
  }
  .yoursurprise\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-icon-default-tertiary:where([data-label="yoursurprise"] *):enabled:focus-visible:not(:active) {
    color: var(--color-icon-default-tertiary);
  }
  .yoursurprise\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:text-text-default-tertiary:where([data-label="yoursurprise"] *):enabled:focus-visible:not(:active) {
    color: var(--color-text-default-tertiary);
  }
  .yoursurprise\\:enabled\\:\\[\\&\\:focus-visible\\:not\\(\\:active\\)\\]\\:shadow-\\[inset_0_0_0_2px_var\\(--color-background-surface-fill-4\\)\\]:where([data-label="yoursurprise"] *):enabled:focus-visible:not(:active) {
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-background-surface-fill-4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  @media (width >= 48rem) {
    .md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-border-brand-primary-hover:enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-border-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-brand-accent-fill-1:enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-brand-accent-fill-1);
    }
  }
  @media (width >= 48rem) {
    .md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-brand-primary-hover:enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-icon-brand-primary-hover:enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-icon-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-text-brand-primary-hover:enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-text-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .agfa\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-border-neutral-border-5:where([data-label="agfa"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-border-neutral-border-5);
    }
  }
  @media (width >= 48rem) {
    .agfa\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-hover:where([data-label="agfa"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (width >= 48rem) {
    .agfa\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-icon-default-primary:where([data-label="agfa"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-icon-default-primary);
    }
  }
  @media (width >= 48rem) {
    .agfa\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-text-default-primary:where([data-label="agfa"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-text-default-primary);
    }
  }
  @media (width >= 48rem) {
    .brandon\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-background-brand-secondary-hover:where([data-label="brandon"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (width >= 48rem) {
    .brandon\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-surface-fill-2:where([data-label="brandon"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-surface-fill-2);
    }
  }
  @media (width >= 48rem) {
    .brandon\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-background-brand-secondary-hover:where([data-label="brandon"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (width >= 48rem) {
    .helloprint\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-border-brand-primary-hover:where([data-label="helloprint"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-border-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .helloprint\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-hover:where([data-label="helloprint"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (width >= 48rem) {
    .helloprint\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-icon-default-primary:where([data-label="helloprint"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-icon-default-primary);
    }
  }
  @media (width >= 48rem) {
    .helloprint\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-text-default-primary:where([data-label="helloprint"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-text-default-primary);
    }
  }
  @media (width >= 48rem) {
    .hema\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--primitive-color-accent-8b);
    }
  }
  @media (width >= 48rem) {
    .hema\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-border-neutral-border-5:where([data-label="hema"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-border-neutral-border-5);
    }
  }
  @media (width >= 48rem) {
    .hema\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-\\(--primitive-color-accent-8b\\):where([data-label="hema"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--primitive-color-accent-8b);
    }
  }
  @media (width >= 48rem) {
    .hema\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-surface-fill-2:where([data-label="hema"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-surface-fill-2);
    }
  }
  @media (width >= 48rem) {
    .hema\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-icon-default-primary:where([data-label="hema"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-icon-default-primary);
    }
  }
  @media (width >= 48rem) {
    .hema\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-text-default-primary:where([data-label="hema"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-text-default-primary);
    }
  }
  @media (width >= 48rem) {
    .safsira\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-border-brand-primary-hover:where([data-label="safsira"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-border-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .safsira\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-hover:where([data-label="safsira"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (width >= 48rem) {
    .safsira\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-text-brand-primary-hover:where([data-label="safsira"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-text-brand-primary-hover);
    }
  }
  @media (width >= 48rem) {
    .yoursurprise\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:border-border-neutral-border-3:where([data-label="yoursurprise"] *):enabled:hover:not(:focus-visible):not(:active) {
      border-color: var(--color-border-neutral-border-3);
    }
  }
  @media (width >= 48rem) {
    .yoursurprise\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:bg-background-brand-secondary-hover:where([data-label="yoursurprise"] *):enabled:hover:not(:focus-visible):not(:active) {
      background-color: var(--color-background-brand-secondary-hover);
    }
  }
  @media (width >= 48rem) {
    .yoursurprise\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-icon-default-tertiary:where([data-label="yoursurprise"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-icon-default-tertiary);
    }
  }
  @media (width >= 48rem) {
    .yoursurprise\\:md\\:enabled\\:\\[\\&\\:hover\\:not\\(\\:focus-visible\\)\\:not\\(\\:active\\)\\]\\:text-text-default-tertiary:where([data-label="yoursurprise"] *):enabled:hover:not(:focus-visible):not(:active) {
      color: var(--color-text-default-tertiary);
    }
  }
  .\\[\\&\\:is\\(\\.button-toggle-component-checked\\,\\:hover\\)\\]\\:border-solid\\!:is(.button-toggle-component-checked,:hover) {
    --tw-border-style: solid !important;
    border-style: solid !important;
  }
  .\\[\\&\\:is\\(\\.button-toggle-component-checked\\,\\:hover\\)\\]\\:border-\\(--background-primary-inverse\\)\\!:is(.button-toggle-component-checked,:hover) {
    border-color: var(--background-primary-inverse) !important;
  }
  :is(.\\*\\*\\:\\[\\.button-toggle-component-label\\]\\:font-\\(family-name\\:--font-family-bold\\)\\! *):is(.button-toggle-component-label) {
    font-family: var(--font-family-bold) !important;
  }
  :is(.\\*\\*\\:\\[\\.button-toggle-component-label\\]\\:text-\\(length\\:--font-size-s\\)\\! *):is(.button-toggle-component-label) {
    font-size: var(--font-size-s) !important;
  }
  :is(.\\*\\*\\:\\[\\.button-toggle-component-label\\]\\:font-\\(--font-weight-bold\\)\\! *):is(.button-toggle-component-label) {
    --tw-font-weight: var(--font-weight-bold) !important;
    font-weight: var(--font-weight-bold) !important;
  }
  :is(.\\*\\*\\:\\[\\.button-toggle-component-label\\]\\:text-\\(--font-primary\\)\\! *):is(.button-toggle-component-label) {
    color: var(--font-primary) !important;
  }
  :is(.\\*\\*\\:\\[\\.dialog-modal\\]\\:bg-black\\/40 *):is(.dialog-modal) {
    background-color: color-mix(in srgb, #000 40%, transparent);
  }
  @supports (color: color-mix(in lab, red, red)) {
    :is(.\\*\\*\\:\\[\\.dialog-modal\\]\\:bg-black\\/40 *):is(.dialog-modal) {
      background-color: color-mix(in oklab, var(--color-black) 40%, transparent);
    }
  }
  .\\[data-tool-id\\]\\:visible:is(data-tool-id) {
    visibility: visible;
  }
  :is(.\\*\\*\\:\\[header\\]\\:box-border *):is(header) {
    box-sizing: border-box;
  }
  :is(.\\*\\*\\:\\[header\\]\\:shrink-0 *):is(header) {
    flex-shrink: 0;
  }
  :is(.\\*\\*\\:\\[header\\]\\:items-center *):is(header) {
    align-items: center;
  }
  :is(.\\*\\*\\:\\[header\\]\\:border-b *):is(header) {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  :is(.\\*\\*\\:\\[header\\]\\:border-\\(--neutral1-borders-and-stroke\\) *):is(header) {
    border-color: var(--neutral1-borders-and-stroke);
  }
  :is(.\\*\\*\\:\\[header\\]\\:px-6 *):is(header) {
    padding-inline: calc(var(--spacing) * 6);
  }
  :is(.\\*\\*\\:\\[header\\]\\:py-5 *):is(header) {
    padding-block: calc(var(--spacing) * 5);
  }
  :is(.\\*\\*\\:\\[header\\]\\:pb-5 *):is(header) {
    padding-bottom: calc(var(--spacing) * 5);
  }
  :is(.\\*\\*\\:\\[img\\]\\:w-auto *):is(img) {
    width: auto;
  }
  :is(.\\*\\*\\:\\[img\\]\\:max-w-full *):is(img) {
    max-width: 100%;
  }
  :is(.\\*\\*\\:\\[img\\]\\:object-contain *):is(img) {
    object-fit: contain;
  }
  :is(.\\*\\*\\:\\[main\\]\\:m-0 *):is(main) {
    margin: calc(var(--spacing) * 0);
  }
  :is(.\\*\\*\\:\\[main\\]\\:box-border *):is(main) {
    box-sizing: border-box;
  }
  :is(.\\*\\*\\:\\[main\\]\\:p-6 *):is(main) {
    padding: calc(var(--spacing) * 6);
  }
  :is(.\\*\\*\\:\\[main\\]\\:whitespace-normal *):is(main) {
    white-space: normal;
  }
  :is(.\\*\\*\\:\\[svg\\]\\:aspect-square *):is(svg) {
    aspect-ratio: 1 / 1;
  }
  :is(.\\*\\*\\:\\[svg\\]\\:w-full *):is(svg) {
    width: 100%;
  }
  :is(.\\*\\*\\:\\[svg\\,img\\]\\:h-full *):is(svg,img) {
    height: 100%;
  }
  .\\[\\&\\>\\.before\\,\\.after\\,\\.full\\]\\:bg-\\[url\\(\\~root\\/img\\/colors\\/transparent\\.svg\\)\\]>.before,.\\[\\&\\>\\.before\\,\\.after\\,\\.full\\]\\:bg-\\[url\\(\\~root\\/img\\/colors\\/transparent\\.svg\\)\\] .after,.\\[\\&\\>\\.before\\,\\.after\\,\\.full\\]\\:bg-\\[url\\(\\~root\\/img\\/colors\\/transparent\\.svg\\)\\] .full {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .\\[\\&\\>\\.before\\,\\.after\\,\\.full\\]\\:bg-size-\\[10\\%\\]>.before,.\\[\\&\\>\\.before\\,\\.after\\,\\.full\\]\\:bg-size-\\[10\\%\\] .after,.\\[\\&\\>\\.before\\,\\.after\\,\\.full\\]\\:bg-size-\\[10\\%\\] .full {
    background-size: 10%;
  }
  .\\[\\&\\>\\.grow\\]\\:p-space-lg>.grow {
    padding: var(--space-lg);
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&\\>\\.grow\\]\\:py-\\[11px\\]>.grow {
      padding-block: 11px;
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&\\>\\.grow\\]\\:pr-space-lg>.grow {
      padding-right: var(--space-lg);
    }
  }
  @media (width >= 48rem) {
    .md\\:\\[\\&\\>\\.grow\\]\\:pl-space-md>.grow {
      padding-left: var(--space-md);
    }
  }
  .\\[\\&\\>footer\\]\\:flex-col>footer {
    flex-direction: column;
  }
  .\\[\\&\\>header\\]\\:pb-6>header {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .\\[\\&\\>header\\>\\*\\]\\:min-w-0>header>* {
    min-width: calc(var(--spacing) * 0);
  }
  .\\[\\&\\>header\\>\\*\\]\\:flex-auto>header>* {
    flex: auto;
  }
  .\\[\\&\\>main\\]\\:my-0>main {
    margin-block: calc(var(--spacing) * 0);
  }
  .\\[\\&\\>main\\]\\:flex>main {
    display: flex;
  }
  .\\[\\&\\>main\\]\\:min-h-0>main {
    min-height: calc(var(--spacing) * 0);
  }
  .\\[\\&\\>main\\]\\:flex-1>main {
    flex: 1;
  }
  .\\[\\&\\>main\\]\\:flex-col>main {
    flex-direction: column;
  }
  .\\[\\&\\>main\\]\\:overflow-visible>main {
    overflow: visible;
  }
  .\\[\\&\\>main\\]\\:whitespace-normal>main {
    white-space: normal;
  }
  .\\[\\&\\>span\\]\\:text-red-500>span {
    color: var(--color-red-500);
  }
  .\\[\\&\\>svg\\]\\:block>svg {
    display: block;
  }
}
.font-heading {
  font-family: var(--font-heading);
}
.font-body {
  font-family: var(--font-body);
}
.font-body-demi {
  font-family: var(--font-body-demi);
}
.type-title-1 {
  font-size: var(--type-title-1-size);
  line-height: var(--type-title-1-leading);
  font-weight: var(--type-title-1-weight);
}
.type-title-2 {
  font-size: var(--type-title-2-size);
  line-height: var(--type-title-2-leading);
  font-weight: var(--type-title-2-weight);
}
.type-heading {
  font-size: var(--type-heading-size);
  line-height: var(--type-heading-leading);
  font-weight: var(--type-heading-weight);
}
.type-subtitle-1 {
  font-size: var(--type-subtitle-1-size);
  line-height: var(--type-subtitle-1-leading);
  font-weight: var(--type-subtitle-1-weight);
}
.type-h5 {
  font-size: var(--type-h5-size);
  line-height: var(--type-h5-leading);
  font-weight: var(--type-h5-weight);
}
.type-h6 {
  font-size: var(--type-h6-size);
  line-height: var(--type-h6-leading);
  font-weight: var(--type-h6-weight);
}
.type-subtitle {
  font-size: var(--type-subtitle-size);
  line-height: var(--type-subtitle-leading);
  font-weight: var(--type-subtitle-weight);
}
.type-subtitle-strong {
  font-size: var(--type-subtitle-strong-size);
  line-height: var(--type-subtitle-strong-leading);
  font-weight: var(--type-subtitle-strong-weight);
}
.type-body-1 {
  font-size: var(--type-body-1-size);
  line-height: var(--type-body-1-leading);
  font-weight: var(--type-body-1-weight);
}
.type-body-1-strong {
  font-size: var(--type-body-1-strong-size);
  line-height: var(--type-body-1-strong-leading);
  font-weight: var(--type-body-1-strong-weight);
}
.type-body-2 {
  font-size: var(--type-body-2-size);
  line-height: var(--type-body-2-leading);
  font-weight: var(--type-body-2-weight);
}
.type-body-2-emphasis {
  font-family: var(--type-body-2-emphasis-family);
  font-size: var(--type-body-2-emphasis-size);
  line-height: var(--type-body-2-emphasis-leading);
  font-weight: var(--type-body-2-emphasis-weight);
}
.type-link {
  font-size: var(--type-link-size);
  line-height: var(--type-link-leading);
  font-weight: var(--type-link-weight);
  text-decoration: underline;
}
.type-button {
  font-size: var(--type-button-label-size);
  line-height: var(--type-button-label-leading);
  font-weight: var(--type-button-label-weight);
}
.type-caption {
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-leading);
  font-weight: var(--type-caption-weight);
}
.type-caption-2 {
  font-size: var(--type-caption-2-size);
  line-height: var(--type-caption-2-leading);
  font-weight: var(--type-caption-2-weight);
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-pan-x {
  syntax: "*";
  inherits: false;
}
@property --tw-pan-y {
  syntax: "*";
  inherits: false;
}
@property --tw-pinch-zoom {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes wiggle {
  0%,
		100% {
    transform: rotate(1deg);
    transform-origin: 30% 5%;
  }
  50% {
    transform: rotate(-1.5deg);
    transform-origin: 30% 5%;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-pan-x: initial;
      --tw-pan-y: initial;
      --tw-pinch-zoom: initial;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-content: "";
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./../node_modules/tailwindcss/utilities.css","webpack://./css/tailwind.css","webpack://./../node_modules/tailwindcss/theme.css","webpack://./../packages/design-system/css/typography.css"],"names":[],"mappings":"AAAA,iEAAA;ACAA,iBAAmB;ACYnB,yCAA0C;AAC1C;ECbA;IAKE;aAEW;IAOX,0CAA0C;IAmQ1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAElB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IASvB,sBAAsB;IAStB,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IAKtC,gBAAgB;IAChB,0BAA0B;IAa1B,yBAAyB;IAEzB,2BAA2B;IDxP5B,sCAAuC;ICoQtC,qBAAqB;IA4BrB,6CAA6C;IAe7C,qCAAqC;IACrC,sCAAsC;IACtC,2CAA2C;IAE3C,uCAAuC;IAEvC,+DAA+D;IAoD/D,oCAAoC;IACpC,kEAAkE;IDzXnE,4CAA6C;IAG7C,kCAAmC;IASnC,4CAA6C;IAoB7C,mFAAoF;IACpF,mFAAoF;IACpF,mFAAoF;IACpF,uEAAwE;IACxE,mFAAoF;IACpF,mFAAoF;IACpF,uFAAwF;IACxF,2EAA4E;IAC5E,uFAAwF;IACxF,uFAAwF;IACxF,2FAA4F;IAC5F,uFAAwF;IACxF,2FAA4F;IAC5F,+EAAgF;IAChF,+EAAgF;IAChF,2EAA4E;IAC5E,2EAA4E;IAC5E,qFAAsF;IACtF,qFAAsF;IACtF,iFAAkF;IAClF,iFAAkF;IAClF,iFAAkF;IAClF,iFAAkF;IAClF,6EAA8E;IAC9E,yEAA0E;IAC1E,yEAA0E;IAC1E,yEAA0E;IAC1E,yEAA0E;IAC1E,yEAA0E;IAC1E,2EAA4E;IAE5E,+DAAgE;IAChE,2EAA4E;IAC5E,2EAA4E;IAC5E,+EAAgF;IAChF,qEAAsE;IACtE,qEAAsE;IACtE,qEAAsE;IACtE,qEAAsE;IACtE,qEAAsE;IACtE,qEAAsE;IACtE,mFAAoF;IAEpF,2DAA4D;IAC5D,uEAAwE;IACxE,uEAAwE;IACxE,2EAA4E;IAC5E,+DAAgE;IAChE,iEAAkE;IAClE,+DAAgE;IAChE,mEAAoE;IACpE,iEAAkE;IAClE,+DAAgE;IAChE,2DAA4D;IAC5D,iEAAkE;IAClE,iEAAkE;IAElE,2DAA4D;IAC5D,uEAAwE;IACxE,uEAAwE;IACxE,2EAA4E;IAC5E,+DAAgE;IAChE,iEAAkE;IAClE,+DAAgE;IAChE,mEAAoE;IACpE,iEAAkE;IAClE,+DAAgE;IAChE,2DAA4D;IAC5D,iEAAkE;IAClE,iEAAkE;IAElE,2FAA4F;IAC5F,2FAA4F;IAC5F,2FAA4F;IAC5F,2FAA4F;IAC5F,uFAAwF;IACxF,uFAAwF;IA0BxF,uCAAwC;IACxC,uCAAwC;IACxC,uCAAwC;IAOxC,qCAAsC;IACtC,yCAA0C;IAC1C,uCAAwC;IACxC,uCAAwC;IAaxC,qCAAsC;IACtC,yCAA0C;IAC1C,yCAA0C;IAC1C,yCAA0C;IAC1C,iCAAkC;ECtOpB;ADa8B;AAC7C;EDdA;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;ICwYkB,sBAAuB;EDxYtB;EAAnB;IC2YsB,0BAA2B;ED3Y9B;EAAnB;IC8YmB,uBAAwB;ED9YxB;EAAnB;IC6Y4B,gCAAiC;ED7Y1C;EAAnB;IC4YqB,yBAA0B;ED5Y5B;EAAnB;IC+YqB,yBAA0B;ED/Y5B;EAAnB;ICyYoB,wBAAyB;EDzY1B;EAAnB;IC0YoB,wBAAyB;ED1Y1B;EAAnB;ICgZmB,uBAAwB;EDhZxB;EAAnB;ICiZqB,yBAA0B;EDjZ5B;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;ICkfC,yEAA0E;IAC1E,mBAAoB;IACpB,eAAgB;IAChB,2CAA4C;IAC5C,SAAU;IACV,sDAA2C;IAC3C,oDAAyC;EDxfvB;EAAnB;IC4fC,yEAA0E;IAC1E,mBAAoB;IACpB,eAAgB;IAChB,4CAA6C;IAC7C,qDAA0C;IAC1C,sDAA2C;IAC3C,QAAS;EDlgBS;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,UAAmB;IAAnB,WAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IC6WwB,8BAA+B;ED7WpC;EAAnB;IC4WwB,8BAA+B;ED5WpC;EAAnB;IC2WwB,8BAA+B;ED3WpC;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IC0bC,mCAAoC;IACpC,oCAAqC;ED3bnB;EAAnB;IC8bC,2CAA4C;IAC5C,4CAA6C;ED/b3B;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;ICgX4B,kCAAmC;EDhX5C;EAAnB;IC+W4B,kCAAmC;ED/W5C;EAAnB;IC8W4B,kCAAmC;ED9W5C;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,wHAAmB;EAAA;EAAnB;IC6eC,wBAAyB;IACzB,qEAAsE;ED9epD;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,qEAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,kEAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;ICiYuB,6BAA8B;EDjYlC;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;ICkcC,yBAA0B;EDlcR;EAAnB;ICqcC,4BAA6B;EDrcX;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;ICmiBC,kDAA2C;EDniBzB;EAAnB;ICmiBC,uCAA2C;EDniBzB;EAAnB;ICmiBC,uCAA2C;EDniBzB;EAAnB;ICmiBC,uCAA2C;EDniBzB;EAAnB;ICmiBC,uCAA2C;EDniBzB;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IC0nBC,gBAAiB;ED1nBC;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;ICydC,gDAAiD;IACjD,8CAA+C;ED1d7B;EAAnB;IAAA,gDAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IC+iBC,iDAAqD;IAErD,+CAAmD;EDjjBjC;EAAnB;IC8dC,8CAA+C;IAC/C,4CAA6C;ED/d3B;EAAnB;IAAA,8CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,kDAAmB;EAAA;EAAnB;ICsjBC,gDAAoD;IAEpD,iDAAqD;EDxjBnC;EAAnB;ICmeC,6CAA8C;IAC9C,8CAA+C;EDpe7B;EAAnB;IAAA,6CAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;ICweC,iDAAkD;IAClD,gDAAiD;EDze/B;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+FAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA;MAAA,yFAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA;MAAA,oFAAmB;IAAA;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kGAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IC8XC,wCAAyC;IACzC,sCAAuC;ED/XrB;EAAnB;IC0XC,wCAAyC;IACzC,sCAAuC;ED3XrB;EAAnB;ICsXC,wCAAyC;IACzC,sCAAuC;EDvXrB;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;ICiXsB,sCAAuC;EDjX1C;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;ICoXyB,wCAAyC;EDpX/C;EAAnB;ICmXyB,wCAAyC;EDnX/C;EAAnB;ICkXyB,wCAAyC;EDlX/C;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gEAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;ICoUC,+CAAgD;IAChD,2CAA4C;IAC5C,gDAAiD;IACjD,+CAAgD;EDvU9B;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IC2UC,gCAAiC;IACjC,qCAAsC;IACtC,oCAAqC;IACrC,0BAA2B;ED9UT;EAAnB;ICkTC,kCAAmC;IACnC,uCAAwC;IACxC,sCAAuC;EDpTrB;EAAnB;ICwTC,yCAA0C;IAC1C,8CAA+C;IAC/C,6CAA8C;ED1T5B;EAAnB;IC8TC,kCAAmC;IACnC,uCAAwC;IACxC,sCAAuC;EDhUrB;EAAnB;ICsVC,wCAAyC;IACzC,6CAA8C;IAC9C,4CAA6C;EDxV3B;EAAnB;IC4VC,mCAAoC;IACpC,wCAAyC;IACzC,uCAAwC;ED9VtB;EAAnB;ICkWC,qCAAsC;IACtC,0CAA2C;IAC3C,yCAA0C;EDpWxB;EAAnB;IC0RC,8BAA+B;IAC/B,mCAAoC;IACpC,kCAAmC;ED5RjB;EAAnB;ICgSC,8BAA+B;IAC/B,mCAAoC;IACpC,kCAAmC;EDlSjB;EAAnB;IC8QC,mCAAoC;IACpC,wCAAyC;IACzC,uCAAwC;EDhRtB;EAAnB;ICsSC,oCAAqC;IACrC,yCAA0C;IAC1C,wCAAyC;EDxSvB;EAAnB;ICoRC,sCAAuC;IACvC,2CAA4C;IAC5C,0CAA2C;EDtRzB;EAAnB;IC4SC,2CAA4C;IAC5C,gDAAiD;IACjD,+CAAgD;ED9S9B;EAAnB;ICkQC,mCAAoC;IACpC,wCAAyC;IACzC,uCAAwC;EDpQtB;EAAnB;ICwQC,mCAAoC;IACpC,wCAAyC;IACzC,uCAAwC;ED1QtB;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,2BAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,kDAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;ICgdC,qCAAsC;EDhdpB;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,4FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yFAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yFAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sFAAmB;EAAA;EAAnB;IAAA;MAAA,+IAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;ICoaC,gFAAiF;IACjF,wCAAyC;EDravB;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,mGAAmB;IAAnB,4CAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,4FAAmB;IAAnB,oDAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA;MAAA,kHAAmB;IAAA;EAAA;EDAnB;ICAA;GDAA;ECAA;IAAA,uBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,qVAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,2BAAmB;EAAA;EAAnB;ICyZyB,yCAA0C;EDzZhD;EAAnB;ICwZyB,yCAA0C;EDxZhD;EAAnB;ICuZ4B,4CAA6C;EDvZtD;EAAnB;IC0ZyB,yCAA0C;ED1ZhD;EAAnB;IC2Z2B,2CAA4C;ED3ZpD;EAAnB;IAAA,eAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kDAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kDAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kDAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8EAAmB;EAAA;EAAnB;IAAA,sEAAmB;EAAA;EAAnB;IAAA,4EAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yEAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;ICsgBC,uCAA2C;EDtgBzB;EAAnB;ICsgBC,uCAA2C;EDtgBzB;EAAnB;ICsgBC,uCAA2C;EDtgBzB;EAAnB;IC4gBC,yCAA4C;ED5gB1B;EAAnB;ICshBC,oBAAqB;EDthBH;EAAnB;IC0hBC,oBAAoC;ED1hBlB;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;ICuPQ,qBAAsB;EDvPX;ECwPX;IAAA,gBAA8C;EAAA;EAAC;IAAA,gBAA8C;EAAA;EDxPrG;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB,kDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA;MAAA,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,UAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,WAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,6CAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,gFAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,yDAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,0BAAmB;ICyYC,wBAAyB;EDzY1B;EAAnB;IAAA,0BAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,gBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,kBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;ICoaC,gFAAiF;IACjF,wCAAyC;EDravB;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sEAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MCsjBC,gDAAoD;MAEpD,iDAAqD;IDxjBnC;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,OAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MC0nBC,gBAAiB;ID1nBC;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MC4WwB,8BAA+B;ID5WpC;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,OAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,UAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MCmiBC,uCAA2C;IDniBzB;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;MAAnB,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yDAAmB;MAAnB,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;ICmXyB,wCAAyC;EDnX/C;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,iEAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,6DAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yFAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yFAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;ACckC;AENrD;EACC,gCAAgC;AADnB;AAId;EACC,6BAA6B;AADnB;AAIX;EACC,kCAAkC;AADnB;AAIhB;EACC,mCAAmC;EACnC,wCAAwC;EACxC,uCAAuC;AAH1B;AAMd;EACC,mCAAmC;EACnC,wCAAwC;EACxC,uCAAuC;AAH1B;AAMd;EACC,mCAAmC;EACnC,wCAAwC;EACxC,uCAAuC;AAH1B;AAMd;EACC,sCAAsC;EACtC,2CAA2C;EAC3C,0CAA0C;AAH1B;AAMjB;EACC,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;AAH1B;AAMT;EACC,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;AAH1B;AAMT;EACC,oCAAoC;EACpC,yCAAyC;EACzC,wCAAwC;AAH1B;AAMf;EACC,2CAA2C;EAC3C,gDAAgD;EAChD,+CAA+C;AAH1B;AAMtB;EACC,kCAAkC;EAClC,uCAAuC;EACvC,sCAAsC;AAH1B;AAMb;EACC,yCAAyC;EACzC,8CAA8C;EAC9C,6CAA6C;AAH1B;AAMpB;EACC,kCAAkC;EAClC,uCAAuC;EACvC,sCAAsC;AAH1B;AAMb;EACC,+CAA+C;EAC/C,2CAA2C;EAC3C,gDAAgD;EAChD,+CAA+C;AAJ1B;AAOtB;EACC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,0BAA0B;AAJhB;AAOX;EACC,wCAAwC;EACxC,6CAA6C;EAC7C,4CAA4C;AAHhC;AAMb;EACC,mCAAmC;EACnC,wCAAwC;EACxC,uCAAuC;AAH1B;AAMd;EACC,qCAAqC;EACrC,0CAA0C;EAC1C,yCAAyC;AAH1B;AHhHhB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB,eAAmB;AAAA;AE0YjB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;ADxWlB;EACC;;IAEC,uBAAwB;IACxB,wBAAyB;EACzB;EACD;IACC,0BAA2B;IAC3B,wBAAyB;EACzB;AACD;AD1DF;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;MAAnB,gBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@tailwind utilities;\n","/**\n * Tailwind CSS entry file\n */\n/**\n * @import \"tailwindcss\" prefix(tw);\n */\n/**\n * Preflight disabled since having it enabled\n * creates visual changes on some parts of the\n * creator, needs to be checked in the future:\n * @see https://tailwindcss.com/docs/preflight#disabling-preflight\n */\n@layer theme, base, components, utilities;\n@import \"tailwindcss/theme.css\" layer(theme);\n@import \"tailwindcss/utilities.css\" layer(utilities);\n@import \"@sosocio/design-system/css/typography.css\";\n\n@config \"../../tailwind.config.js\";\n\n/**\n * Custom variants for different labels, e.g.:\n * <div class=\"font-(--font-weight-demi-bold) hema:font-(--font-weight-bold)\">\n *   Text\n * </div>\n *\n * The descendant `*` is required because data-label is set on <html> while\n * variant utilities usually live on elements below it.\n */\n@custom-variant agfa (&:where([data-label=\"agfa\"] *));\n@custom-variant brandon (&:where([data-label=\"brandon\"] *));\n@custom-variant fasteditor (&:where([data-label=\"fasteditor\"] *));\n@custom-variant helloprint (&:where([data-label=\"helloprint\"] *));\n@custom-variant hema (&:where([data-label=\"hema\"] *));\n@custom-variant safsira (&:where([data-label=\"safsira\"] *));\n@custom-variant yoursurprise (&:where([data-label=\"yoursurprise\"] *));\n\n/*\n * Dark theme variant — driven by a `data-theme=\"dark\"` attribute on :root\n * (or any ancestor). Selector matches both the attributed element itself\n * and its descendants so utility classes work anywhere in the subtree.\n *\n * Toggle via `setTheme()` in src/js/utils/theme.ts.\n */\n@custom-variant dark (&:where([data-theme=\"dark\"], [data-theme=\"dark\"] *));\n\n@theme {\n\t--radius-*: initial;\n\n\t@keyframes wiggle {\n\t\t0%,\n\t\t100% {\n\t\t\ttransform: rotate(1deg);\n\t\t\ttransform-origin: 30% 5%;\n\t\t}\n\t\t50% {\n\t\t\ttransform: rotate(-1.5deg);\n\t\t\ttransform-origin: 30% 5%;\n\t\t}\n\t}\n}\n\n/*\n * Semantic typography tokens — uses `inline` so var() references resolve via\n * CSS cascade at runtime, picking up brand overrides on :root[data-label].\n * twMerge is configured for these keys in packages/ui/src/cn.ts.\n */\n@theme inline {\n\t--font-size-heading-1: var(--text-heading-1);\n\t--font-size-heading-2: var(--text-heading-2);\n\t--font-size-heading-3: var(--text-heading-3);\n\t--font-size-body: var(--text-body);\n\t--font-size-body-sm: var(--text-body-sm);\n\t--font-size-caption: var(--text-caption);\n\t--font-size-overline: var(--text-overline);\n\n\t--font-family-heading: var(--font-heading);\n\t--font-family-body: var(--font-body);\n\t--font-family-body-demi: var(--font-body-demi);\n\n\t--font-weight-regular: var(--weight-regular);\n\t--font-weight-medium: var(--weight-medium);\n\t--font-weight-demi: var(--weight-demi);\n\t--font-weight-bold: var(--weight-bold);\n\n\t--line-height-heading: var(--leading-heading);\n\t--line-height-body: var(--leading-body);\n\n\t--letter-spacing-heading: var(--tracking-heading);\n\t--letter-spacing-body: var(--tracking-body);\n\n\t/*\n\t * Finalized Figma Semantic Themes contract. CSS names preserve the complete\n\t * slash-delimited Figma path, for example:\n\t * `background/brand/primary-hover`\n\t *   -> `--color-background-brand-primary-hover`.\n\t *\n\t * Private primitives (--primitive-color-*) are intentionally not exposed\n\t * as utilities.\n\t */\n\t--color-background-brand-accent-fill-1: var(--color-background-brand-accent-fill-1);\n\t--color-background-brand-accent-fill-2: var(--color-background-brand-accent-fill-2);\n\t--color-background-brand-accent-fill-3: var(--color-background-brand-accent-fill-3);\n\t--color-background-brand-primary: var(--color-background-brand-primary);\n\t--color-background-brand-primary-hover: var(--color-background-brand-primary-hover);\n\t--color-background-brand-primary-focus: var(--color-background-brand-primary-focus);\n\t--color-background-brand-primary-pressed: var(--color-background-brand-primary-pressed);\n\t--color-background-brand-secondary: var(--color-background-brand-secondary);\n\t--color-background-brand-secondary-hover: var(--color-background-brand-secondary-hover);\n\t--color-background-brand-secondary-focus: var(--color-background-brand-secondary-focus);\n\t--color-background-brand-secondary-pressed: var(--color-background-brand-secondary-pressed);\n\t--color-background-canvas-canvas-primary: var(--color-background-canvas-canvas-primary);\n\t--color-background-canvas-canvas-secondary: var(--color-background-canvas-canvas-secondary);\n\t--color-background-feedback-danger-1: var(--color-background-feedback-danger-1);\n\t--color-background-feedback-danger-2: var(--color-background-feedback-danger-2);\n\t--color-background-feedback-info-1: var(--color-background-feedback-info-1);\n\t--color-background-feedback-info-2: var(--color-background-feedback-info-2);\n\t--color-background-feedback-promotion-1: var(--color-background-feedback-promotion-1);\n\t--color-background-feedback-promotion-2: var(--color-background-feedback-promotion-2);\n\t--color-background-feedback-success-1: var(--color-background-feedback-success-1);\n\t--color-background-feedback-success-2: var(--color-background-feedback-success-2);\n\t--color-background-feedback-warning-1: var(--color-background-feedback-warning-1);\n\t--color-background-feedback-warning-2: var(--color-background-feedback-warning-2);\n\t--color-background-surface-disabled: var(--color-background-surface-disabled);\n\t--color-background-surface-fill-1: var(--color-background-surface-fill-1);\n\t--color-background-surface-fill-2: var(--color-background-surface-fill-2);\n\t--color-background-surface-fill-3: var(--color-background-surface-fill-3);\n\t--color-background-surface-fill-4: var(--color-background-surface-fill-4);\n\t--color-background-surface-fill-5: var(--color-background-surface-fill-5);\n\t--color-background-surface-overlay: var(--color-background-surface-overlay);\n\n\t--color-border-brand-primary: var(--color-border-brand-primary);\n\t--color-border-brand-primary-hover: var(--color-border-brand-primary-hover);\n\t--color-border-brand-primary-focus: var(--color-border-brand-primary-focus);\n\t--color-border-brand-primary-pressed: var(--color-border-brand-primary-pressed);\n\t--color-border-neutral-border-1: var(--color-border-neutral-border-1);\n\t--color-border-neutral-border-2: var(--color-border-neutral-border-2);\n\t--color-border-neutral-border-3: var(--color-border-neutral-border-3);\n\t--color-border-neutral-border-4: var(--color-border-neutral-border-4);\n\t--color-border-neutral-border-5: var(--color-border-neutral-border-5);\n\t--color-border-neutral-disabled: var(--color-border-neutral-disabled);\n\t--color-border-utility-alignment-guide: var(--color-border-utility-alignment-guide);\n\n\t--color-icon-brand-primary: var(--color-icon-brand-primary);\n\t--color-icon-brand-primary-hover: var(--color-icon-brand-primary-hover);\n\t--color-icon-brand-primary-focus: var(--color-icon-brand-primary-focus);\n\t--color-icon-brand-primary-pressed: var(--color-icon-brand-primary-pressed);\n\t--color-icon-brand-secondary: var(--color-icon-brand-secondary);\n\t--color-icon-default-disabled: var(--color-icon-default-disabled);\n\t--color-icon-default-primary: var(--color-icon-default-primary);\n\t--color-icon-default-secondary: var(--color-icon-default-secondary);\n\t--color-icon-default-tertiary: var(--color-icon-default-tertiary);\n\t--color-icon-feedback-danger: var(--color-icon-feedback-danger);\n\t--color-icon-feedback-info: var(--color-icon-feedback-info);\n\t--color-icon-feedback-success: var(--color-icon-feedback-success);\n\t--color-icon-feedback-warning: var(--color-icon-feedback-warning);\n\n\t--color-text-brand-primary: var(--color-text-brand-primary);\n\t--color-text-brand-primary-hover: var(--color-text-brand-primary-hover);\n\t--color-text-brand-primary-focus: var(--color-text-brand-primary-focus);\n\t--color-text-brand-primary-pressed: var(--color-text-brand-primary-pressed);\n\t--color-text-brand-secondary: var(--color-text-brand-secondary);\n\t--color-text-default-disabled: var(--color-text-default-disabled);\n\t--color-text-default-primary: var(--color-text-default-primary);\n\t--color-text-default-secondary: var(--color-text-default-secondary);\n\t--color-text-default-tertiary: var(--color-text-default-tertiary);\n\t--color-text-feedback-danger: var(--color-text-feedback-danger);\n\t--color-text-feedback-info: var(--color-text-feedback-info);\n\t--color-text-feedback-success: var(--color-text-feedback-success);\n\t--color-text-feedback-warning: var(--color-text-feedback-warning);\n\n\t--color-utilities-elevation-drop-shadow-lg: var(--color-utilities-elevation-drop-shadow-lg);\n\t--color-utilities-elevation-drop-shadow-md: var(--color-utilities-elevation-drop-shadow-md);\n\t--color-utilities-elevation-drop-shadow-sm: var(--color-utilities-elevation-drop-shadow-sm);\n\t--color-utilities-elevation-drop-shadow-xs: var(--color-utilities-elevation-drop-shadow-xs);\n\t--color-utilities-elevation-inner-shadow: var(--color-utilities-elevation-inner-shadow);\n\t--color-utilities-material-fills-overlay: var(--color-utilities-material-fills-overlay);\n\n\t/*\n\t * Semantic space/size tokens. General spacing remains available through\n\t * CSS variables; control utilities below expose the button/input sizing\n\t * contract needed by components.\n\t */\n\t--spacing-space-none: var(--space-none);\n\t--spacing-space-3xs: var(--space-3xs);\n\t--spacing-space-2xs: var(--space-2xs);\n\t--spacing-space-xs: var(--space-xs);\n\t--spacing-space-2sm: var(--space-2sm);\n\t--spacing-space-sm: var(--space-sm);\n\t--spacing-space-2md: var(--space-2md);\n\t--spacing-space-md: var(--space-md);\n\t--spacing-space-lg: var(--space-lg);\n\t--spacing-space-xl: var(--space-xl);\n\t--spacing-space-2xl: var(--space-2xl);\n\n\t/*\n\t * Semantic radius → generates `rounded-control`, `rounded-surface`,\n\t * `rounded-overlay`. Tailwind's built-in `rounded-full` stays on its\n\t * max-radius implementation so existing circular badges keep matching\n\t * pre-migration computed styles. The functional `@utility rounded-*` below\n\t * still handles numeric `rounded-1`/`rounded-2` for legacy integer usage.\n\t */\n\t--radius-control: var(--radius-control);\n\t--radius-surface: var(--radius-surface);\n\t--radius-overlay: var(--radius-overlay);\n\n\t/*\n\t * Semantic elevation → `shadow-raised`, `shadow-floating`,\n\t * `shadow-overlay`, `shadow-inverse`. Single global set (Figma elevation\n\t * variables 1–4); `inverse` is the variant for elements on dark surfaces.\n\t */\n\t--shadow-raised: var(--shadow-raised);\n\t--shadow-floating: var(--shadow-floating);\n\t--shadow-overlay: var(--shadow-overlay);\n\t--shadow-inverse: var(--shadow-inverse);\n\n\t--inset-shadow-raised: inset var(--shadow-raised);\n\t--inset-shadow-floating: inset var(--shadow-floating);\n\t--inset-shadow-overlay: inset var(--shadow-overlay);\n\t--inset-shadow-inverse: inset var(--shadow-inverse);\n\n\t/*\n\t * Semantic easings → `ease-standard`, `ease-emphasized`, `ease-decelerate`,\n\t * `ease-accelerate`, `ease-linear`. Durations and z-index ship as\n\t * explicit @utility blocks below (Tailwind v4 doesn't auto-generate\n\t * those namespaces from @theme).\n\t */\n\t--ease-standard: var(--ease-standard);\n\t--ease-emphasized: var(--ease-emphasized);\n\t--ease-decelerate: var(--ease-decelerate);\n\t--ease-accelerate: var(--ease-accelerate);\n\t--ease-linear: var(--ease-linear);\n}\n\n/**\n * Keep these aligned with the legacy `@mobileNotSmall`/`@mobileSmall`\n * breakpoint until existing `max-sm-*` callers are migrated.\n */\n@custom-variant max-sm-tall (@media (width <= 767px) and (min-height: 701px));\n@custom-variant max-sm-small (@media (width <= 767px) and (max-height: 700px));\n\n/*\n * Role-prefixed color tokens like --color-text-default-primary would normally emit\n * Tailwind's literal `.text-text-default`. These aliases preserve the design\n * system API documented as `.text-default` / `.border-default` while keeping\n * token names explicit.\n */\n@utility appearance-textfield {\n\t@apply [appearance:textfield];\n\t@apply [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none;\n}\n\n/*\n * Typography recipes — one utility per Figma brand style, bundling\n * font-size + line-height + font-weight. Backed by --type-*-* tokens\n * in each brand's semantic.css. Applied as `type-title-1`, `type-body-2`,\n * `type-button`, etc. Mix with `font-heading`/`font-body` to choose family.\n */\n@utility type-title-1 {\n\tfont-size: var(--type-title-1-size);\n\tline-height: var(--type-title-1-leading);\n\tfont-weight: var(--type-title-1-weight);\n}\n\n@utility type-title-2 {\n\tfont-size: var(--type-title-2-size);\n\tline-height: var(--type-title-2-leading);\n\tfont-weight: var(--type-title-2-weight);\n}\n\n@utility type-heading {\n\tfont-size: var(--type-heading-size);\n\tline-height: var(--type-heading-leading);\n\tfont-weight: var(--type-heading-weight);\n}\n\n@utility type-subtitle-1 {\n\tfont-size: var(--type-subtitle-1-size);\n\tline-height: var(--type-subtitle-1-leading);\n\tfont-weight: var(--type-subtitle-1-weight);\n}\n\n@utility type-h5 {\n\tfont-size: var(--type-h5-size);\n\tline-height: var(--type-h5-leading);\n\tfont-weight: var(--type-h5-weight);\n}\n\n@utility type-h6 {\n\tfont-size: var(--type-h6-size);\n\tline-height: var(--type-h6-leading);\n\tfont-weight: var(--type-h6-weight);\n}\n\n@utility type-subtitle {\n\tfont-size: var(--type-subtitle-size);\n\tline-height: var(--type-subtitle-leading);\n\tfont-weight: var(--type-subtitle-weight);\n}\n\n@utility type-subtitle-strong {\n\tfont-size: var(--type-subtitle-strong-size);\n\tline-height: var(--type-subtitle-strong-leading);\n\tfont-weight: var(--type-subtitle-strong-weight);\n}\n\n@utility type-body-1 {\n\tfont-size: var(--type-body-1-size);\n\tline-height: var(--type-body-1-leading);\n\tfont-weight: var(--type-body-1-weight);\n}\n\n@utility type-body-1-strong {\n\tfont-size: var(--type-body-1-strong-size);\n\tline-height: var(--type-body-1-strong-leading);\n\tfont-weight: var(--type-body-1-strong-weight);\n}\n\n@utility type-body-2 {\n\tfont-size: var(--type-body-2-size);\n\tline-height: var(--type-body-2-leading);\n\tfont-weight: var(--type-body-2-weight);\n}\n\n@utility type-body-2-emphasis {\n\tfont-family: var(--type-body-2-emphasis-family);\n\tfont-size: var(--type-body-2-emphasis-size);\n\tline-height: var(--type-body-2-emphasis-leading);\n\tfont-weight: var(--type-body-2-emphasis-weight);\n}\n\n@utility type-link {\n\tfont-size: var(--type-link-size);\n\tline-height: var(--type-link-leading);\n\tfont-weight: var(--type-link-weight);\n\ttext-decoration: underline;\n}\n\n/*\n * The button text style is the finalized Figma Button label role. It reads\n * those tokens directly so there is one source of truth per brand.\n */\n@utility type-button {\n\tfont-size: var(--type-button-label-size);\n\tline-height: var(--type-button-label-leading);\n\tfont-weight: var(--type-button-label-weight);\n}\n\n@utility type-caption {\n\tfont-size: var(--type-caption-size);\n\tline-height: var(--type-caption-leading);\n\tfont-weight: var(--type-caption-weight);\n}\n\n@utility type-caption-2 {\n\tfont-size: var(--type-caption-2-size);\n\tline-height: var(--type-caption-2-leading);\n\tfont-weight: var(--type-caption-2-weight);\n}\n\n/*\n * Control size/spacing — button/input-like primitives. These pair with the\n * Figma button heights while remaining root-font scalable.\n */\n@utility h-control-sm { height: var(--size-control-sm); }\n@utility h-control-md { height: var(--size-control-md); }\n@utility h-control-lg { height: var(--size-control-lg); }\n@utility min-h-control-sm { min-height: var(--size-control-sm); }\n@utility min-h-control-md { min-height: var(--size-control-md); }\n@utility min-h-control-lg { min-height: var(--size-control-lg); }\n@utility px-control { padding-inline: var(--space-control-x); }\n@utility py-control-sm { padding-block: var(--space-control-y-sm); }\n@utility py-control-md { padding-block: var(--space-control-y-md); }\n@utility py-control-lg { padding-block: var(--space-control-y-lg); }\n@utility p-control-sm {\n\tpadding-block: var(--space-control-y-sm);\n\tpadding-inline: var(--space-control-x);\n}\n@utility p-control-md {\n\tpadding-block: var(--space-control-y-md);\n\tpadding-inline: var(--space-control-x);\n}\n@utility p-control-lg {\n\tpadding-block: var(--space-control-y-lg);\n\tpadding-inline: var(--space-control-x);\n}\n@utility gap-control { gap: var(--space-control-gap); }\n\n/*\n * Semantic z-index — one utility per layer. Source of truth:\n * foundations.css. Never hardcode integers in component CSS; extend the\n * scale in foundations.css and add a matching @utility here.\n */\n@utility z-base { z-index: var(--z-base); }\n@utility z-raised { z-index: var(--z-raised); }\n@utility z-sticky { z-index: var(--z-sticky); }\n@utility z-dropdown { z-index: var(--z-dropdown); }\n@utility z-overlay { z-index: var(--z-overlay); }\n@utility z-modal-backdrop { z-index: var(--z-modal-backdrop); }\n@utility z-modal { z-index: var(--z-modal); }\n@utility z-popover { z-index: var(--z-popover); }\n@utility z-toast { z-index: var(--z-toast); }\n@utility z-tooltip { z-index: var(--z-tooltip); }\n\n/*\n * Semantic duration — transition-duration utilities. Paces named by\n * perceptual feel; picks up reduced-motion overrides from foundations.css.\n */\n@utility duration-instant { transition-duration: var(--duration-instant); }\n@utility duration-fast { transition-duration: var(--duration-fast); }\n@utility duration-base { transition-duration: var(--duration-base); }\n@utility duration-slow { transition-duration: var(--duration-slow); }\n@utility duration-slower { transition-duration: var(--duration-slower); }\n\n/*\n * Focus ring — one utility bundles color + width + offset + style, same\n * way type-* bundles font-size + leading + weight. Intended as\n * `focus-visible:focus-ring` so keyboard focus is visible without\n * punishing mouse users.\n */\n@utility focus-ring {\n\toutline: var(--focus-ring-width) var(--focus-ring-style) var(--focus-ring-color);\n\toutline-offset: var(--focus-ring-offset);\n}\n\n/*\n * Icon size — sets width + height + min-width + min-height in one shot so\n * SVG icons keep their square footprint inside flex containers (where\n * `width` alone would let them collapse). Five steps mirror the radius\n * naming convention.\n */\n@utility icon-size-* {\n\twidth: --value(--icon-size-*);\n\theight: --value(--icon-size-*);\n\tmin-width: --value(--icon-size-*);\n\tmin-height: --value(--icon-size-*);\n}\n\n/*\n * Icon hit area and label spacing — Material icons remain visually sized by\n * icon-size-* while the clickable container keeps the Figma minimum target.\n */\n@utility icon-hit-area-min {\n\tmin-width: var(--icon-hit-area-min);\n\tmin-height: var(--icon-hit-area-min);\n}\n@utility icon-hit-area-recommended {\n\tmin-width: var(--icon-hit-area-recommended);\n\tmin-height: var(--icon-hit-area-recommended);\n}\n@utility icon-text-gap {\n\tgap: var(--icon-text-gap);\n}\n@utility icon-text-gap-lg {\n\tgap: var(--icon-text-gap-lg);\n}\n\n/*\n * Brand text-transform — Tailwind v4 has no text-transform theme namespace\n * (so `--text-transform-brand` in @theme would be parsed as a font-size key).\n * A dedicated @utility block is the only way to expose `text-transform-brand`\n * that actually sets CSS `text-transform`, picking up per-brand overrides via\n * the `--text-transform` cascade (e.g. HEMA's `lowercase`).\n */\n@utility text-transform-brand {\n\ttext-transform: var(--text-transform);\n}\n\n/*\n * Figma border-radius directional variants. The node shows 24px end/start,\n * top, and bottom rounding; keep these backed by --radius-overlay rather\n * than asking component code to reach for numeric rounded-6 values.\n */\n@utility rounded-s-overlay {\n\tborder-start-start-radius: var(--radius-overlay);\n\tborder-end-start-radius: var(--radius-overlay);\n}\n\n@utility rounded-e-overlay {\n\tborder-start-end-radius: var(--radius-overlay);\n\tborder-end-end-radius: var(--radius-overlay);\n}\n\n@utility rounded-t-overlay {\n\tborder-top-left-radius: var(--radius-overlay);\n\tborder-top-right-radius: var(--radius-overlay);\n}\n\n@utility rounded-b-overlay {\n\tborder-bottom-right-radius: var(--radius-overlay);\n\tborder-bottom-left-radius: var(--radius-overlay);\n}\n\n@utility animate-wiggle {\n\t--tw-animation-delay: 0s;\n\tanimation: 0.3s ease-in-out var(--tw-animation-delay) wiggle infinite;\n}\n\n@utility divider-horizontal {\n\tborder-color: var(--divider-color, var(--neutral2-separator-and-divider));\n\tborder-style: solid;\n\tborder-width: 0;\n\tborder-top-width: var(--divider-width, 1px);\n\theight: 0;\n\tmargin: var(--divider-gap, --spacing(2)) 0;\n\twidth: var(--divider-size, --spacing(5));\n}\n\n@utility divider-vertical {\n\tborder-color: var(--divider-color, var(--neutral2-separator-and-divider));\n\tborder-style: solid;\n\tborder-width: 0;\n\tborder-left-width: var(--divider-width, 1px);\n\theight: var(--divider-size, --spacing(5));\n\tmargin: 0 var(--divider-gap, --spacing(2));\n\twidth: 0;\n}\n\n@utility divider-gap-* {\n\t--divider-gap: --spacing(--value(integer));\n\t--divider-gap: calc(--value(ratio) * 100%);\n\t--divider-gap: --value([length]);\n}\n\n@utility divider-size-* {\n\t--divider-size: --spacing(--value(integer));\n\t--divider-size: calc(--value(ratio) * 100%);\n\t--divider-size: --value([length]);\n}\n\n@utility divider-size-auto {\n\t--divider-size: auto;\n}\n\n@utility divider-size-full {\n\t--divider-size: 100%;\n}\n\n@utility divider-width-* {\n\t--divider-width: --value(integer)px;\n\t--divider-width: calc(--value(ratio) * 100%);\n\t--divider-width: --value([length]);\n}\n\n/**\n * rounded-1, rounded-2, rounded-12, rounded-1/2, rounded-, ...\n */\n@utility rounded-* {\n\tborder-radius: --spacing(--value(integer));\n\tborder-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-s-* {\n\tborder-start-start-radius: --spacing(--value(integer));\n\tborder-start-start-radius: calc(--value(ratio) * 100%);\n\tborder-end-start-radius: --spacing(--value(integer));\n\tborder-end-start-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-e-* {\n\tborder-start-end-radius: --spacing(--value(integer));\n\tborder-start-end-radius: calc(--value(ratio) * 100%);\n\tborder-end-end-radius: --spacing(--value(integer));\n\tborder-end-end-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-t-* {\n\tborder-top-left-radius: --spacing(--value(integer));\n\tborder-top-left-radius: calc(--value(ratio) * 100%);\n\tborder-top-right-radius: --spacing(--value(integer));\n\tborder-top-right-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-r-* {\n\tborder-top-right-radius: --spacing(--value(integer));\n\tborder-top-right-radius: calc(--value(ratio) * 100%);\n\tborder-bottom-right-radius: --spacing(--value(integer));\n\tborder-bottom-right-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-b-* {\n\tborder-bottom-right-radius: --spacing(--value(integer));\n\tborder-bottom-right-radius: calc(--value(ratio) * 100%);\n\tborder-bottom-left-radius: --spacing(--value(integer));\n\tborder-bottom-left-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-l-* {\n\tborder-top-left-radius: --spacing(--value(integer));\n\tborder-top-left-radius: calc(--value(ratio) * 100%);\n\tborder-bottom-left-radius: --spacing(--value(integer));\n\tborder-bottom-left-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-ss-* {\n\tborder-start-start-radius: --spacing(--value(integer));\n\tborder-start-start-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-se-* {\n\tborder-start-end-radius: --spacing(--value(integer));\n\tborder-start-end-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-ee-* {\n\tborder-end-end-radius: --spacing(--value(integer));\n\tborder-end-end-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-es-* {\n\tborder-end-start-radius: --spacing(--value(integer));\n\tborder-end-start-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-tl-* {\n\tborder-top-left-radius: --spacing(--value(integer));\n\tborder-top-left-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-tr-* {\n\tborder-top-right-radius: --spacing(--value(integer));\n\tborder-top-right-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-br-* {\n\tborder-bottom-right-radius: --spacing(--value(integer));\n\tborder-bottom-right-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-bl-* {\n\tborder-bottom-left-radius: --spacing(--value(integer));\n\tborder-bottom-left-radius: calc(--value(ratio) * 100%);\n}\n\n@utility rounded-none {\n\tborder-radius: 0;\n}\n","@theme default {\n  --font-sans:\n    ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n    'Noto Color Emoji';\n  --font-serif: ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif;\n  --font-mono:\n    ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',\n    monospace;\n\n  --color-red-50: oklch(97.1% 0.013 17.38);\n  --color-red-100: oklch(93.6% 0.032 17.717);\n  --color-red-200: oklch(88.5% 0.062 18.334);\n  --color-red-300: oklch(80.8% 0.114 19.571);\n  --color-red-400: oklch(70.4% 0.191 22.216);\n  --color-red-500: oklch(63.7% 0.237 25.331);\n  --color-red-600: oklch(57.7% 0.245 27.325);\n  --color-red-700: oklch(50.5% 0.213 27.518);\n  --color-red-800: oklch(44.4% 0.177 26.899);\n  --color-red-900: oklch(39.6% 0.141 25.723);\n  --color-red-950: oklch(25.8% 0.092 26.042);\n\n  --color-orange-50: oklch(98% 0.016 73.684);\n  --color-orange-100: oklch(95.4% 0.038 75.164);\n  --color-orange-200: oklch(90.1% 0.076 70.697);\n  --color-orange-300: oklch(83.7% 0.128 66.29);\n  --color-orange-400: oklch(75% 0.183 55.934);\n  --color-orange-500: oklch(70.5% 0.213 47.604);\n  --color-orange-600: oklch(64.6% 0.222 41.116);\n  --color-orange-700: oklch(55.3% 0.195 38.402);\n  --color-orange-800: oklch(47% 0.157 37.304);\n  --color-orange-900: oklch(40.8% 0.123 38.172);\n  --color-orange-950: oklch(26.6% 0.079 36.259);\n\n  --color-amber-50: oklch(98.7% 0.022 95.277);\n  --color-amber-100: oklch(96.2% 0.059 95.617);\n  --color-amber-200: oklch(92.4% 0.12 95.746);\n  --color-amber-300: oklch(87.9% 0.169 91.605);\n  --color-amber-400: oklch(82.8% 0.189 84.429);\n  --color-amber-500: oklch(76.9% 0.188 70.08);\n  --color-amber-600: oklch(66.6% 0.179 58.318);\n  --color-amber-700: oklch(55.5% 0.163 48.998);\n  --color-amber-800: oklch(47.3% 0.137 46.201);\n  --color-amber-900: oklch(41.4% 0.112 45.904);\n  --color-amber-950: oklch(27.9% 0.077 45.635);\n\n  --color-yellow-50: oklch(98.7% 0.026 102.212);\n  --color-yellow-100: oklch(97.3% 0.071 103.193);\n  --color-yellow-200: oklch(94.5% 0.129 101.54);\n  --color-yellow-300: oklch(90.5% 0.182 98.111);\n  --color-yellow-400: oklch(85.2% 0.199 91.936);\n  --color-yellow-500: oklch(79.5% 0.184 86.047);\n  --color-yellow-600: oklch(68.1% 0.162 75.834);\n  --color-yellow-700: oklch(55.4% 0.135 66.442);\n  --color-yellow-800: oklch(47.6% 0.114 61.907);\n  --color-yellow-900: oklch(42.1% 0.095 57.708);\n  --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n  --color-lime-50: oklch(98.6% 0.031 120.757);\n  --color-lime-100: oklch(96.7% 0.067 122.328);\n  --color-lime-200: oklch(93.8% 0.127 124.321);\n  --color-lime-300: oklch(89.7% 0.196 126.665);\n  --color-lime-400: oklch(84.1% 0.238 128.85);\n  --color-lime-500: oklch(76.8% 0.233 130.85);\n  --color-lime-600: oklch(64.8% 0.2 131.684);\n  --color-lime-700: oklch(53.2% 0.157 131.589);\n  --color-lime-800: oklch(45.3% 0.124 130.933);\n  --color-lime-900: oklch(40.5% 0.101 131.063);\n  --color-lime-950: oklch(27.4% 0.072 132.109);\n\n  --color-green-50: oklch(98.2% 0.018 155.826);\n  --color-green-100: oklch(96.2% 0.044 156.743);\n  --color-green-200: oklch(92.5% 0.084 155.995);\n  --color-green-300: oklch(87.1% 0.15 154.449);\n  --color-green-400: oklch(79.2% 0.209 151.711);\n  --color-green-500: oklch(72.3% 0.219 149.579);\n  --color-green-600: oklch(62.7% 0.194 149.214);\n  --color-green-700: oklch(52.7% 0.154 150.069);\n  --color-green-800: oklch(44.8% 0.119 151.328);\n  --color-green-900: oklch(39.3% 0.095 152.535);\n  --color-green-950: oklch(26.6% 0.065 152.934);\n\n  --color-emerald-50: oklch(97.9% 0.021 166.113);\n  --color-emerald-100: oklch(95% 0.052 163.051);\n  --color-emerald-200: oklch(90.5% 0.093 164.15);\n  --color-emerald-300: oklch(84.5% 0.143 164.978);\n  --color-emerald-400: oklch(76.5% 0.177 163.223);\n  --color-emerald-500: oklch(69.6% 0.17 162.48);\n  --color-emerald-600: oklch(59.6% 0.145 163.225);\n  --color-emerald-700: oklch(50.8% 0.118 165.612);\n  --color-emerald-800: oklch(43.2% 0.095 166.913);\n  --color-emerald-900: oklch(37.8% 0.077 168.94);\n  --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n  --color-teal-50: oklch(98.4% 0.014 180.72);\n  --color-teal-100: oklch(95.3% 0.051 180.801);\n  --color-teal-200: oklch(91% 0.096 180.426);\n  --color-teal-300: oklch(85.5% 0.138 181.071);\n  --color-teal-400: oklch(77.7% 0.152 181.912);\n  --color-teal-500: oklch(70.4% 0.14 182.503);\n  --color-teal-600: oklch(60% 0.118 184.704);\n  --color-teal-700: oklch(51.1% 0.096 186.391);\n  --color-teal-800: oklch(43.7% 0.078 188.216);\n  --color-teal-900: oklch(38.6% 0.063 188.416);\n  --color-teal-950: oklch(27.7% 0.046 192.524);\n\n  --color-cyan-50: oklch(98.4% 0.019 200.873);\n  --color-cyan-100: oklch(95.6% 0.045 203.388);\n  --color-cyan-200: oklch(91.7% 0.08 205.041);\n  --color-cyan-300: oklch(86.5% 0.127 207.078);\n  --color-cyan-400: oklch(78.9% 0.154 211.53);\n  --color-cyan-500: oklch(71.5% 0.143 215.221);\n  --color-cyan-600: oklch(60.9% 0.126 221.723);\n  --color-cyan-700: oklch(52% 0.105 223.128);\n  --color-cyan-800: oklch(45% 0.085 224.283);\n  --color-cyan-900: oklch(39.8% 0.07 227.392);\n  --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n  --color-sky-50: oklch(97.7% 0.013 236.62);\n  --color-sky-100: oklch(95.1% 0.026 236.824);\n  --color-sky-200: oklch(90.1% 0.058 230.902);\n  --color-sky-300: oklch(82.8% 0.111 230.318);\n  --color-sky-400: oklch(74.6% 0.16 232.661);\n  --color-sky-500: oklch(68.5% 0.169 237.323);\n  --color-sky-600: oklch(58.8% 0.158 241.966);\n  --color-sky-700: oklch(50% 0.134 242.749);\n  --color-sky-800: oklch(44.3% 0.11 240.79);\n  --color-sky-900: oklch(39.1% 0.09 240.876);\n  --color-sky-950: oklch(29.3% 0.066 243.157);\n\n  --color-blue-50: oklch(97% 0.014 254.604);\n  --color-blue-100: oklch(93.2% 0.032 255.585);\n  --color-blue-200: oklch(88.2% 0.059 254.128);\n  --color-blue-300: oklch(80.9% 0.105 251.813);\n  --color-blue-400: oklch(70.7% 0.165 254.624);\n  --color-blue-500: oklch(62.3% 0.214 259.815);\n  --color-blue-600: oklch(54.6% 0.245 262.881);\n  --color-blue-700: oklch(48.8% 0.243 264.376);\n  --color-blue-800: oklch(42.4% 0.199 265.638);\n  --color-blue-900: oklch(37.9% 0.146 265.522);\n  --color-blue-950: oklch(28.2% 0.091 267.935);\n\n  --color-indigo-50: oklch(96.2% 0.018 272.314);\n  --color-indigo-100: oklch(93% 0.034 272.788);\n  --color-indigo-200: oklch(87% 0.065 274.039);\n  --color-indigo-300: oklch(78.5% 0.115 274.713);\n  --color-indigo-400: oklch(67.3% 0.182 276.935);\n  --color-indigo-500: oklch(58.5% 0.233 277.117);\n  --color-indigo-600: oklch(51.1% 0.262 276.966);\n  --color-indigo-700: oklch(45.7% 0.24 277.023);\n  --color-indigo-800: oklch(39.8% 0.195 277.366);\n  --color-indigo-900: oklch(35.9% 0.144 278.697);\n  --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n  --color-violet-50: oklch(96.9% 0.016 293.756);\n  --color-violet-100: oklch(94.3% 0.029 294.588);\n  --color-violet-200: oklch(89.4% 0.057 293.283);\n  --color-violet-300: oklch(81.1% 0.111 293.571);\n  --color-violet-400: oklch(70.2% 0.183 293.541);\n  --color-violet-500: oklch(60.6% 0.25 292.717);\n  --color-violet-600: oklch(54.1% 0.281 293.009);\n  --color-violet-700: oklch(49.1% 0.27 292.581);\n  --color-violet-800: oklch(43.2% 0.232 292.759);\n  --color-violet-900: oklch(38% 0.189 293.745);\n  --color-violet-950: oklch(28.3% 0.141 291.089);\n\n  --color-purple-50: oklch(97.7% 0.014 308.299);\n  --color-purple-100: oklch(94.6% 0.033 307.174);\n  --color-purple-200: oklch(90.2% 0.063 306.703);\n  --color-purple-300: oklch(82.7% 0.119 306.383);\n  --color-purple-400: oklch(71.4% 0.203 305.504);\n  --color-purple-500: oklch(62.7% 0.265 303.9);\n  --color-purple-600: oklch(55.8% 0.288 302.321);\n  --color-purple-700: oklch(49.6% 0.265 301.924);\n  --color-purple-800: oklch(43.8% 0.218 303.724);\n  --color-purple-900: oklch(38.1% 0.176 304.987);\n  --color-purple-950: oklch(29.1% 0.149 302.717);\n\n  --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n  --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n  --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n  --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n  --color-fuchsia-400: oklch(74% 0.238 322.16);\n  --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n  --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n  --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n  --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n  --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n  --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n  --color-pink-50: oklch(97.1% 0.014 343.198);\n  --color-pink-100: oklch(94.8% 0.028 342.258);\n  --color-pink-200: oklch(89.9% 0.061 343.231);\n  --color-pink-300: oklch(82.3% 0.12 346.018);\n  --color-pink-400: oklch(71.8% 0.202 349.761);\n  --color-pink-500: oklch(65.6% 0.241 354.308);\n  --color-pink-600: oklch(59.2% 0.249 0.584);\n  --color-pink-700: oklch(52.5% 0.223 3.958);\n  --color-pink-800: oklch(45.9% 0.187 3.815);\n  --color-pink-900: oklch(40.8% 0.153 2.432);\n  --color-pink-950: oklch(28.4% 0.109 3.907);\n\n  --color-rose-50: oklch(96.9% 0.015 12.422);\n  --color-rose-100: oklch(94.1% 0.03 12.58);\n  --color-rose-200: oklch(89.2% 0.058 10.001);\n  --color-rose-300: oklch(81% 0.117 11.638);\n  --color-rose-400: oklch(71.2% 0.194 13.428);\n  --color-rose-500: oklch(64.5% 0.246 16.439);\n  --color-rose-600: oklch(58.6% 0.253 17.585);\n  --color-rose-700: oklch(51.4% 0.222 16.935);\n  --color-rose-800: oklch(45.5% 0.188 13.697);\n  --color-rose-900: oklch(41% 0.159 10.272);\n  --color-rose-950: oklch(27.1% 0.105 12.094);\n\n  --color-slate-50: oklch(98.4% 0.003 247.858);\n  --color-slate-100: oklch(96.8% 0.007 247.896);\n  --color-slate-200: oklch(92.9% 0.013 255.508);\n  --color-slate-300: oklch(86.9% 0.022 252.894);\n  --color-slate-400: oklch(70.4% 0.04 256.788);\n  --color-slate-500: oklch(55.4% 0.046 257.417);\n  --color-slate-600: oklch(44.6% 0.043 257.281);\n  --color-slate-700: oklch(37.2% 0.044 257.287);\n  --color-slate-800: oklch(27.9% 0.041 260.031);\n  --color-slate-900: oklch(20.8% 0.042 265.755);\n  --color-slate-950: oklch(12.9% 0.042 264.695);\n\n  --color-gray-50: oklch(98.5% 0.002 247.839);\n  --color-gray-100: oklch(96.7% 0.003 264.542);\n  --color-gray-200: oklch(92.8% 0.006 264.531);\n  --color-gray-300: oklch(87.2% 0.01 258.338);\n  --color-gray-400: oklch(70.7% 0.022 261.325);\n  --color-gray-500: oklch(55.1% 0.027 264.364);\n  --color-gray-600: oklch(44.6% 0.03 256.802);\n  --color-gray-700: oklch(37.3% 0.034 259.733);\n  --color-gray-800: oklch(27.8% 0.033 256.848);\n  --color-gray-900: oklch(21% 0.034 264.665);\n  --color-gray-950: oklch(13% 0.028 261.692);\n\n  --color-zinc-50: oklch(98.5% 0 0);\n  --color-zinc-100: oklch(96.7% 0.001 286.375);\n  --color-zinc-200: oklch(92% 0.004 286.32);\n  --color-zinc-300: oklch(87.1% 0.006 286.286);\n  --color-zinc-400: oklch(70.5% 0.015 286.067);\n  --color-zinc-500: oklch(55.2% 0.016 285.938);\n  --color-zinc-600: oklch(44.2% 0.017 285.786);\n  --color-zinc-700: oklch(37% 0.013 285.805);\n  --color-zinc-800: oklch(27.4% 0.006 286.033);\n  --color-zinc-900: oklch(21% 0.006 285.885);\n  --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n  --color-neutral-50: oklch(98.5% 0 0);\n  --color-neutral-100: oklch(97% 0 0);\n  --color-neutral-200: oklch(92.2% 0 0);\n  --color-neutral-300: oklch(87% 0 0);\n  --color-neutral-400: oklch(70.8% 0 0);\n  --color-neutral-500: oklch(55.6% 0 0);\n  --color-neutral-600: oklch(43.9% 0 0);\n  --color-neutral-700: oklch(37.1% 0 0);\n  --color-neutral-800: oklch(26.9% 0 0);\n  --color-neutral-900: oklch(20.5% 0 0);\n  --color-neutral-950: oklch(14.5% 0 0);\n\n  --color-stone-50: oklch(98.5% 0.001 106.423);\n  --color-stone-100: oklch(97% 0.001 106.424);\n  --color-stone-200: oklch(92.3% 0.003 48.717);\n  --color-stone-300: oklch(86.9% 0.005 56.366);\n  --color-stone-400: oklch(70.9% 0.01 56.259);\n  --color-stone-500: oklch(55.3% 0.013 58.071);\n  --color-stone-600: oklch(44.4% 0.011 73.639);\n  --color-stone-700: oklch(37.4% 0.01 67.558);\n  --color-stone-800: oklch(26.8% 0.007 34.298);\n  --color-stone-900: oklch(21.6% 0.006 56.043);\n  --color-stone-950: oklch(14.7% 0.004 49.25);\n\n  --color-black: #000;\n  --color-white: #fff;\n\n  --spacing: 0.25rem;\n\n  --breakpoint-sm: 40rem;\n  --breakpoint-md: 48rem;\n  --breakpoint-lg: 64rem;\n  --breakpoint-xl: 80rem;\n  --breakpoint-2xl: 96rem;\n\n  --container-3xs: 16rem;\n  --container-2xs: 18rem;\n  --container-xs: 20rem;\n  --container-sm: 24rem;\n  --container-md: 28rem;\n  --container-lg: 32rem;\n  --container-xl: 36rem;\n  --container-2xl: 42rem;\n  --container-3xl: 48rem;\n  --container-4xl: 56rem;\n  --container-5xl: 64rem;\n  --container-6xl: 72rem;\n  --container-7xl: 80rem;\n\n  --text-xs: 0.75rem;\n  --text-xs--line-height: calc(1 / 0.75);\n  --text-sm: 0.875rem;\n  --text-sm--line-height: calc(1.25 / 0.875);\n  --text-base: 1rem;\n  --text-base--line-height: calc(1.5 / 1);\n  --text-lg: 1.125rem;\n  --text-lg--line-height: calc(1.75 / 1.125);\n  --text-xl: 1.25rem;\n  --text-xl--line-height: calc(1.75 / 1.25);\n  --text-2xl: 1.5rem;\n  --text-2xl--line-height: calc(2 / 1.5);\n  --text-3xl: 1.875rem;\n  --text-3xl--line-height: calc(2.25 / 1.875);\n  --text-4xl: 2.25rem;\n  --text-4xl--line-height: calc(2.5 / 2.25);\n  --text-5xl: 3rem;\n  --text-5xl--line-height: 1;\n  --text-6xl: 3.75rem;\n  --text-6xl--line-height: 1;\n  --text-7xl: 4.5rem;\n  --text-7xl--line-height: 1;\n  --text-8xl: 6rem;\n  --text-8xl--line-height: 1;\n  --text-9xl: 8rem;\n  --text-9xl--line-height: 1;\n\n  --font-weight-thin: 100;\n  --font-weight-extralight: 200;\n  --font-weight-light: 300;\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n  --font-weight-black: 900;\n\n  --tracking-tighter: -0.05em;\n  --tracking-tight: -0.025em;\n  --tracking-normal: 0em;\n  --tracking-wide: 0.025em;\n  --tracking-wider: 0.05em;\n  --tracking-widest: 0.1em;\n\n  --leading-tight: 1.25;\n  --leading-snug: 1.375;\n  --leading-normal: 1.5;\n  --leading-relaxed: 1.625;\n  --leading-loose: 2;\n\n  --radius-xs: 0.125rem;\n  --radius-sm: 0.25rem;\n  --radius-md: 0.375rem;\n  --radius-lg: 0.5rem;\n  --radius-xl: 0.75rem;\n  --radius-2xl: 1rem;\n  --radius-3xl: 1.5rem;\n  --radius-4xl: 2rem;\n\n  --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n  --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n  --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n  --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n  --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n  --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n  --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n  --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n  --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n  --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n  --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n  --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n  --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n  --text-shadow-sm:\n    0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075), 0px 2px 2px rgb(0 0 0 / 0.075);\n  --text-shadow-md:\n    0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1), 0px 2px 4px rgb(0 0 0 / 0.1);\n  --text-shadow-lg:\n    0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1), 0px 4px 8px rgb(0 0 0 / 0.1);\n\n  --ease-in: cubic-bezier(0.4, 0, 1, 1);\n  --ease-out: cubic-bezier(0, 0, 0.2, 1);\n  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n  --animate-spin: spin 1s linear infinite;\n  --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  --animate-bounce: bounce 1s infinite;\n\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes ping {\n    75%,\n    100% {\n      transform: scale(2);\n      opacity: 0;\n    }\n  }\n\n  @keyframes pulse {\n    50% {\n      opacity: 0.5;\n    }\n  }\n\n  @keyframes bounce {\n    0%,\n    100% {\n      transform: translateY(-25%);\n      animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n    }\n\n    50% {\n      transform: none;\n      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n    }\n  }\n\n  --blur-xs: 4px;\n  --blur-sm: 8px;\n  --blur-md: 12px;\n  --blur-lg: 16px;\n  --blur-xl: 24px;\n  --blur-2xl: 40px;\n  --blur-3xl: 64px;\n\n  --perspective-dramatic: 100px;\n  --perspective-near: 300px;\n  --perspective-normal: 500px;\n  --perspective-midrange: 800px;\n  --perspective-distant: 1200px;\n\n  --aspect-video: 16 / 9;\n\n  --default-transition-duration: 150ms;\n  --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  --default-font-family: --theme(--font-sans, initial);\n  --default-font-feature-settings: --theme(--font-sans--font-feature-settings, initial);\n  --default-font-variation-settings: --theme(--font-sans--font-variation-settings, initial);\n  --default-mono-font-family: --theme(--font-mono, initial);\n  --default-mono-font-feature-settings: --theme(--font-mono--font-feature-settings, initial);\n  --default-mono-font-variation-settings: --theme(--font-mono--font-variation-settings, initial);\n}\n\n/* Deprecated */\n@theme default inline reference {\n  --blur: 8px;\n  --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n  --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n  --radius: 0.25rem;\n  --max-width-prose: 65ch;\n}\n","/*\n * Shared typography utility classes consumed by Creator applications.\n *\n * The recipe values are provided by each brand runtime through the semantic\n * --type-* and --font-* variables. Keeping these classes outside an app-level\n * Tailwind entry lets standalone applications reuse TypographyComponent\n * without importing the full Creator stylesheet.\n */\n.font-heading {\n\tfont-family: var(--font-heading);\n}\n\n.font-body {\n\tfont-family: var(--font-body);\n}\n\n.font-body-demi {\n\tfont-family: var(--font-body-demi);\n}\n\n.type-title-1 {\n\tfont-size: var(--type-title-1-size);\n\tline-height: var(--type-title-1-leading);\n\tfont-weight: var(--type-title-1-weight);\n}\n\n.type-title-2 {\n\tfont-size: var(--type-title-2-size);\n\tline-height: var(--type-title-2-leading);\n\tfont-weight: var(--type-title-2-weight);\n}\n\n.type-heading {\n\tfont-size: var(--type-heading-size);\n\tline-height: var(--type-heading-leading);\n\tfont-weight: var(--type-heading-weight);\n}\n\n.type-subtitle-1 {\n\tfont-size: var(--type-subtitle-1-size);\n\tline-height: var(--type-subtitle-1-leading);\n\tfont-weight: var(--type-subtitle-1-weight);\n}\n\n.type-h5 {\n\tfont-size: var(--type-h5-size);\n\tline-height: var(--type-h5-leading);\n\tfont-weight: var(--type-h5-weight);\n}\n\n.type-h6 {\n\tfont-size: var(--type-h6-size);\n\tline-height: var(--type-h6-leading);\n\tfont-weight: var(--type-h6-weight);\n}\n\n.type-subtitle {\n\tfont-size: var(--type-subtitle-size);\n\tline-height: var(--type-subtitle-leading);\n\tfont-weight: var(--type-subtitle-weight);\n}\n\n.type-subtitle-strong {\n\tfont-size: var(--type-subtitle-strong-size);\n\tline-height: var(--type-subtitle-strong-leading);\n\tfont-weight: var(--type-subtitle-strong-weight);\n}\n\n.type-body-1 {\n\tfont-size: var(--type-body-1-size);\n\tline-height: var(--type-body-1-leading);\n\tfont-weight: var(--type-body-1-weight);\n}\n\n.type-body-1-strong {\n\tfont-size: var(--type-body-1-strong-size);\n\tline-height: var(--type-body-1-strong-leading);\n\tfont-weight: var(--type-body-1-strong-weight);\n}\n\n.type-body-2 {\n\tfont-size: var(--type-body-2-size);\n\tline-height: var(--type-body-2-leading);\n\tfont-weight: var(--type-body-2-weight);\n}\n\n.type-body-2-emphasis {\n\tfont-family: var(--type-body-2-emphasis-family);\n\tfont-size: var(--type-body-2-emphasis-size);\n\tline-height: var(--type-body-2-emphasis-leading);\n\tfont-weight: var(--type-body-2-emphasis-weight);\n}\n\n.type-link {\n\tfont-size: var(--type-link-size);\n\tline-height: var(--type-link-leading);\n\tfont-weight: var(--type-link-weight);\n\ttext-decoration: underline;\n}\n\n.type-button {\n\tfont-size: var(--type-button-label-size);\n\tline-height: var(--type-button-label-leading);\n\tfont-weight: var(--type-button-label-weight);\n}\n\n.type-caption {\n\tfont-size: var(--type-caption-size);\n\tline-height: var(--type-caption-leading);\n\tfont-weight: var(--type-caption-weight);\n}\n\n.type-caption-2 {\n\tfont-size: var(--type-caption-2-size);\n\tline-height: var(--type-caption-2-leading);\n\tfont-weight: var(--type-caption-2-weight);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
